var Zn = (t, e, r) => {
  if (!e.has(t))
    throw TypeError("Cannot " + r);
};
var b = (t, e, r) => (Zn(t, e, "read from private field"), r ? r.call(t) : e.get(t)), L = (t, e, r) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, r);
}, I = (t, e, r, n) => (Zn(t, e, "write to private field"), n ? n.call(t, r) : e.set(t, r), r);
var gn = (t, e, r, n) => ({
  set _(s) {
    I(t, e, s, r);
  },
  get _() {
    return b(t, e, n);
  }
}), G = (t, e, r) => (Zn(t, e, "access private method"), r);
import * as Se from "react";
import Ae, { createContext as Ga, useContext as Ql, useState as te, useRef as Le, useEffect as We, useCallback as Yl, Children as Xl, memo as Gl } from "react";
import { Checkbox as Jl, ActionMenu as Zl, LanguageCodeEnum as ps, CloseIcon as Ri, Modal as kn, PrimaryButton as an, SecondaryButton as Ja, FieldErrorAndDescription as En, ActionMenuItem as In, InfoIcon as ec, BinIcon as tc, PenIcon as rc, DonwloadIcon as nc, FormInputSearch as sc, FormSelectMultiple as _i, Loader as ic, toast as Me, CloseCircleIcon as Pi, SmallPenIcon as ac, UploadIcon as oc, CheckBoxSwitcher as lc, useWindowSize as cc, FormInput as uc, ModalSizeEnum as hc } from "@systemeio/ui";
import { getTFuncWithNamespace as dc, getUseLocoTranslation as fc, setupBasicInterceptor as pc, getUseBaseFetch as mc, httpBaseClient as gc, RequestMethodsEnum as tr, BadRequest as yc } from "@systemeio/util";
import { flushSync as bc } from "react-dom";
var ms = { exports: {} }, Rr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ti;
function vc() {
  if (Ti)
    return Rr;
  Ti = 1;
  var t = Ae, e = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, s = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(o, l, u) {
    var c, h = {}, d = null, f = null;
    u !== void 0 && (d = "" + u), l.key !== void 0 && (d = "" + l.key), l.ref !== void 0 && (f = l.ref);
    for (c in l)
      n.call(l, c) && !i.hasOwnProperty(c) && (h[c] = l[c]);
    if (o && o.defaultProps)
      for (c in l = o.defaultProps, l)
        h[c] === void 0 && (h[c] = l[c]);
    return { $$typeof: e, type: o, key: d, ref: f, props: h, _owner: s.current };
  }
  return Rr.Fragment = r, Rr.jsx = a, Rr.jsxs = a, Rr;
}
var _r = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ni;
function wc() {
  return Ni || (Ni = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Ae, e = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), p = Symbol.iterator, y = "@@iterator";
    function m(g) {
      if (g === null || typeof g != "object")
        return null;
      var T = p && g[p] || g[y];
      return typeof T == "function" ? T : null;
    }
    var S = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(g) {
      {
        for (var T = arguments.length, D = new Array(T > 1 ? T - 1 : 0), B = 1; B < T; B++)
          D[B - 1] = arguments[B];
        C("error", g, D);
      }
    }
    function C(g, T, D) {
      {
        var B = S.ReactDebugCurrentFrame, se = B.getStackAddendum();
        se !== "" && (T += "%s", D = D.concat([se]));
        var ae = D.map(function(ee) {
          return String(ee);
        });
        ae.unshift("Warning: " + T), Function.prototype.apply.call(console[g], console, ae);
      }
    }
    var P = !1, j = !1, w = !1, _ = !1, O = !1, R;
    R = Symbol.for("react.module.reference");
    function N(g) {
      return !!(typeof g == "string" || typeof g == "function" || g === n || g === i || O || g === s || g === u || g === c || _ || g === f || P || j || w || typeof g == "object" && g !== null && (g.$$typeof === d || g.$$typeof === h || g.$$typeof === a || g.$$typeof === o || g.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      g.$$typeof === R || g.getModuleId !== void 0));
    }
    function k(g, T, D) {
      var B = g.displayName;
      if (B)
        return B;
      var se = T.displayName || T.name || "";
      return se !== "" ? D + "(" + se + ")" : D;
    }
    function F(g) {
      return g.displayName || "Context";
    }
    function U(g) {
      if (g == null)
        return null;
      if (typeof g.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof g == "function")
        return g.displayName || g.name || null;
      if (typeof g == "string")
        return g;
      switch (g) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case o:
            var T = g;
            return F(T) + ".Consumer";
          case a:
            var D = g;
            return F(D._context) + ".Provider";
          case l:
            return k(g, g.render, "ForwardRef");
          case h:
            var B = g.displayName || null;
            return B !== null ? B : U(g.type) || "Memo";
          case d: {
            var se = g, ae = se._payload, ee = se._init;
            try {
              return U(ee(ae));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, M = 0, re, ce, $, K, ne, W, A;
    function Q() {
    }
    Q.__reactDisabledLog = !0;
    function Z() {
      {
        if (M === 0) {
          re = console.log, ce = console.info, $ = console.warn, K = console.error, ne = console.group, W = console.groupCollapsed, A = console.groupEnd;
          var g = {
            configurable: !0,
            enumerable: !0,
            value: Q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: g,
            log: g,
            warn: g,
            error: g,
            group: g,
            groupCollapsed: g,
            groupEnd: g
          });
        }
        M++;
      }
    }
    function Te() {
      {
        if (M--, M === 0) {
          var g = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, g, {
              value: re
            }),
            info: z({}, g, {
              value: ce
            }),
            warn: z({}, g, {
              value: $
            }),
            error: z({}, g, {
              value: K
            }),
            group: z({}, g, {
              value: ne
            }),
            groupCollapsed: z({}, g, {
              value: W
            }),
            groupEnd: z({}, g, {
              value: A
            })
          });
        }
        M < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var nt = S.ReactCurrentDispatcher, ot;
    function Ct(g, T, D) {
      {
        if (ot === void 0)
          try {
            throw Error();
          } catch (se) {
            var B = se.stack.trim().match(/\n( *(at )?)/);
            ot = B && B[1] || "";
          }
        return `
` + ot + g;
      }
    }
    var Er = !1, Ot;
    {
      var qn = typeof WeakMap == "function" ? WeakMap : Map;
      Ot = new qn();
    }
    function Cr(g, T) {
      if (!g || Er)
        return "";
      {
        var D = Ot.get(g);
        if (D !== void 0)
          return D;
      }
      var B;
      Er = !0;
      var se = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ae;
      ae = nt.current, nt.current = null, Z();
      try {
        if (T) {
          var ee = function() {
            throw Error();
          };
          if (Object.defineProperty(ee.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ee, []);
            } catch (Ne) {
              B = Ne;
            }
            Reflect.construct(g, [], ee);
          } else {
            try {
              ee.call();
            } catch (Ne) {
              B = Ne;
            }
            g.call(ee.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ne) {
            B = Ne;
          }
          g();
        }
      } catch (Ne) {
        if (Ne && B && typeof Ne.stack == "string") {
          for (var Y = Ne.stack.split(`
`), Oe = B.stack.split(`
`), me = Y.length - 1, be = Oe.length - 1; me >= 1 && be >= 0 && Y[me] !== Oe[be]; )
            be--;
          for (; me >= 1 && be >= 0; me--, be--)
            if (Y[me] !== Oe[be]) {
              if (me !== 1 || be !== 1)
                do
                  if (me--, be--, be < 0 || Y[me] !== Oe[be]) {
                    var Ue = `
` + Y[me].replace(" at new ", " at ");
                    return g.displayName && Ue.includes("<anonymous>") && (Ue = Ue.replace("<anonymous>", g.displayName)), typeof g == "function" && Ot.set(g, Ue), Ue;
                  }
                while (me >= 1 && be >= 0);
              break;
            }
        }
      } finally {
        Er = !1, nt.current = ae, Te(), Error.prepareStackTrace = se;
      }
      var Qt = g ? g.displayName || g.name : "", _t = Qt ? Ct(Qt) : "";
      return typeof g == "function" && Ot.set(g, _t), _t;
    }
    function Kn(g, T, D) {
      return Cr(g, !1);
    }
    function un(g) {
      var T = g.prototype;
      return !!(T && T.isReactComponent);
    }
    function Vt(g, T, D) {
      if (g == null)
        return "";
      if (typeof g == "function")
        return Cr(g, un(g));
      if (typeof g == "string")
        return Ct(g);
      switch (g) {
        case u:
          return Ct("Suspense");
        case c:
          return Ct("SuspenseList");
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case l:
            return Kn(g.render);
          case h:
            return Vt(g.type, T, D);
          case d: {
            var B = g, se = B._payload, ae = B._init;
            try {
              return Vt(ae(se), T, D);
            } catch {
            }
          }
        }
      return "";
    }
    var lt = Object.prototype.hasOwnProperty, hn = {}, dn = S.ReactDebugCurrentFrame;
    function Rt(g) {
      if (g) {
        var T = g._owner, D = Vt(g.type, g._source, T ? T.type : null);
        dn.setExtraStackFrame(D);
      } else
        dn.setExtraStackFrame(null);
    }
    function fn(g, T, D, B, se) {
      {
        var ae = Function.call.bind(lt);
        for (var ee in g)
          if (ae(g, ee)) {
            var Y = void 0;
            try {
              if (typeof g[ee] != "function") {
                var Oe = Error((B || "React class") + ": " + D + " type `" + ee + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[ee] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Oe.name = "Invariant Violation", Oe;
              }
              Y = g[ee](T, ee, B, D, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (me) {
              Y = me;
            }
            Y && !(Y instanceof Error) && (Rt(se), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", B || "React class", D, ee, typeof Y), Rt(null)), Y instanceof Error && !(Y.message in hn) && (hn[Y.message] = !0, Rt(se), x("Failed %s type: %s", D, Y.message), Rt(null));
          }
      }
    }
    var de = Array.isArray;
    function Ce(g) {
      return de(g);
    }
    function st(g) {
      {
        var T = typeof Symbol == "function" && Symbol.toStringTag, D = T && g[Symbol.toStringTag] || g.constructor.name || "Object";
        return D;
      }
    }
    function qt(g) {
      try {
        return pn(g), !1;
      } catch {
        return !0;
      }
    }
    function pn(g) {
      return "" + g;
    }
    function mn(g) {
      if (qt(g))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", st(g)), pn(g);
    }
    var Or = S.ReactCurrentOwner, Nl = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, yi, bi, Qn;
    Qn = {};
    function jl(g) {
      if (lt.call(g, "ref")) {
        var T = Object.getOwnPropertyDescriptor(g, "ref").get;
        if (T && T.isReactWarning)
          return !1;
      }
      return g.ref !== void 0;
    }
    function Fl(g) {
      if (lt.call(g, "key")) {
        var T = Object.getOwnPropertyDescriptor(g, "key").get;
        if (T && T.isReactWarning)
          return !1;
      }
      return g.key !== void 0;
    }
    function Dl(g, T) {
      if (typeof g.ref == "string" && Or.current && T && Or.current.stateNode !== T) {
        var D = U(Or.current.type);
        Qn[D] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', U(Or.current.type), g.ref), Qn[D] = !0);
      }
    }
    function Al(g, T) {
      {
        var D = function() {
          yi || (yi = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", T));
        };
        D.isReactWarning = !0, Object.defineProperty(g, "key", {
          get: D,
          configurable: !0
        });
      }
    }
    function kl(g, T) {
      {
        var D = function() {
          bi || (bi = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", T));
        };
        D.isReactWarning = !0, Object.defineProperty(g, "ref", {
          get: D,
          configurable: !0
        });
      }
    }
    var Il = function(g, T, D, B, se, ae, ee) {
      var Y = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: g,
        key: T,
        ref: D,
        props: ee,
        // Record the component responsible for creating this element.
        _owner: ae
      };
      return Y._store = {}, Object.defineProperty(Y._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Y, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: B
      }), Object.defineProperty(Y, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: se
      }), Object.freeze && (Object.freeze(Y.props), Object.freeze(Y)), Y;
    };
    function Ml(g, T, D, B, se) {
      {
        var ae, ee = {}, Y = null, Oe = null;
        D !== void 0 && (mn(D), Y = "" + D), Fl(T) && (mn(T.key), Y = "" + T.key), jl(T) && (Oe = T.ref, Dl(T, se));
        for (ae in T)
          lt.call(T, ae) && !Nl.hasOwnProperty(ae) && (ee[ae] = T[ae]);
        if (g && g.defaultProps) {
          var me = g.defaultProps;
          for (ae in me)
            ee[ae] === void 0 && (ee[ae] = me[ae]);
        }
        if (Y || Oe) {
          var be = typeof g == "function" ? g.displayName || g.name || "Unknown" : g;
          Y && Al(ee, be), Oe && kl(ee, be);
        }
        return Il(g, Y, Oe, se, B, Or.current, ee);
      }
    }
    var Yn = S.ReactCurrentOwner, vi = S.ReactDebugCurrentFrame;
    function Kt(g) {
      if (g) {
        var T = g._owner, D = Vt(g.type, g._source, T ? T.type : null);
        vi.setExtraStackFrame(D);
      } else
        vi.setExtraStackFrame(null);
    }
    var Xn;
    Xn = !1;
    function Gn(g) {
      return typeof g == "object" && g !== null && g.$$typeof === e;
    }
    function wi() {
      {
        if (Yn.current) {
          var g = U(Yn.current.type);
          if (g)
            return `

Check the render method of \`` + g + "`.";
        }
        return "";
      }
    }
    function Ll(g) {
      return "";
    }
    var xi = {};
    function zl(g) {
      {
        var T = wi();
        if (!T) {
          var D = typeof g == "string" ? g : g.displayName || g.name;
          D && (T = `

Check the top-level render call using <` + D + ">.");
        }
        return T;
      }
    }
    function Si(g, T) {
      {
        if (!g._store || g._store.validated || g.key != null)
          return;
        g._store.validated = !0;
        var D = zl(T);
        if (xi[D])
          return;
        xi[D] = !0;
        var B = "";
        g && g._owner && g._owner !== Yn.current && (B = " It was passed a child from " + U(g._owner.type) + "."), Kt(g), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', D, B), Kt(null);
      }
    }
    function Ei(g, T) {
      {
        if (typeof g != "object")
          return;
        if (Ce(g))
          for (var D = 0; D < g.length; D++) {
            var B = g[D];
            Gn(B) && Si(B, T);
          }
        else if (Gn(g))
          g._store && (g._store.validated = !0);
        else if (g) {
          var se = m(g);
          if (typeof se == "function" && se !== g.entries)
            for (var ae = se.call(g), ee; !(ee = ae.next()).done; )
              Gn(ee.value) && Si(ee.value, T);
        }
      }
    }
    function Ul(g) {
      {
        var T = g.type;
        if (T == null || typeof T == "string")
          return;
        var D;
        if (typeof T == "function")
          D = T.propTypes;
        else if (typeof T == "object" && (T.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        T.$$typeof === h))
          D = T.propTypes;
        else
          return;
        if (D) {
          var B = U(T);
          fn(D, g.props, "prop", B, g);
        } else if (T.PropTypes !== void 0 && !Xn) {
          Xn = !0;
          var se = U(T);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", se || "Unknown");
        }
        typeof T.getDefaultProps == "function" && !T.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Bl(g) {
      {
        for (var T = Object.keys(g.props), D = 0; D < T.length; D++) {
          var B = T[D];
          if (B !== "children" && B !== "key") {
            Kt(g), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", B), Kt(null);
            break;
          }
        }
        g.ref !== null && (Kt(g), x("Invalid attribute `ref` supplied to `React.Fragment`."), Kt(null));
      }
    }
    var Ci = {};
    function Oi(g, T, D, B, se, ae) {
      {
        var ee = N(g);
        if (!ee) {
          var Y = "";
          (g === void 0 || typeof g == "object" && g !== null && Object.keys(g).length === 0) && (Y += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Oe = Ll();
          Oe ? Y += Oe : Y += wi();
          var me;
          g === null ? me = "null" : Ce(g) ? me = "array" : g !== void 0 && g.$$typeof === e ? (me = "<" + (U(g.type) || "Unknown") + " />", Y = " Did you accidentally export a JSX literal instead of a component?") : me = typeof g, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", me, Y);
        }
        var be = Ml(g, T, D, se, ae);
        if (be == null)
          return be;
        if (ee) {
          var Ue = T.children;
          if (Ue !== void 0)
            if (B)
              if (Ce(Ue)) {
                for (var Qt = 0; Qt < Ue.length; Qt++)
                  Ei(Ue[Qt], g);
                Object.freeze && Object.freeze(Ue);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ei(Ue, g);
        }
        if (lt.call(T, "key")) {
          var _t = U(g), Ne = Object.keys(T).filter(function(Kl) {
            return Kl !== "key";
          }), Jn = Ne.length > 0 ? "{key: someKey, " + Ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ci[_t + Jn]) {
            var ql = Ne.length > 0 ? "{" + Ne.join(": ..., ") + ": ...}" : "{}";
            x(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Jn, _t, ql, _t), Ci[_t + Jn] = !0;
          }
        }
        return g === n ? Bl(be) : Ul(be), be;
      }
    }
    function $l(g, T, D) {
      return Oi(g, T, D, !0);
    }
    function Hl(g, T, D) {
      return Oi(g, T, D, !1);
    }
    var Wl = Hl, Vl = $l;
    _r.Fragment = n, _r.jsx = Wl, _r.jsxs = Vl;
  }()), _r;
}
process.env.NODE_ENV === "production" ? ms.exports = vc() : ms.exports = wc();
var v = ms.exports, ft = /* @__PURE__ */ ((t) => (t.Docx = ".docx", t.Doc = ".doc", t.Ttf = ".ttf", t.AD_PRT = ".AD_PRT", t.AD_SMP = ".AD_SMP", t.AD_ASM = ".AD_ASM", t.AD_DRW = ".AD_DRW", t))(ft || {}), oe = /* @__PURE__ */ ((t) => (t.Editor = "editor", t.Community = "community", t.BlockPreview = "block_preview", t.Membership = "membership", t.Marketplace = "marketplace", t.Settings = "settings", t.Email = "email", t.Ckeditor = "ckeditor", t.TextEditor = "text_editor", t.BlogPost = "blog_post", t.PageTemplate = "page_template", t.PageTemplatePreview = "page_template_preview", t.BlogTemplatePreview = "blog_template_preview", t.EmailTemplate = "email_template", t.WebsiteTemplate = "website_template", t.Product = "product", t.FunnelTemplatePreview = "funnel_template_preview", t.DigitalStore = "digital_store", t.DigitalProductResource = "digital_product_resource", t.CalendarHostAvatar = "calendar_host_avatar", t.FileManager = "file_manager", t.WhiteLabel = "white_label", t))(oe || {}), ie = /* @__PURE__ */ ((t) => (t.Image = "image", t.ImageOther = "image_other", t.Video = "video", t.Audio = "audio", t.Font = "font", t.Document = "document", t))(ie || {});
const xc = (t) => {
  if (typeof t != "object" || t === null)
    return !1;
  const e = t;
  return typeof e.id == "number" && typeof e.name == "string" && typeof e.filename == "string" && typeof e.path == "string" && (typeof e.thumbnail == "string" || e.thumbnail === null) && Object.values(oe).includes(e.source) && typeof e.size == "number" && Object.values(ie).includes(e.type) && typeof e.createdAt == "string";
}, Sc = {
  [oe.Editor]: "file_manager.file_source.editor",
  [oe.Community]: "file_manager.file_source.community",
  [oe.BlockPreview]: "file_manager.file_source.block_preview",
  [oe.Membership]: "file_manager.file_source.membership",
  [oe.Marketplace]: "file_manager.file_source.marketplace",
  [oe.Settings]: "file_manager.file_source.settings",
  [oe.Email]: "file_manager.file_source.email",
  [oe.Ckeditor]: "file_manager.file_source.ckeditor",
  [oe.BlogPost]: "file_manager.file_source.blog_post",
  [oe.PageTemplate]: "file_manager.file_source.page_template",
  [oe.PageTemplatePreview]: "file_manager.file_source.page_template_preview",
  [oe.BlogTemplatePreview]: "file_manager.file_source.blog_template_preview",
  [oe.EmailTemplate]: "file_manager.file_source.email_template",
  [oe.Product]: "file_manager.file_source.product",
  [oe.FunnelTemplatePreview]: "file_manager.file_source.funnel_template_preview",
  [oe.DigitalStore]: "file_manager.file_source.digital_store",
  [oe.DigitalProductResource]: "file_manager.file_source.digital_product_resource",
  [oe.CalendarHostAvatar]: "file_manager.file_source.calendar_host_avatar",
  [oe.FileManager]: "file_manager.file_source.file_manager",
  [oe.TextEditor]: "file_manager.file_source.text_editor",
  [oe.WhiteLabel]: "file_manager.file_source.white_label",
  [oe.WebsiteTemplate]: "file_manager.file_source.website_template"
}, Ec = {
  [ie.Image]: "file_manager.file_type.image",
  [ie.ImageOther]: "file_manager.file_type.image_other",
  [ie.Video]: "file_manager.file_type.video",
  [ie.Audio]: "file_manager.file_type.audio",
  [ie.Font]: "file_manager.file_type.font",
  [ie.Document]: "file_manager.file_type.document"
};
var ei = /* @__PURE__ */ ((t) => (t.Next = "next", t.Prev = "prev", t))(ei || {}), Za = /* @__PURE__ */ ((t) => (t.Asc = "ASC", t.Desc = "DESC", t))(Za || {});
function Cc(t) {
  return /* @__PURE__ */ v.jsx(
    "svg",
    {
      id: "Layer_1",
      enableBackground: "new 0 0 28 28",
      height: "512",
      viewBox: "0 0 28 28",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ v.jsx("g", { id: "_x35_3", children: /* @__PURE__ */ v.jsx("path", { d: "m4.6 8.7c-.2.5-.3 1-.3 1.5v12.2c0 2 1.6 3.6 3.6 3.6h12.2c2 0 3.6-1.6 3.6-3.6v-16.8c0-2-1.6-3.6-3.6-3.6h-7.6c-.5 0-1 .1-1.5.3-.4.2-.7.4-1 .7l-4.6 4.6c-.3.3-.6.7-.8 1.1zm8.1 5.7c.3 0 .7.1 1 .2v-6c0-.4.2-.8.6-.9.4-.2.8-.1 1.1.2l2.7 2.7c.4.4.4 1 0 1.4s-1 .4-1.4 0l-1-1v6.3c0 1.7-1.4 3-3 3-1.7 0-3-1.3-3-3 0-1.6 1.3-2.9 3-2.9z" }) })
    }
  );
}
function ji(t) {
  return /* @__PURE__ */ v.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      id: "Capa_1",
      enableBackground: "new 0 0 512 512",
      height: "512",
      viewBox: "0 0 512 512",
      width: "512",
      ...t,
      children: [
        /* @__PURE__ */ v.jsx("path", { d: "m106 512h300c24.814 0 45-20.186 45-45v-317h-105c-24.814 0-45-20.186-45-45v-105h-195c-24.814 0-45 20.186-45 45v422c0 24.814 20.186 45 45 45zm60-301h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h180c8.291 0 15 6.709 15 15s-6.709 15-15 15h-180c-8.291 0-15-6.709-15-15s6.709-15 15-15zm0 60h120c8.291 0 15 6.709 15 15s-6.709 15-15 15h-120c-8.291 0-15-6.709-15-15s6.709-15 15-15z" }),
        /* @__PURE__ */ v.jsx("path", { d: "m346 120h96.211l-111.211-111.211v96.211c0 8.276 6.724 15 15 15z" })
      ]
    }
  );
}
function Oc(t) {
  return /* @__PURE__ */ v.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      height: "512pt",
      viewBox: "0 -64 512 512",
      width: "512pt",
      ...t,
      children: [
        /* @__PURE__ */ v.jsx("path", { d: "m149.332031 106.667969c0 23.5625-19.101562 42.664062-42.664062 42.664062-23.566407 0-42.667969-19.101562-42.667969-42.664062 0-23.566407 19.101562-42.667969 42.667969-42.667969 23.5625 0 42.664062 19.101562 42.664062 42.667969zm0 0" }),
        /* @__PURE__ */ v.jsx("path", { d: "m448 0h-384c-35.285156 0-64 28.714844-64 64v256c0 1.195312.296875 2.324219.363281 3.519531-.300781 2.558594-.171875 5.140625.765625 7.574219 5.269532 29.996094 31.382813 52.90625 62.871094 52.90625h384c35.285156 0 64-28.714844 64-64v-256c0-35.285156-28.714844-64-64-64zm-384 42.667969h384c11.753906 0 21.332031 9.578125 21.332031 21.332031v169.367188l-112.210937-112.214844c-14.59375-14.59375-38.335938-14.59375-52.90625 0l-101.546875 101.546875-26.882813-26.878907c-14.589844-14.59375-38.335937-14.59375-52.90625 0l-80.210937 80.210938v-212.03125c0-11.753906 9.578125-21.332031 21.332031-21.332031zm0 0" })
      ]
    }
  );
}
function Rc(t) {
  return /* @__PURE__ */ v.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.1",
      id: "Capa_1",
      x: "0px",
      y: "0px",
      viewBox: "0 0 467.968 467.968",
      ...t,
      children: [
        /* @__PURE__ */ v.jsx("g", { children: /* @__PURE__ */ v.jsx("g", { children: /* @__PURE__ */ v.jsx("path", { d: "M264.704,96.512H51.2c-28.16,0-51.2,23.04-51.2,51.2v172.544c0,28.16,23.04,51.2,51.2,51.2h213.504    c28.16,0,51.2-23.04,51.2-51.2V147.712C315.904,119.04,292.864,96.512,264.704,96.512z" }) }) }),
        /* @__PURE__ */ v.jsx("g", { children: /* @__PURE__ */ v.jsx("g", { children: /* @__PURE__ */ v.jsx("path", { d: "M430.08,124.672c-3.072,0.512-6.144,2.048-8.704,3.584l-79.872,46.08V293.12l80.384,46.08    c14.848,8.704,33.28,3.584,41.984-11.264c2.56-4.608,4.096-9.728,4.096-15.36V154.368    C467.968,135.424,450.048,120.064,430.08,124.672z" }) }) }),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {}),
        /* @__PURE__ */ v.jsx("g", {})
      ]
    }
  );
}
function _c(t) {
  switch (t) {
    case ie.Audio:
      return /* @__PURE__ */ v.jsx(Cc, { className: "fill-text-secondary", width: 40, height: 40 });
    case ie.Image:
    case ie.ImageOther:
      return /* @__PURE__ */ v.jsx(Oc, { className: "fill-text-secondary", width: 40, height: 40 });
    case ie.Video:
      return /* @__PURE__ */ v.jsx(Rc, { className: "fill-text-secondary", width: 40, height: 40 });
    case ie.Font:
    case ie.Document:
      return /* @__PURE__ */ v.jsx(ji, { className: "fill-text-secondary", width: 40, height: 40 });
    default:
      return /* @__PURE__ */ v.jsx(ji, { className: "fill-text-secondary", width: 40, height: 40 });
  }
}
const ti = "-", Pc = (t) => {
  const e = Nc(t), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = t;
  return {
    getClassGroupId: (a) => {
      const o = a.split(ti);
      return o[0] === "" && o.length !== 1 && o.shift(), eo(o, e) || Tc(a);
    },
    getConflictingClassGroupIds: (a, o) => {
      const l = r[a] || [];
      return o && n[a] ? [...l, ...n[a]] : l;
    }
  };
}, eo = (t, e) => {
  var a;
  if (t.length === 0)
    return e.classGroupId;
  const r = t[0], n = e.nextPart.get(r), s = n ? eo(t.slice(1), n) : void 0;
  if (s)
    return s;
  if (e.validators.length === 0)
    return;
  const i = t.join(ti);
  return (a = e.validators.find(({
    validator: o
  }) => o(i))) == null ? void 0 : a.classGroupId;
}, Fi = /^\[(.+)\]$/, Tc = (t) => {
  if (Fi.test(t)) {
    const e = Fi.exec(t)[1], r = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, Nc = (t) => {
  const {
    theme: e,
    prefix: r
  } = t, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Fc(Object.entries(t.classGroups), r).forEach(([i, a]) => {
    gs(a, n, i, e);
  }), n;
}, gs = (t, e, r, n) => {
  t.forEach((s) => {
    if (typeof s == "string") {
      const i = s === "" ? e : Di(e, s);
      i.classGroupId = r;
      return;
    }
    if (typeof s == "function") {
      if (jc(s)) {
        gs(s(n), e, r, n);
        return;
      }
      e.validators.push({
        validator: s,
        classGroupId: r
      });
      return;
    }
    Object.entries(s).forEach(([i, a]) => {
      gs(a, Di(e, i), r, n);
    });
  });
}, Di = (t, e) => {
  let r = t;
  return e.split(ti).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, jc = (t) => t.isThemeGetter, Fc = (t, e) => e ? t.map(([r, n]) => {
  const s = n.map((i) => typeof i == "string" ? e + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([a, o]) => [e + a, o])) : i);
  return [r, s];
}) : t, Dc = (t) => {
  if (t < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const s = (i, a) => {
    r.set(i, a), e++, e > t && (e = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let a = r.get(i);
      if (a !== void 0)
        return a;
      if ((a = n.get(i)) !== void 0)
        return s(i, a), a;
    },
    set(i, a) {
      r.has(i) ? r.set(i, a) : s(i, a);
    }
  };
}, to = "!", Ac = (t) => {
  const {
    separator: e,
    experimentalParseClassName: r
  } = t, n = e.length === 1, s = e[0], i = e.length, a = (o) => {
    const l = [];
    let u = 0, c = 0, h;
    for (let m = 0; m < o.length; m++) {
      let S = o[m];
      if (u === 0) {
        if (S === s && (n || o.slice(m, m + i) === e)) {
          l.push(o.slice(c, m)), c = m + i;
          continue;
        }
        if (S === "/") {
          h = m;
          continue;
        }
      }
      S === "[" ? u++ : S === "]" && u--;
    }
    const d = l.length === 0 ? o : o.substring(c), f = d.startsWith(to), p = f ? d.substring(1) : d, y = h && h > c ? h - c : void 0;
    return {
      modifiers: l,
      hasImportantModifier: f,
      baseClassName: p,
      maybePostfixModifierPosition: y
    };
  };
  return r ? (o) => r({
    className: o,
    parseClassName: a
  }) : a;
}, kc = (t) => {
  if (t.length <= 1)
    return t;
  const e = [];
  let r = [];
  return t.forEach((n) => {
    n[0] === "[" ? (e.push(...r.sort(), n), r = []) : r.push(n);
  }), e.push(...r.sort()), e;
}, Ic = (t) => ({
  cache: Dc(t.cacheSize),
  parseClassName: Ac(t),
  ...Pc(t)
}), Mc = /\s+/, Lc = (t, e) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: s
  } = e, i = [], a = t.trim().split(Mc);
  let o = "";
  for (let l = a.length - 1; l >= 0; l -= 1) {
    const u = a[l], {
      modifiers: c,
      hasImportantModifier: h,
      baseClassName: d,
      maybePostfixModifierPosition: f
    } = r(u);
    let p = !!f, y = n(p ? d.substring(0, f) : d);
    if (!y) {
      if (!p) {
        o = u + (o.length > 0 ? " " + o : o);
        continue;
      }
      if (y = n(d), !y) {
        o = u + (o.length > 0 ? " " + o : o);
        continue;
      }
      p = !1;
    }
    const m = kc(c).join(":"), S = h ? m + to : m, x = S + y;
    if (i.includes(x))
      continue;
    i.push(x);
    const C = s(y, p);
    for (let P = 0; P < C.length; ++P) {
      const j = C[P];
      i.push(S + j);
    }
    o = u + (o.length > 0 ? " " + o : o);
  }
  return o;
};
function zc() {
  let t = 0, e, r, n = "";
  for (; t < arguments.length; )
    (e = arguments[t++]) && (r = ro(e)) && (n && (n += " "), n += r);
  return n;
}
const ro = (t) => {
  if (typeof t == "string")
    return t;
  let e, r = "";
  for (let n = 0; n < t.length; n++)
    t[n] && (e = ro(t[n])) && (r && (r += " "), r += e);
  return r;
};
function Uc(t, ...e) {
  let r, n, s, i = a;
  function a(l) {
    const u = e.reduce((c, h) => h(c), t());
    return r = Ic(u), n = r.cache.get, s = r.cache.set, i = o, o(l);
  }
  function o(l) {
    const u = n(l);
    if (u)
      return u;
    const c = Lc(l, r);
    return s(l, c), c;
  }
  return function() {
    return i(zc.apply(null, arguments));
  };
}
const le = (t) => {
  const e = (r) => r[t] || [];
  return e.isThemeGetter = !0, e;
}, no = /^\[(?:([a-z-]+):)?(.+)\]$/i, Bc = /^\d+\/\d+$/, $c = /* @__PURE__ */ new Set(["px", "full", "screen"]), Hc = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Wc = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Vc = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, qc = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Kc = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, it = (t) => rr(t) || $c.has(t) || Bc.test(t), ct = (t) => wr(t, "length", tu), rr = (t) => !!t && !Number.isNaN(Number(t)), es = (t) => wr(t, "number", rr), Pr = (t) => !!t && Number.isInteger(Number(t)), Qc = (t) => t.endsWith("%") && rr(t.slice(0, -1)), q = (t) => no.test(t), ut = (t) => Hc.test(t), Yc = /* @__PURE__ */ new Set(["length", "size", "percentage"]), Xc = (t) => wr(t, Yc, so), Gc = (t) => wr(t, "position", so), Jc = /* @__PURE__ */ new Set(["image", "url"]), Zc = (t) => wr(t, Jc, nu), eu = (t) => wr(t, "", ru), Tr = () => !0, wr = (t, e, r) => {
  const n = no.exec(t);
  return n ? n[1] ? typeof e == "string" ? n[1] === e : e.has(n[1]) : r(n[2]) : !1;
}, tu = (t) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Wc.test(t) && !Vc.test(t)
), so = () => !1, ru = (t) => qc.test(t), nu = (t) => Kc.test(t), su = () => {
  const t = le("colors"), e = le("spacing"), r = le("blur"), n = le("brightness"), s = le("borderColor"), i = le("borderRadius"), a = le("borderSpacing"), o = le("borderWidth"), l = le("contrast"), u = le("grayscale"), c = le("hueRotate"), h = le("invert"), d = le("gap"), f = le("gradientColorStops"), p = le("gradientColorStopPositions"), y = le("inset"), m = le("margin"), S = le("opacity"), x = le("padding"), C = le("saturate"), P = le("scale"), j = le("sepia"), w = le("skew"), _ = le("space"), O = le("translate"), R = () => ["auto", "contain", "none"], N = () => ["auto", "hidden", "clip", "visible", "scroll"], k = () => ["auto", q, e], F = () => [q, e], U = () => ["", it, ct], z = () => ["auto", rr, q], M = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], re = () => ["solid", "dashed", "dotted", "double", "none"], ce = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], $ = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], K = () => ["", "0", q], ne = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], W = () => [rr, q];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Tr],
      spacing: [it, ct],
      blur: ["none", "", ut, q],
      brightness: W(),
      borderColor: [t],
      borderRadius: ["none", "", "full", ut, q],
      borderSpacing: F(),
      borderWidth: U(),
      contrast: W(),
      grayscale: K(),
      hueRotate: W(),
      invert: K(),
      gap: F(),
      gradientColorStops: [t],
      gradientColorStopPositions: [Qc, ct],
      inset: k(),
      margin: k(),
      opacity: W(),
      padding: F(),
      saturate: W(),
      scale: W(),
      sepia: K(),
      skew: W(),
      space: F(),
      translate: F()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", q]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [ut]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": ne()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": ne()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...M(), q]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: N()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": N()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": N()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: R()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": R()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": R()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [y]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [y]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [y]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [y]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [y]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [y]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [y]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [y]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [y]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Pr, q]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: k()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", q]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: K()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: K()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Pr, q]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Tr]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Pr, q]
        }, q]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": z()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": z()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Tr]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Pr, q]
        }, q]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": z()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": z()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", q]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", q]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [d]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [d]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [d]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...$()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...$(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...$(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [x]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [x]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [x]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [x]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [x]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [x]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [x]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [x]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [x]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [_]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [_]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", q, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [q, e, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [q, e, "none", "full", "min", "max", "fit", "prose", {
          screen: [ut]
        }, ut]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [q, e, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [q, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [q, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [q, e, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", ut, ct]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", es]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Tr]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", q]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", rr, es]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", it, q]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", q]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", q]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [t]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [S]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [t]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [S]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...re(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", it, ct]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", it, q]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [t]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: F()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", q]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", q]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [S]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...M(), Gc]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Xc]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Zc]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [t]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [p]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [f]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [f]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [f]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [o]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [o]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [o]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [o]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [o]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [o]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [o]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [o]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [o]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [S]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...re(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [o]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [o]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [S]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: re()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [s]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [s]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [s]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [s]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [s]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [s]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [s]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [s]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [s]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [s]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...re()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [it, q]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [it, ct]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [t]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: U()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [t]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [S]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [it, ct]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [t]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", ut, eu]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Tr]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [S]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...ce(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": ce()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", ut, q]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [c]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [h]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [C]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [j]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [c]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [h]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [S]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [C]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [j]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", q]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: W()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", q]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: W()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", q]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [P]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [P]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [P]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Pr, q]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [O]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [O]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [w]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [w]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", q]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", t]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", q]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [t]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": F()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": F()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": F()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": F()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": F()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": F()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": F()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": F()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": F()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": F()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": F()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": F()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": F()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": F()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": F()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": F()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": F()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": F()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", q]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [t, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [it, ct, es]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [t, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, ge = /* @__PURE__ */ Uc(su), Nr = /* @__PURE__ */ new Set(), jr = /* @__PURE__ */ new Set(), Ut = Ae.memo(
  ({
    src: t,
    fileType: e,
    alt: r,
    className: n,
    isThumbnail: s = !1,
    width: i,
    height: a,
    title: o
  }) => {
    const [l, u] = Ae.useState(jr.has(t)), [c, h] = Ae.useState(Nr.has(t));
    return /* @__PURE__ */ v.jsxs(
      "div",
      {
        className: ge("flex items-center justify-center", n),
        style: {
          width: i,
          height: a,
          minHeight: a
        },
        title: o,
        children: [
          e !== ie.Video && /* @__PURE__ */ v.jsx(
            "img",
            {
              src: t,
              alt: r,
              className: ge(
                "flex-2 w-full rounded-md object-cover",
                s && "h-full object-cover",
                !l && c ? "block" : "hidden"
              ),
              onLoad: () => {
                h(!0), Nr.add(t), jr.delete(t);
              },
              onError: () => {
                u(!0), Nr.delete(t), jr.add(t);
              }
            }
          ),
          e === ie.Video && /* @__PURE__ */ v.jsx(
            "video",
            {
              src: t,
              className: ge(
                "flex-2 w-full rounded-md object-cover",
                s && "h-full object-cover",
                !l && c ? "block" : "hidden"
              ),
              onLoadedData: () => {
                h(!0), Nr.add(t), jr.delete(t);
              },
              onError: () => {
                u(!0), Nr.delete(t), jr.add(t);
              },
              controls: !s
            }
          ),
          /* @__PURE__ */ v.jsx(
            "div",
            {
              className: ge(
                "flex-2 flex items-center justify-center rounded-md",
                !s && "min-h-[300px]",
                !t || l ? "flex" : "hidden"
              ),
              children: _c(e)
            }
          )
        ]
      }
    );
  }
);
Ut.displayName = "FilePreview";
function iu({
  fileType: t,
  src: e,
  alt: r,
  name: n,
  secondaryText: s,
  style: i,
  selected: a,
  actionMenu: o,
  className: l,
  imageWidth: u,
  imageHeight: c,
  onSelect: h
}) {
  const d = Ae.useRef(null), f = Ae.useRef(null);
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: ge("relative flex flex-col cursor-pointer", l),
      style: i,
      onClick: (p) => {
        var y;
        d.current && !((y = f.current) != null && y.contains(p.target)) && d.current.click();
      },
      children: [
        /* @__PURE__ */ v.jsx(
          Ut,
          {
            src: e ?? "",
            fileType: t,
            alt: r,
            width: u,
            height: c,
            className: ge(
              "relative -top-[2px] -left-[2px] flex-1 rounded-lg border-2 border-transparent box-content",
              a && "border-brand-primary"
            ),
            isThumbnail: !0
          }
        ),
        /* @__PURE__ */ v.jsx("div", { ref: f, className: "absolute top-1 left-1", children: /* @__PURE__ */ v.jsx(Jl, { inputRef: d, value: a, onChange: h }) }),
        /* @__PURE__ */ v.jsx("div", { onClick: (p) => p.stopPropagation(), children: /* @__PURE__ */ v.jsx(
          Zl,
          {
            toggleOnHover: !0,
            menuButtonClassName: "absolute top-1 right-1 p-1 h-[20px] w-[26px]",
            menuItemsClassName: "z-30",
            ...o,
            menuItems: (o == null ? void 0 : o.menuItems) ?? []
          }
        ) }),
        /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "truncate overflow-clip text-base text-text-primary mt-1",
            title: n,
            children: n
          }
        ),
        /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "truncate overflow-clip text-sm text-text-secondary mt-1",
            title: s,
            children: s
          }
        )
      ]
    }
  );
}
const au = (t, e) => {
  const r = t[e];
  return r ? typeof r == "function" ? r() : Promise.resolve(r) : new Promise((n, s) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(s.bind(null, new Error("Unknown variable dynamic import: " + e)));
  });
}, H = (t) => typeof t == "string", Fr = () => {
  let t, e;
  const r = new Promise((n, s) => {
    t = n, e = s;
  });
  return r.resolve = t, r.reject = e, r;
}, Ai = (t) => t == null ? "" : "" + t, ou = (t, e, r) => {
  t.forEach((n) => {
    e[n] && (r[n] = e[n]);
  });
}, lu = /###/g, ki = (t) => t && t.indexOf("###") > -1 ? t.replace(lu, ".") : t, Ii = (t) => !t || H(t), zr = (t, e, r) => {
  const n = H(e) ? e.split(".") : e;
  let s = 0;
  for (; s < n.length - 1; ) {
    if (Ii(t))
      return {};
    const i = ki(n[s]);
    !t[i] && r && (t[i] = new r()), Object.prototype.hasOwnProperty.call(t, i) ? t = t[i] : t = {}, ++s;
  }
  return Ii(t) ? {} : {
    obj: t,
    k: ki(n[s])
  };
}, Mi = (t, e, r) => {
  const {
    obj: n,
    k: s
  } = zr(t, e, Object);
  if (n !== void 0 || e.length === 1) {
    n[s] = r;
    return;
  }
  let i = e[e.length - 1], a = e.slice(0, e.length - 1), o = zr(t, a, Object);
  for (; o.obj === void 0 && a.length; )
    i = `${a[a.length - 1]}.${i}`, a = a.slice(0, a.length - 1), o = zr(t, a, Object), o && o.obj && typeof o.obj[`${o.k}.${i}`] < "u" && (o.obj = void 0);
  o.obj[`${o.k}.${i}`] = r;
}, cu = (t, e, r, n) => {
  const {
    obj: s,
    k: i
  } = zr(t, e, Object);
  s[i] = s[i] || [], s[i].push(r);
}, Cn = (t, e) => {
  const {
    obj: r,
    k: n
  } = zr(t, e);
  if (r)
    return r[n];
}, uu = (t, e, r) => {
  const n = Cn(t, r);
  return n !== void 0 ? n : Cn(e, r);
}, io = (t, e, r) => {
  for (const n in e)
    n !== "__proto__" && n !== "constructor" && (n in t ? H(t[n]) || t[n] instanceof String || H(e[n]) || e[n] instanceof String ? r && (t[n] = e[n]) : io(t[n], e[n], r) : t[n] = e[n]);
  return t;
}, Yt = (t) => t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var hu = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const du = (t) => H(t) ? t.replace(/[&<>"'\/]/g, (e) => hu[e]) : t;
class fu {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const r = this.regExpMap.get(e);
    if (r !== void 0)
      return r;
    const n = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, n), this.regExpQueue.push(e), n;
  }
}
const pu = [" ", ",", "?", "!", ";"], mu = new fu(20), gu = (t, e, r) => {
  e = e || "", r = r || "";
  const n = pu.filter((a) => e.indexOf(a) < 0 && r.indexOf(a) < 0);
  if (n.length === 0)
    return !0;
  const s = mu.getRegExp(`(${n.map((a) => a === "?" ? "\\?" : a).join("|")})`);
  let i = !s.test(t);
  if (!i) {
    const a = t.indexOf(r);
    a > 0 && !s.test(t.substring(0, a)) && (i = !0);
  }
  return i;
}, ys = function(t, e) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!t)
    return;
  if (t[e])
    return t[e];
  const n = e.split(r);
  let s = t;
  for (let i = 0; i < n.length; ) {
    if (!s || typeof s != "object")
      return;
    let a, o = "";
    for (let l = i; l < n.length; ++l)
      if (l !== i && (o += r), o += n[l], a = s[o], a !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof a) > -1 && l < n.length - 1)
          continue;
        i += l - i + 1;
        break;
      }
    s = a;
  }
  return s;
}, On = (t) => t && t.replace("_", "-"), yu = {
  type: "logger",
  log(t) {
    this.output("log", t);
  },
  warn(t) {
    this.output("warn", t);
  },
  error(t) {
    this.output("error", t);
  },
  output(t, e) {
    console && console[t] && console[t].apply(console, e);
  }
};
class Rn {
  constructor(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, r);
  }
  init(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = r.prefix || "i18next:", this.logger = e || yu, this.options = r, this.debug = r.debug;
  }
  log() {
    for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    return this.forward(r, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    return this.forward(r, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    return this.forward(r, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    return this.forward(r, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, r, n, s) {
    return s && !this.debug ? null : (H(e[0]) && (e[0] = `${n}${this.prefix} ${e[0]}`), this.logger[r](e));
  }
  create(e) {
    return new Rn(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new Rn(this.logger, e);
  }
}
var et = new Rn();
class Mn {
  constructor() {
    this.observers = {};
  }
  on(e, r) {
    return e.split(" ").forEach((n) => {
      this.observers[n] || (this.observers[n] = /* @__PURE__ */ new Map());
      const s = this.observers[n].get(r) || 0;
      this.observers[n].set(r, s + 1);
    }), this;
  }
  off(e, r) {
    if (this.observers[e]) {
      if (!r) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(r);
    }
  }
  emit(e) {
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)
      n[s - 1] = arguments[s];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((a) => {
      let [o, l] = a;
      for (let u = 0; u < l; u++)
        o(...n);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((a) => {
      let [o, l] = a;
      for (let u = 0; u < l; u++)
        o.apply(o, [e, ...n]);
    });
  }
}
class Li extends Mn {
  constructor(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const r = this.options.ns.indexOf(e);
    r > -1 && this.options.ns.splice(r, 1);
  }
  getResource(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, a = s.ignoreJSONStructure !== void 0 ? s.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let o;
    e.indexOf(".") > -1 ? o = e.split(".") : (o = [e, r], n && (Array.isArray(n) ? o.push(...n) : H(n) && i ? o.push(...n.split(i)) : o.push(n)));
    const l = Cn(this.data, o);
    return !l && !r && !n && e.indexOf(".") > -1 && (e = o[0], r = o[1], n = o.slice(2).join(".")), l || !a || !H(n) ? l : ys(this.data && this.data[e] && this.data[e][r], n, i);
  }
  addResource(e, r, n, s) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const a = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let o = [e, r];
    n && (o = o.concat(a ? n.split(a) : n)), e.indexOf(".") > -1 && (o = e.split("."), s = r, r = o[1]), this.addNamespaces(r), Mi(this.data, o, s), i.silent || this.emit("added", e, r, n, s);
  }
  addResources(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in n)
      (H(n[i]) || Array.isArray(n[i])) && this.addResource(e, r, i, n[i], {
        silent: !0
      });
    s.silent || this.emit("added", e, r, n);
  }
  addResourceBundle(e, r, n, s, i) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, o = [e, r];
    e.indexOf(".") > -1 && (o = e.split("."), s = n, n = r, r = o[1]), this.addNamespaces(r);
    let l = Cn(this.data, o) || {};
    a.skipCopy || (n = JSON.parse(JSON.stringify(n))), s ? io(l, n, i) : l = {
      ...l,
      ...n
    }, Mi(this.data, o, l), a.silent || this.emit("added", e, r, n);
  }
  removeResourceBundle(e, r) {
    this.hasResourceBundle(e, r) && delete this.data[e][r], this.removeNamespaces(r), this.emit("removed", e, r);
  }
  hasResourceBundle(e, r) {
    return this.getResource(e, r) !== void 0;
  }
  getResourceBundle(e, r) {
    return r || (r = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, r)
    } : this.getResource(e, r);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const r = this.getDataByLanguage(e);
    return !!(r && Object.keys(r) || []).find((s) => r[s] && Object.keys(r[s]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var ao = {
  processors: {},
  addPostProcessor(t) {
    this.processors[t.name] = t;
  },
  handle(t, e, r, n, s) {
    return t.forEach((i) => {
      this.processors[i] && (e = this.processors[i].process(e, r, n, s));
    }), e;
  }
};
const zi = {};
class _n extends Mn {
  constructor(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), ou(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = et.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const n = this.resolve(e, r);
    return n && n.res !== void 0;
  }
  extractFromKey(e, r) {
    let n = r.nsSeparator !== void 0 ? r.nsSeparator : this.options.nsSeparator;
    n === void 0 && (n = ":");
    const s = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let i = r.ns || this.options.defaultNS || [];
    const a = n && e.indexOf(n) > -1, o = !this.options.userDefinedKeySeparator && !r.keySeparator && !this.options.userDefinedNsSeparator && !r.nsSeparator && !gu(e, n, s);
    if (a && !o) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: H(i) ? [i] : i
        };
      const u = e.split(n);
      (n !== s || n === s && this.options.ns.indexOf(u[0]) > -1) && (i = u.shift()), e = u.join(s);
    }
    return {
      key: e,
      namespaces: H(i) ? [i] : i
    };
  }
  translate(e, r, n) {
    if (typeof r != "object" && this.options.overloadTranslationOptionHandler && (r = this.options.overloadTranslationOptionHandler(arguments)), typeof r == "object" && (r = {
      ...r
    }), r || (r = {}), e == null)
      return "";
    Array.isArray(e) || (e = [String(e)]);
    const s = r.returnDetails !== void 0 ? r.returnDetails : this.options.returnDetails, i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, {
      key: a,
      namespaces: o
    } = this.extractFromKey(e[e.length - 1], r), l = o[o.length - 1], u = r.lng || this.language, c = r.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (u && u.toLowerCase() === "cimode") {
      if (c) {
        const P = r.nsSeparator || this.options.nsSeparator;
        return s ? {
          res: `${l}${P}${a}`,
          usedKey: a,
          exactUsedKey: a,
          usedLng: u,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(r)
        } : `${l}${P}${a}`;
      }
      return s ? {
        res: a,
        usedKey: a,
        exactUsedKey: a,
        usedLng: u,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(r)
      } : a;
    }
    const h = this.resolve(e, r);
    let d = h && h.res;
    const f = h && h.usedKey || a, p = h && h.exactUsedKey || a, y = Object.prototype.toString.apply(d), m = ["[object Number]", "[object Function]", "[object RegExp]"], S = r.joinArrays !== void 0 ? r.joinArrays : this.options.joinArrays, x = !this.i18nFormat || this.i18nFormat.handleAsObject, C = !H(d) && typeof d != "boolean" && typeof d != "number";
    if (x && d && C && m.indexOf(y) < 0 && !(H(S) && Array.isArray(d))) {
      if (!r.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const P = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(f, d, {
          ...r,
          ns: o
        }) : `key '${a} (${this.language})' returned an object instead of string.`;
        return s ? (h.res = P, h.usedParams = this.getUsedParamsDetails(r), h) : P;
      }
      if (i) {
        const P = Array.isArray(d), j = P ? [] : {}, w = P ? p : f;
        for (const _ in d)
          if (Object.prototype.hasOwnProperty.call(d, _)) {
            const O = `${w}${i}${_}`;
            j[_] = this.translate(O, {
              ...r,
              joinArrays: !1,
              ns: o
            }), j[_] === O && (j[_] = d[_]);
          }
        d = j;
      }
    } else if (x && H(S) && Array.isArray(d))
      d = d.join(S), d && (d = this.extendTranslation(d, e, r, n));
    else {
      let P = !1, j = !1;
      const w = r.count !== void 0 && !H(r.count), _ = _n.hasDefaultValue(r), O = w ? this.pluralResolver.getSuffix(u, r.count, r) : "", R = r.ordinal && w ? this.pluralResolver.getSuffix(u, r.count, {
        ordinal: !1
      }) : "", N = w && !r.ordinal && r.count === 0 && this.pluralResolver.shouldUseIntlApi(), k = N && r[`defaultValue${this.options.pluralSeparator}zero`] || r[`defaultValue${O}`] || r[`defaultValue${R}`] || r.defaultValue;
      !this.isValidLookup(d) && _ && (P = !0, d = k), this.isValidLookup(d) || (j = !0, d = a);
      const U = (r.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && j ? void 0 : d, z = _ && k !== d && this.options.updateMissing;
      if (j || P || z) {
        if (this.logger.log(z ? "updateKey" : "missingKey", u, l, a, z ? k : d), i) {
          const $ = this.resolve(a, {
            ...r,
            keySeparator: !1
          });
          $ && $.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let M = [];
        const re = this.languageUtils.getFallbackCodes(this.options.fallbackLng, r.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && re && re[0])
          for (let $ = 0; $ < re.length; $++)
            M.push(re[$]);
        else
          this.options.saveMissingTo === "all" ? M = this.languageUtils.toResolveHierarchy(r.lng || this.language) : M.push(r.lng || this.language);
        const ce = ($, K, ne) => {
          const W = _ && ne !== d ? ne : U;
          this.options.missingKeyHandler ? this.options.missingKeyHandler($, l, K, W, z, r) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing($, l, K, W, z, r), this.emit("missingKey", $, l, K, d);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && w ? M.forEach(($) => {
          const K = this.pluralResolver.getSuffixes($, r);
          N && r[`defaultValue${this.options.pluralSeparator}zero`] && K.indexOf(`${this.options.pluralSeparator}zero`) < 0 && K.push(`${this.options.pluralSeparator}zero`), K.forEach((ne) => {
            ce([$], a + ne, r[`defaultValue${ne}`] || k);
          });
        }) : ce(M, a, k));
      }
      d = this.extendTranslation(d, e, r, h, n), j && d === a && this.options.appendNamespaceToMissingKey && (d = `${l}:${a}`), (j || P) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? d = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${a}` : a, P ? d : void 0) : d = this.options.parseMissingKeyHandler(d));
    }
    return s ? (h.res = d, h.usedParams = this.getUsedParamsDetails(r), h) : d;
  }
  extendTranslation(e, r, n, s, i) {
    var a = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...n
      }, n.lng || this.language || s.usedLng, s.usedNS, s.usedKey, {
        resolved: s
      });
    else if (!n.skipInterpolation) {
      n.interpolation && this.interpolator.init({
        ...n,
        interpolation: {
          ...this.options.interpolation,
          ...n.interpolation
        }
      });
      const u = H(e) && (n && n.interpolation && n.interpolation.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (u) {
        const d = e.match(this.interpolator.nestingRegexp);
        c = d && d.length;
      }
      let h = n.replace && !H(n.replace) ? n.replace : n;
      if (this.options.interpolation.defaultVariables && (h = {
        ...this.options.interpolation.defaultVariables,
        ...h
      }), e = this.interpolator.interpolate(e, h, n.lng || this.language || s.usedLng, n), u) {
        const d = e.match(this.interpolator.nestingRegexp), f = d && d.length;
        c < f && (n.nest = !1);
      }
      !n.lng && this.options.compatibilityAPI !== "v1" && s && s.res && (n.lng = this.language || s.usedLng), n.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var d = arguments.length, f = new Array(d), p = 0; p < d; p++)
          f[p] = arguments[p];
        return i && i[0] === f[0] && !n.context ? (a.logger.warn(`It seems you are nesting recursively key: ${f[0]} in key: ${r[0]}`), null) : a.translate(...f, r);
      }, n)), n.interpolation && this.interpolator.reset();
    }
    const o = n.postProcess || this.options.postProcess, l = H(o) ? [o] : o;
    return e != null && l && l.length && n.applyPostProcessor !== !1 && (e = ao.handle(l, e, r, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...s,
        usedParams: this.getUsedParamsDetails(n)
      },
      ...n
    } : n, this)), e;
  }
  resolve(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n, s, i, a, o;
    return H(e) && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(n))
        return;
      const u = this.extractFromKey(l, r), c = u.key;
      s = c;
      let h = u.namespaces;
      this.options.fallbackNS && (h = h.concat(this.options.fallbackNS));
      const d = r.count !== void 0 && !H(r.count), f = d && !r.ordinal && r.count === 0 && this.pluralResolver.shouldUseIntlApi(), p = r.context !== void 0 && (H(r.context) || typeof r.context == "number") && r.context !== "", y = r.lngs ? r.lngs : this.languageUtils.toResolveHierarchy(r.lng || this.language, r.fallbackLng);
      h.forEach((m) => {
        this.isValidLookup(n) || (o = m, !zi[`${y[0]}-${m}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(o) && (zi[`${y[0]}-${m}`] = !0, this.logger.warn(`key "${s}" for languages "${y.join(", ")}" won't get resolved as namespace "${o}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), y.forEach((S) => {
          if (this.isValidLookup(n))
            return;
          a = S;
          const x = [c];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(x, c, S, m, r);
          else {
            let P;
            d && (P = this.pluralResolver.getSuffix(S, r.count, r));
            const j = `${this.options.pluralSeparator}zero`, w = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (d && (x.push(c + P), r.ordinal && P.indexOf(w) === 0 && x.push(c + P.replace(w, this.options.pluralSeparator)), f && x.push(c + j)), p) {
              const _ = `${c}${this.options.contextSeparator}${r.context}`;
              x.push(_), d && (x.push(_ + P), r.ordinal && P.indexOf(w) === 0 && x.push(_ + P.replace(w, this.options.pluralSeparator)), f && x.push(_ + j));
            }
          }
          let C;
          for (; C = x.pop(); )
            this.isValidLookup(n) || (i = C, n = this.getResource(S, m, C, r));
        }));
      });
    }), {
      res: n,
      usedKey: s,
      exactUsedKey: i,
      usedLng: a,
      usedNS: o
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, r, n, s) : this.resourceStore.getResource(e, r, n, s);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const r = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], n = e.replace && !H(e.replace);
    let s = n ? e.replace : e;
    if (n && typeof e.count < "u" && (s.count = e.count), this.options.interpolation.defaultVariables && (s = {
      ...this.options.interpolation.defaultVariables,
      ...s
    }), !n) {
      s = {
        ...s
      };
      for (const i of r)
        delete s[i];
    }
    return s;
  }
  static hasDefaultValue(e) {
    const r = "defaultValue";
    for (const n in e)
      if (Object.prototype.hasOwnProperty.call(e, n) && r === n.substring(0, r.length) && e[n] !== void 0)
        return !0;
    return !1;
  }
}
const ts = (t) => t.charAt(0).toUpperCase() + t.slice(1);
class Ui {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = et.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = On(e), !e || e.indexOf("-") < 0)
      return null;
    const r = e.split("-");
    return r.length === 2 || (r.pop(), r[r.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(r.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = On(e), !e || e.indexOf("-") < 0)
      return e;
    const r = e.split("-");
    return this.formatLanguageCode(r[0]);
  }
  formatLanguageCode(e) {
    if (H(e) && e.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let s = Intl.getCanonicalLocales(e)[0];
          if (s && this.options.lowerCaseLng && (s = s.toLowerCase()), s)
            return s;
        } catch {
        }
      const r = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let n = e.split("-");
      return this.options.lowerCaseLng ? n = n.map((s) => s.toLowerCase()) : n.length === 2 ? (n[0] = n[0].toLowerCase(), n[1] = n[1].toUpperCase(), r.indexOf(n[1].toLowerCase()) > -1 && (n[1] = ts(n[1].toLowerCase()))) : n.length === 3 && (n[0] = n[0].toLowerCase(), n[1].length === 2 && (n[1] = n[1].toUpperCase()), n[0] !== "sgn" && n[2].length === 2 && (n[2] = n[2].toUpperCase()), r.indexOf(n[1].toLowerCase()) > -1 && (n[1] = ts(n[1].toLowerCase())), r.indexOf(n[2].toLowerCase()) > -1 && (n[2] = ts(n[2].toLowerCase()))), n.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e)
      return null;
    let r;
    return e.forEach((n) => {
      if (r)
        return;
      const s = this.formatLanguageCode(n);
      (!this.options.supportedLngs || this.isSupportedCode(s)) && (r = s);
    }), !r && this.options.supportedLngs && e.forEach((n) => {
      if (r)
        return;
      const s = this.getLanguagePartFromCode(n);
      if (this.isSupportedCode(s))
        return r = s;
      r = this.options.supportedLngs.find((i) => {
        if (i === s)
          return i;
        if (!(i.indexOf("-") < 0 && s.indexOf("-") < 0) && (i.indexOf("-") > 0 && s.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === s || i.indexOf(s) === 0 && s.length > 1))
          return i;
      });
    }), r || (r = this.getFallbackCodes(this.options.fallbackLng)[0]), r;
  }
  getFallbackCodes(e, r) {
    if (!e)
      return [];
    if (typeof e == "function" && (e = e(r)), H(e) && (e = [e]), Array.isArray(e))
      return e;
    if (!r)
      return e.default || [];
    let n = e[r];
    return n || (n = e[this.getScriptPartFromCode(r)]), n || (n = e[this.formatLanguageCode(r)]), n || (n = e[this.getLanguagePartFromCode(r)]), n || (n = e.default), n || [];
  }
  toResolveHierarchy(e, r) {
    const n = this.getFallbackCodes(r || this.options.fallbackLng || [], e), s = [], i = (a) => {
      a && (this.isSupportedCode(a) ? s.push(a) : this.logger.warn(`rejecting language code not found in supportedLngs: ${a}`));
    };
    return H(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(e))) : H(e) && i(this.formatLanguageCode(e)), n.forEach((a) => {
      s.indexOf(a) < 0 && i(this.formatLanguageCode(a));
    }), s;
  }
}
let bu = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], vu = {
  1: (t) => +(t > 1),
  2: (t) => +(t != 1),
  3: (t) => 0,
  4: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  5: (t) => t == 0 ? 0 : t == 1 ? 1 : t == 2 ? 2 : t % 100 >= 3 && t % 100 <= 10 ? 3 : t % 100 >= 11 ? 4 : 5,
  6: (t) => t == 1 ? 0 : t >= 2 && t <= 4 ? 1 : 2,
  7: (t) => t == 1 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  8: (t) => t == 1 ? 0 : t == 2 ? 1 : t != 8 && t != 11 ? 2 : 3,
  9: (t) => +(t >= 2),
  10: (t) => t == 1 ? 0 : t == 2 ? 1 : t < 7 ? 2 : t < 11 ? 3 : 4,
  11: (t) => t == 1 || t == 11 ? 0 : t == 2 || t == 12 ? 1 : t > 2 && t < 20 ? 2 : 3,
  12: (t) => +(t % 10 != 1 || t % 100 == 11),
  13: (t) => +(t !== 0),
  14: (t) => t == 1 ? 0 : t == 2 ? 1 : t == 3 ? 2 : 3,
  15: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  16: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t !== 0 ? 1 : 2,
  17: (t) => t == 1 || t % 10 == 1 && t % 100 != 11 ? 0 : 1,
  18: (t) => t == 0 ? 0 : t == 1 ? 1 : 2,
  19: (t) => t == 1 ? 0 : t == 0 || t % 100 > 1 && t % 100 < 11 ? 1 : t % 100 > 10 && t % 100 < 20 ? 2 : 3,
  20: (t) => t == 1 ? 0 : t == 0 || t % 100 > 0 && t % 100 < 20 ? 1 : 2,
  21: (t) => t % 100 == 1 ? 1 : t % 100 == 2 ? 2 : t % 100 == 3 || t % 100 == 4 ? 3 : 0,
  22: (t) => t == 1 ? 0 : t == 2 ? 1 : (t < 0 || t > 10) && t % 10 == 0 ? 2 : 3
};
const wu = ["v1", "v2", "v3"], xu = ["v4"], Bi = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Su = () => {
  const t = {};
  return bu.forEach((e) => {
    e.lngs.forEach((r) => {
      t[r] = {
        numbers: e.nr,
        plurals: vu[e.fc]
      };
    });
  }), t;
};
class Eu {
  constructor(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = r, this.logger = et.create("pluralResolver"), (!this.options.compatibilityJSON || xu.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = Su(), this.pluralRulesCache = {};
  }
  addRule(e, r) {
    this.rules[e] = r;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const n = On(e === "dev" ? "en" : e), s = r.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
        cleanedCode: n,
        type: s
      });
      if (i in this.pluralRulesCache)
        return this.pluralRulesCache[i];
      let a;
      try {
        a = new Intl.PluralRules(n, {
          type: s
        });
      } catch {
        if (!e.match(/-|_/))
          return;
        const l = this.languageUtils.getLanguagePartFromCode(e);
        a = this.getRule(l, r);
      }
      return this.pluralRulesCache[i] = a, a;
    }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this.getRule(e, r);
    return this.shouldUseIntlApi() ? n && n.resolvedOptions().pluralCategories.length > 1 : n && n.numbers.length > 1;
  }
  getPluralFormsOfKey(e, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, n).map((s) => `${r}${s}`);
  }
  getSuffixes(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this.getRule(e, r);
    return n ? this.shouldUseIntlApi() ? n.resolvedOptions().pluralCategories.sort((s, i) => Bi[s] - Bi[i]).map((s) => `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${s}`) : n.numbers.map((s) => this.getSuffix(e, s, r)) : [];
  }
  getSuffix(e, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const s = this.getRule(e, n);
    return s ? this.shouldUseIntlApi() ? `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${s.select(r)}` : this.getSuffixRetroCompatible(s, r) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, r) {
    const n = e.noAbs ? e.plurals(r) : e.plurals(Math.abs(r));
    let s = e.numbers[n];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (s === 2 ? s = "plural" : s === 1 && (s = ""));
    const i = () => this.options.prepend && s.toString() ? this.options.prepend + s.toString() : s.toString();
    return this.options.compatibilityJSON === "v1" ? s === 1 ? "" : typeof s == "number" ? `_plural_${s.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? i() : this.options.prepend && n.toString() ? this.options.prepend + n.toString() : n.toString();
  }
  shouldUseIntlApi() {
    return !wu.includes(this.options.compatibilityJSON);
  }
}
const $i = function(t, e, r) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = uu(t, e, r);
  return !i && s && H(r) && (i = ys(t, r, n), i === void 0 && (i = ys(e, r, n))), i;
}, rs = (t) => t.replace(/\$/g, "$$$$");
class Cu {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = et.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((r) => r), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: r,
      escapeValue: n,
      useRawValueToEscape: s,
      prefix: i,
      prefixEscaped: a,
      suffix: o,
      suffixEscaped: l,
      formatSeparator: u,
      unescapeSuffix: c,
      unescapePrefix: h,
      nestingPrefix: d,
      nestingPrefixEscaped: f,
      nestingSuffix: p,
      nestingSuffixEscaped: y,
      nestingOptionsSeparator: m,
      maxReplaces: S,
      alwaysFormat: x
    } = e.interpolation;
    this.escape = r !== void 0 ? r : du, this.escapeValue = n !== void 0 ? n : !0, this.useRawValueToEscape = s !== void 0 ? s : !1, this.prefix = i ? Yt(i) : a || "{{", this.suffix = o ? Yt(o) : l || "}}", this.formatSeparator = u || ",", this.unescapePrefix = c ? "" : h || "-", this.unescapeSuffix = this.unescapePrefix ? "" : c || "", this.nestingPrefix = d ? Yt(d) : f || Yt("$t("), this.nestingSuffix = p ? Yt(p) : y || Yt(")"), this.nestingOptionsSeparator = m || ",", this.maxReplaces = S || 1e3, this.alwaysFormat = x !== void 0 ? x : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (r, n) => r && r.source === n ? (r.lastIndex = 0, r) : new RegExp(n, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, r, n, s) {
    let i, a, o;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, u = (f) => {
      if (f.indexOf(this.formatSeparator) < 0) {
        const S = $i(r, l, f, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(S, void 0, n, {
          ...s,
          ...r,
          interpolationkey: f
        }) : S;
      }
      const p = f.split(this.formatSeparator), y = p.shift().trim(), m = p.join(this.formatSeparator).trim();
      return this.format($i(r, l, y, this.options.keySeparator, this.options.ignoreJSONStructure), m, n, {
        ...s,
        ...r,
        interpolationkey: y
      });
    };
    this.resetRegExp();
    const c = s && s.missingInterpolationHandler || this.options.missingInterpolationHandler, h = s && s.interpolation && s.interpolation.skipOnVariables !== void 0 ? s.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (f) => rs(f)
    }, {
      regex: this.regexp,
      safeValue: (f) => this.escapeValue ? rs(this.escape(f)) : rs(f)
    }].forEach((f) => {
      for (o = 0; i = f.regex.exec(e); ) {
        const p = i[1].trim();
        if (a = u(p), a === void 0)
          if (typeof c == "function") {
            const m = c(e, i, s);
            a = H(m) ? m : "";
          } else if (s && Object.prototype.hasOwnProperty.call(s, p))
            a = "";
          else if (h) {
            a = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${p} for interpolating ${e}`), a = "";
        else
          !H(a) && !this.useRawValueToEscape && (a = Ai(a));
        const y = f.safeValue(a);
        if (e = e.replace(i[0], y), h ? (f.regex.lastIndex += a.length, f.regex.lastIndex -= i[0].length) : f.regex.lastIndex = 0, o++, o >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s, i, a;
    const o = (l, u) => {
      const c = this.nestingOptionsSeparator;
      if (l.indexOf(c) < 0)
        return l;
      const h = l.split(new RegExp(`${c}[ ]*{`));
      let d = `{${h[1]}`;
      l = h[0], d = this.interpolate(d, a);
      const f = d.match(/'/g), p = d.match(/"/g);
      (f && f.length % 2 === 0 && !p || p.length % 2 !== 0) && (d = d.replace(/'/g, '"'));
      try {
        a = JSON.parse(d), u && (a = {
          ...u,
          ...a
        });
      } catch (y) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, y), `${l}${c}${d}`;
      }
      return a.defaultValue && a.defaultValue.indexOf(this.prefix) > -1 && delete a.defaultValue, l;
    };
    for (; s = this.nestingRegexp.exec(e); ) {
      let l = [];
      a = {
        ...n
      }, a = a.replace && !H(a.replace) ? a.replace : a, a.applyPostProcessor = !1, delete a.defaultValue;
      let u = !1;
      if (s[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(s[1])) {
        const c = s[1].split(this.formatSeparator).map((h) => h.trim());
        s[1] = c.shift(), l = c, u = !0;
      }
      if (i = r(o.call(this, s[1].trim(), a), a), i && s[0] === e && !H(i))
        return i;
      H(i) || (i = Ai(i)), i || (this.logger.warn(`missed to resolve ${s[1]} for nesting ${e}`), i = ""), u && (i = l.reduce((c, h) => this.format(c, h, n.lng, {
        ...n,
        interpolationkey: s[1].trim()
      }), i.trim())), e = e.replace(s[0], i), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const Ou = (t) => {
  let e = t.toLowerCase().trim();
  const r = {};
  if (t.indexOf("(") > -1) {
    const n = t.split("(");
    e = n[0].toLowerCase().trim();
    const s = n[1].substring(0, n[1].length - 1);
    e === "currency" && s.indexOf(":") < 0 ? r.currency || (r.currency = s.trim()) : e === "relativetime" && s.indexOf(":") < 0 ? r.range || (r.range = s.trim()) : s.split(";").forEach((a) => {
      if (a) {
        const [o, ...l] = a.split(":"), u = l.join(":").trim().replace(/^'+|'+$/g, ""), c = o.trim();
        r[c] || (r[c] = u), u === "false" && (r[c] = !1), u === "true" && (r[c] = !0), isNaN(u) || (r[c] = parseInt(u, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: r
  };
}, Xt = (t) => {
  const e = {};
  return (r, n, s) => {
    let i = s;
    s && s.interpolationkey && s.formatParams && s.formatParams[s.interpolationkey] && s[s.interpolationkey] && (i = {
      ...i,
      [s.interpolationkey]: void 0
    });
    const a = n + JSON.stringify(i);
    let o = e[a];
    return o || (o = t(On(n), s), e[a] = o), o(r);
  };
};
class Ru {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = et.create("formatter"), this.options = e, this.formats = {
      number: Xt((r, n) => {
        const s = new Intl.NumberFormat(r, {
          ...n
        });
        return (i) => s.format(i);
      }),
      currency: Xt((r, n) => {
        const s = new Intl.NumberFormat(r, {
          ...n,
          style: "currency"
        });
        return (i) => s.format(i);
      }),
      datetime: Xt((r, n) => {
        const s = new Intl.DateTimeFormat(r, {
          ...n
        });
        return (i) => s.format(i);
      }),
      relativetime: Xt((r, n) => {
        const s = new Intl.RelativeTimeFormat(r, {
          ...n
        });
        return (i) => s.format(i, n.range || "day");
      }),
      list: Xt((r, n) => {
        const s = new Intl.ListFormat(r, {
          ...n
        });
        return (i) => s.format(i);
      })
    }, this.init(e);
  }
  init(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = r.interpolation.formatSeparator || ",";
  }
  add(e, r) {
    this.formats[e.toLowerCase().trim()] = r;
  }
  addCached(e, r) {
    this.formats[e.toLowerCase().trim()] = Xt(r);
  }
  format(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = r.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((o) => o.indexOf(")") > -1)) {
      const o = i.findIndex((l) => l.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, o)].join(this.formatSeparator);
    }
    return i.reduce((o, l) => {
      const {
        formatName: u,
        formatOptions: c
      } = Ou(l);
      if (this.formats[u]) {
        let h = o;
        try {
          const d = s && s.formatParams && s.formatParams[s.interpolationkey] || {}, f = d.locale || d.lng || s.locale || s.lng || n;
          h = this.formats[u](o, f, {
            ...c,
            ...s,
            ...d
          });
        } catch (d) {
          this.logger.warn(d);
        }
        return h;
      } else
        this.logger.warn(`there was no format function for ${u}`);
      return o;
    }, e);
  }
}
const _u = (t, e) => {
  t.pending[e] !== void 0 && (delete t.pending[e], t.pendingCount--);
};
class Pu extends Mn {
  constructor(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = r, this.services = n, this.languageUtils = n.languageUtils, this.options = s, this.logger = et.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = s.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = s.maxRetries >= 0 ? s.maxRetries : 5, this.retryTimeout = s.retryTimeout >= 1 ? s.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(n, s.backend, s);
  }
  queueLoad(e, r, n, s) {
    const i = {}, a = {}, o = {}, l = {};
    return e.forEach((u) => {
      let c = !0;
      r.forEach((h) => {
        const d = `${u}|${h}`;
        !n.reload && this.store.hasResourceBundle(u, h) ? this.state[d] = 2 : this.state[d] < 0 || (this.state[d] === 1 ? a[d] === void 0 && (a[d] = !0) : (this.state[d] = 1, c = !1, a[d] === void 0 && (a[d] = !0), i[d] === void 0 && (i[d] = !0), l[h] === void 0 && (l[h] = !0)));
      }), c || (o[u] = !0);
    }), (Object.keys(i).length || Object.keys(a).length) && this.queue.push({
      pending: a,
      pendingCount: Object.keys(a).length,
      loaded: {},
      errors: [],
      callback: s
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(a),
      toLoadLanguages: Object.keys(o),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, r, n) {
    const s = e.split("|"), i = s[0], a = s[1];
    r && this.emit("failedLoading", i, a, r), !r && n && this.store.addResourceBundle(i, a, n, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = r ? -1 : 2, r && n && (this.state[e] = 0);
    const o = {};
    this.queue.forEach((l) => {
      cu(l.loaded, [i], a), _u(l, e), r && l.errors.push(r), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((u) => {
        o[u] || (o[u] = {});
        const c = l.loaded[u];
        c.length && c.forEach((h) => {
          o[u][h] === void 0 && (o[u][h] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", o), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, a = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length)
      return a(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: r,
        fcName: n,
        tried: s,
        wait: i,
        callback: a
      });
      return;
    }
    this.readingCalls++;
    const o = (u, c) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const h = this.waitingReads.shift();
        this.read(h.lng, h.ns, h.fcName, h.tried, h.wait, h.callback);
      }
      if (u && c && s < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, r, n, s + 1, i * 2, a);
        }, i);
        return;
      }
      a(u, c);
    }, l = this.backend[n].bind(this.backend);
    if (l.length === 2) {
      try {
        const u = l(e, r);
        u && typeof u.then == "function" ? u.then((c) => o(null, c)).catch(o) : o(null, u);
      } catch (u) {
        o(u);
      }
      return;
    }
    return l(e, r, o);
  }
  prepareLoading(e, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), s && s();
    H(e) && (e = this.languageUtils.toResolveHierarchy(e)), H(r) && (r = [r]);
    const i = this.queueLoad(e, r, n, s);
    if (!i.toLoad.length)
      return i.pending.length || s(), null;
    i.toLoad.forEach((a) => {
      this.loadOne(a);
    });
  }
  load(e, r, n) {
    this.prepareLoading(e, r, {}, n);
  }
  reload(e, r, n) {
    this.prepareLoading(e, r, {
      reload: !0
    }, n);
  }
  loadOne(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const n = e.split("|"), s = n[0], i = n[1];
    this.read(s, i, "read", void 0, void 0, (a, o) => {
      a && this.logger.warn(`${r}loading namespace ${i} for language ${s} failed`, a), !a && o && this.logger.log(`${r}loaded namespace ${i} for language ${s}`, o), this.loaded(e, a, o);
    });
  }
  saveMissing(e, r, n, s, i) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(r)) {
      this.logger.warn(`did not save key "${n}" as the namespace "${r}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(n == null || n === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...a,
          isUpdate: i
        }, u = this.backend.create.bind(this.backend);
        if (u.length < 6)
          try {
            let c;
            u.length === 5 ? c = u(e, r, n, s, l) : c = u(e, r, n, s), c && typeof c.then == "function" ? c.then((h) => o(null, h)).catch(o) : o(null, c);
          } catch (c) {
            o(c);
          }
        else
          u(e, r, n, s, o, l);
      }
      !e || !e[0] || this.store.addResource(e[0], r, n, s);
    }
  }
}
const Hi = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (t) => {
    let e = {};
    if (typeof t[1] == "object" && (e = t[1]), H(t[1]) && (e.defaultValue = t[1]), H(t[2]) && (e.tDescription = t[2]), typeof t[2] == "object" || typeof t[3] == "object") {
      const r = t[3] || t[2];
      Object.keys(r).forEach((n) => {
        e[n] = r[n];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (t) => t,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), Wi = (t) => (H(t.ns) && (t.ns = [t.ns]), H(t.fallbackLng) && (t.fallbackLng = [t.fallbackLng]), H(t.fallbackNS) && (t.fallbackNS = [t.fallbackNS]), t.supportedLngs && t.supportedLngs.indexOf("cimode") < 0 && (t.supportedLngs = t.supportedLngs.concat(["cimode"])), t), yn = () => {
}, Tu = (t) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(t)).forEach((r) => {
    typeof t[r] == "function" && (t[r] = t[r].bind(t));
  });
};
class Br extends Mn {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Wi(e), this.services = {}, this.logger = et, this.modules = {
      external: []
    }, Tu(this), r && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, r), this;
      setTimeout(() => {
        this.init(e, r);
      }, 0);
    }
  }
  init() {
    var e = this;
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof r == "function" && (n = r, r = {}), !r.defaultNS && r.defaultNS !== !1 && r.ns && (H(r.ns) ? r.defaultNS = r.ns : r.ns.indexOf("translation") < 0 && (r.defaultNS = r.ns[0]));
    const s = Hi();
    this.options = {
      ...s,
      ...this.options,
      ...Wi(r)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...s.interpolation,
      ...this.options.interpolation
    }), r.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = r.keySeparator), r.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = r.nsSeparator);
    const i = (c) => c ? typeof c == "function" ? new c() : c : null;
    if (!this.options.isClone) {
      this.modules.logger ? et.init(i(this.modules.logger), this.options) : et.init(null, this.options);
      let c;
      this.modules.formatter ? c = this.modules.formatter : typeof Intl < "u" && (c = Ru);
      const h = new Ui(this.options);
      this.store = new Li(this.options.resources, this.options);
      const d = this.services;
      d.logger = et, d.resourceStore = this.store, d.languageUtils = h, d.pluralResolver = new Eu(h, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), c && (!this.options.interpolation.format || this.options.interpolation.format === s.interpolation.format) && (d.formatter = i(c), d.formatter.init(d, this.options), this.options.interpolation.format = d.formatter.format.bind(d.formatter)), d.interpolator = new Cu(this.options), d.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, d.backendConnector = new Pu(i(this.modules.backend), d.resourceStore, d, this.options), d.backendConnector.on("*", function(f) {
        for (var p = arguments.length, y = new Array(p > 1 ? p - 1 : 0), m = 1; m < p; m++)
          y[m - 1] = arguments[m];
        e.emit(f, ...y);
      }), this.modules.languageDetector && (d.languageDetector = i(this.modules.languageDetector), d.languageDetector.init && d.languageDetector.init(d, this.options.detection, this.options)), this.modules.i18nFormat && (d.i18nFormat = i(this.modules.i18nFormat), d.i18nFormat.init && d.i18nFormat.init(this)), this.translator = new _n(this.services, this.options), this.translator.on("*", function(f) {
        for (var p = arguments.length, y = new Array(p > 1 ? p - 1 : 0), m = 1; m < p; m++)
          y[m - 1] = arguments[m];
        e.emit(f, ...y);
      }), this.modules.external.forEach((f) => {
        f.init && f.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, n || (n = yn), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const c = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      c.length > 0 && c[0] !== "dev" && (this.options.lng = c[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((c) => {
      this[c] = function() {
        return e.store[c](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((c) => {
      this[c] = function() {
        return e.store[c](...arguments), e;
      };
    });
    const l = Fr(), u = () => {
      const c = (h, d) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(d), n(h, d);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return c(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, c);
    };
    return this.options.resources || !this.options.initImmediate ? u() : setTimeout(u, 0), l;
  }
  loadResources(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : yn;
    const s = H(e) ? e : this.language;
    if (typeof e == "function" && (n = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (s && s.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return n();
      const i = [], a = (o) => {
        if (!o || o === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(o).forEach((u) => {
          u !== "cimode" && i.indexOf(u) < 0 && i.push(u);
        });
      };
      s ? a(s) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => a(l)), this.options.preload && this.options.preload.forEach((o) => a(o)), this.services.backendConnector.load(i, this.options.ns, (o) => {
        !o && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), n(o);
      });
    } else
      n(null);
  }
  reloadResources(e, r, n) {
    const s = Fr();
    return typeof e == "function" && (n = e, e = void 0), typeof r == "function" && (n = r, r = void 0), e || (e = this.languages), r || (r = this.options.ns), n || (n = yn), this.services.backendConnector.reload(e, r, (i) => {
      s.resolve(), n(i);
    }), s;
  }
  use(e) {
    if (!e)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && ao.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let r = 0; r < this.languages.length; r++) {
        const n = this.languages[r];
        if (!(["cimode", "dev"].indexOf(n) > -1) && this.store.hasLanguageSomeTranslations(n)) {
          this.resolvedLanguage = n;
          break;
        }
      }
  }
  changeLanguage(e, r) {
    var n = this;
    this.isLanguageChangingTo = e;
    const s = Fr();
    this.emit("languageChanging", e);
    const i = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, a = (l, u) => {
      u ? (i(u), this.translator.changeLanguage(u), this.isLanguageChangingTo = void 0, this.emit("languageChanged", u), this.logger.log("languageChanged", u)) : this.isLanguageChangingTo = void 0, s.resolve(function() {
        return n.t(...arguments);
      }), r && r(l, function() {
        return n.t(...arguments);
      });
    }, o = (l) => {
      !e && !l && this.services.languageDetector && (l = []);
      const u = H(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      u && (this.language || i(u), this.translator.language || this.translator.changeLanguage(u), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(u)), this.loadResources(u, (c) => {
        a(c, u);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? o(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(o) : this.services.languageDetector.detect(o) : o(e), s;
  }
  getFixedT(e, r, n) {
    var s = this;
    const i = function(a, o) {
      let l;
      if (typeof o != "object") {
        for (var u = arguments.length, c = new Array(u > 2 ? u - 2 : 0), h = 2; h < u; h++)
          c[h - 2] = arguments[h];
        l = s.options.overloadTranslationOptionHandler([a, o].concat(c));
      } else
        l = {
          ...o
        };
      l.lng = l.lng || i.lng, l.lngs = l.lngs || i.lngs, l.ns = l.ns || i.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || n || i.keyPrefix);
      const d = s.options.keySeparator || ".";
      let f;
      return l.keyPrefix && Array.isArray(a) ? f = a.map((p) => `${l.keyPrefix}${d}${p}`) : f = l.keyPrefix ? `${l.keyPrefix}${d}${a}` : a, s.t(f, l);
    };
    return H(e) ? i.lng = e : i.lngs = e, i.ns = r, i.keyPrefix = n, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const n = r.lng || this.resolvedLanguage || this.languages[0], s = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (n.toLowerCase() === "cimode")
      return !0;
    const a = (o, l) => {
      const u = this.services.backendConnector.state[`${o}|${l}`];
      return u === -1 || u === 0 || u === 2;
    };
    if (r.precheck) {
      const o = r.precheck(this, a);
      if (o !== void 0)
        return o;
    }
    return !!(this.hasResourceBundle(n, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || a(n, e) && (!s || a(i, e)));
  }
  loadNamespaces(e, r) {
    const n = Fr();
    return this.options.ns ? (H(e) && (e = [e]), e.forEach((s) => {
      this.options.ns.indexOf(s) < 0 && this.options.ns.push(s);
    }), this.loadResources((s) => {
      n.resolve(), r && r(s);
    }), n) : (r && r(), Promise.resolve());
  }
  loadLanguages(e, r) {
    const n = Fr();
    H(e) && (e = [e]);
    const s = this.options.preload || [], i = e.filter((a) => s.indexOf(a) < 0 && this.services.languageUtils.isSupportedCode(a));
    return i.length ? (this.options.preload = s.concat(i), this.loadResources((a) => {
      n.resolve(), r && r(a);
    }), n) : (r && r(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e)
      return "rtl";
    const r = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], n = this.services && this.services.languageUtils || new Ui(Hi());
    return r.indexOf(n.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    return new Br(e, r);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : yn;
    const n = e.forkResourceStore;
    n && delete e.forkResourceStore;
    const s = {
      ...this.options,
      ...e,
      isClone: !0
    }, i = new Br(s);
    return (e.debug !== void 0 || e.prefix !== void 0) && (i.logger = i.logger.clone(e)), ["store", "services", "language"].forEach((o) => {
      i[o] = this[o];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, n && (i.store = new Li(this.store.data, s), i.services.resourceStore = i.store), i.translator = new _n(i.services, s), i.translator.on("*", function(o) {
      for (var l = arguments.length, u = new Array(l > 1 ? l - 1 : 0), c = 1; c < l; c++)
        u[c - 1] = arguments[c];
      i.emit(o, ...u);
    }), i.init(s, r), i.translator.options = s, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const ye = Br.createInstance();
ye.createInstance = Br.createInstance;
ye.createInstance;
ye.dir;
ye.init;
ye.loadResources;
ye.reloadResources;
ye.use;
ye.changeLanguage;
ye.getFixedT;
const Nu = ye.t;
ye.exists;
ye.setDefaultNamespace;
ye.hasLoadedNamespace;
ye.loadNamespaces;
ye.loadLanguages;
function $r(t) {
  "@babel/helpers - typeof";
  return $r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, $r(t);
}
function ju(t, e) {
  if ($r(t) != "object" || !t)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if ($r(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function oo(t) {
  var e = ju(t, "string");
  return $r(e) == "symbol" ? e : e + "";
}
function lo(t, e, r) {
  return (e = oo(e)) in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function Fu(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Du(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, oo(n.key), n);
  }
}
function Au(t, e, r) {
  return e && Du(t.prototype, e), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
var ku = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Iu = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Mu = function(e) {
  return Iu[e];
}, Lu = function(e) {
  return e.replace(ku, Mu);
};
function Vi(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qi(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Vi(Object(r), !0).forEach(function(n) {
      lo(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Vi(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var bs = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Lu
}, co, zu = Ga();
function Uu() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  bs = qi(qi({}, bs), t);
}
function Bu() {
  return bs;
}
var $u = function() {
  function t() {
    Fu(this, t), this.usedNamespaces = {};
  }
  return Au(t, [{
    key: "addUsedNamespaces",
    value: function(r) {
      var n = this;
      r.forEach(function(s) {
        n.usedNamespaces[s] || (n.usedNamespaces[s] = !0);
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function() {
      return Object.keys(this.usedNamespaces);
    }
  }]), t;
}();
function Hu(t) {
  co = t;
}
function Wu() {
  return co;
}
var Vu = {
  type: "3rdParty",
  init: function(e) {
    Uu(e.options.react), Hu(e);
  }
};
function qu() {
  if (console && console.warn) {
    for (var t, e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    typeof r[0] == "string" && (r[0] = "react-i18next:: ".concat(r[0])), (t = console).warn.apply(t, r);
  }
}
var Ki = {};
function vs() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  typeof e[0] == "string" && Ki[e[0]] || (typeof e[0] == "string" && (Ki[e[0]] = /* @__PURE__ */ new Date()), qu.apply(void 0, e));
}
function Qi(t, e, r) {
  t.loadNamespaces(e, function() {
    if (t.isInitialized)
      r();
    else {
      var n = function s() {
        setTimeout(function() {
          t.off("initialized", s);
        }, 0), r();
      };
      t.on("initialized", n);
    }
  });
}
function Ku(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = e.languages[0], s = e.options ? e.options.fallbackLng : !1, i = e.languages[e.languages.length - 1];
  if (n.toLowerCase() === "cimode")
    return !0;
  var a = function(l, u) {
    var c = e.services.backendConnector.state["".concat(l, "|").concat(u)];
    return c === -1 || c === 2;
  };
  return r.bindI18n && r.bindI18n.indexOf("languageChanging") > -1 && e.services.backendConnector.backend && e.isLanguageChangingTo && !a(e.isLanguageChangingTo, t) ? !1 : !!(e.hasResourceBundle(n, t) || !e.services.backendConnector.backend || e.options.resources && !e.options.partialBundledLanguages || a(n, t) && (!s || a(i, t)));
}
function Qu(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (!e.languages || !e.languages.length)
    return vs("i18n.languages were undefined or empty", e.languages), !0;
  var n = e.options.ignoreJSONStructure !== void 0;
  return n ? e.hasLoadedNamespace(t, {
    precheck: function(i, a) {
      if (r.bindI18n && r.bindI18n.indexOf("languageChanging") > -1 && i.services.backendConnector.backend && i.isLanguageChangingTo && !a(i.isLanguageChangingTo, t))
        return !1;
    }
  }) : Ku(t, e, r);
}
function Yu(t) {
  if (Array.isArray(t))
    return t;
}
function Xu(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, s, i, a, o = [], l = !0, u = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0)
        for (; !(l = (n = i.call(r)).done) && (o.push(n.value), o.length !== e); l = !0)
          ;
    } catch (c) {
      u = !0, s = c;
    } finally {
      try {
        if (!l && r.return != null && (a = r.return(), Object(a) !== a))
          return;
      } finally {
        if (u)
          throw s;
      }
    }
    return o;
  }
}
function Yi(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function Gu(t, e) {
  if (t) {
    if (typeof t == "string")
      return Yi(t, e);
    var r = {}.toString.call(t).slice(8, -1);
    return r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set" ? Array.from(t) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Yi(t, e) : void 0;
  }
}
function Ju() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Zu(t, e) {
  return Yu(t) || Xu(t, e) || Gu(t, e) || Ju();
}
function Xi(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ns(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Xi(Object(r), !0).forEach(function(n) {
      lo(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Xi(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var eh = function(e, r) {
  var n = Le();
  return We(function() {
    n.current = e;
  }, [e, r]), n.current;
};
function th(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.i18n, n = Ql(zu) || {}, s = n.i18n, i = n.defaultNS, a = r || s || Wu();
  if (a && !a.reportNamespaces && (a.reportNamespaces = new $u()), !a) {
    vs("You will need to pass in an i18next instance by using initReactI18next");
    var o = function(R) {
      return Array.isArray(R) ? R[R.length - 1] : R;
    }, l = [o, {}, !1];
    return l.t = o, l.i18n = {}, l.ready = !1, l;
  }
  a.options.react && a.options.react.wait !== void 0 && vs("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var u = ns(ns(ns({}, Bu()), a.options.react), e), c = u.useSuspense, h = u.keyPrefix, d = t || i || a.options && a.options.defaultNS;
  d = typeof d == "string" ? [d] : d || ["translation"], a.reportNamespaces.addUsedNamespaces && a.reportNamespaces.addUsedNamespaces(d);
  var f = (a.isInitialized || a.initializedStoreOnce) && d.every(function(O) {
    return Qu(O, a, u);
  });
  function p() {
    return a.getFixedT(null, u.nsMode === "fallback" ? d : d[0], h);
  }
  var y = te(p), m = Zu(y, 2), S = m[0], x = m[1], C = d.join(), P = eh(C), j = Le(!0);
  We(function() {
    var O = u.bindI18n, R = u.bindI18nStore;
    j.current = !0, !f && !c && Qi(a, d, function() {
      j.current && x(p);
    }), f && P && P !== C && j.current && x(p);
    function N() {
      j.current && x(p);
    }
    return O && a && a.on(O, N), R && a && a.store.on(R, N), function() {
      j.current = !1, O && a && O.split(" ").forEach(function(k) {
        return a.off(k, N);
      }), R && a && R.split(" ").forEach(function(k) {
        return a.store.off(k, N);
      });
    };
  }, [a, C]);
  var w = Le(!0);
  We(function() {
    j.current && !w.current && x(p), w.current = !1;
  }, [a, h]);
  var _ = [S, a, f];
  if (_.t = S, _.i18n = a, _.ready = f, f || !f && !c)
    return _;
  throw new Promise(function(O) {
    Qi(a, d, function() {
      O();
    });
  });
}
const uo = {
  title: "File Manager",
  file_upload: {
    file_not_supported: "File type not supported",
    drop_files_here: "Drag and drop your files here, or click to browse",
    upload_files: "Upload files",
    uploaded_successfully: "Successfully uploaded",
    crop_file: "Crop image ",
    crop_and_select_file: "Crop and select an image",
    upload_and_select_file: "Upload and select"
  },
  cancelled: "Cancelled",
  error: "Error",
  something_went_wrong: "Something went wrong",
  confirm_action: "Confirm action",
  confirm: "Confirm",
  cancel: "Cancel",
  file_details: "File details",
  download: "Download",
  rename: "Rename",
  delete: "Delete",
  name: "Name",
  size: "Size",
  file_source: {
    editor: "Editor",
    community: "Community",
    block_preview: "Block preview",
    membership: "Membership",
    marketplace: "Marketplace",
    settings: "Settings",
    email: "Email",
    ckeditor: "CKEditor",
    blog_post: "Blog post",
    page_template: "Page template",
    page_template_preview: "Page template preview",
    blog_template_preview: "Blog template preview",
    email_template: "Email template",
    product: "Product",
    funnel_template_preview: "Funnel template preview",
    digital_store: "Digital store",
    digital_product_resource: "Digital product resource",
    file_manager: "File manager",
    calendar_host_avatar: "Calendar",
    text_editor: "Text editor",
    website_template: "Website template",
    white_label: "White Label"
  },
  file_type: {
    image: "Image",
    image_other: "Other image",
    video: "Video",
    audio: "Audio",
    font: "Font",
    document: "Document"
  },
  select: "Select",
  file_selector: {
    files_selected: "file selected",
    search_file: "Search file",
    rename_file: "Rename file",
    file_name: "File name",
    enter_new_file_name: "Enter a new file name",
    failed_rename_file: "Failed to rename file",
    failed_delete_file: "Failed to delete file",
    failed_download_file: "Failed to download file",
    file_deletion_confirmation_text: 'Are you sure you want to delete "{{file}}"?',
    choose_file: "Choose a file"
  },
  search: "Search",
  upload: "Upload",
  file: "File",
  select_type: "Select file type",
  select_source: "Select source",
  type: "Type",
  created_at: "Created at",
  processing_size: "Processing",
  preview: "Preview",
  image_cropper: {
    aspect_ratio: {
      need_to_crop: "Crop image before selecting",
      need_to_crop_note: "The image has a different aspect ratio. Please crop it to match the required one"
    }
  },
  errors: {
    payload_to_large_error_message: "The file size is too big",
    conflict_error_message: "Sorry, but someone else has already changed this entity. Please reload the page and try again!",
    fields_toast_message: "Some fields contain invalid data, scroll down to resolve the issue",
    internal_error_message: "Something went wrong. Please try again"
  },
  file_renamed_successfully: "Renamed successfully",
  file_deleted_successfully: "Deleted successfully"
}, ho = {
  file_manager: uo
}, rh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ho,
  file_manager: uo
}, Symbol.toStringTag, { value: "Module" })), Ln = ["common"], ri = Ln[0], nh = Object.values(ps), sh = {
  en: { common: ho }
}, ih = {
  supportedLngs: nh,
  load: "languageOnly",
  debug: !1,
  defaultNS: ri,
  react: { useSuspense: !1 },
  ns: Ln,
  fallbackLng: ps.ENGLISH,
  lng: ps.ENGLISH,
  interpolation: {
    escapeValue: !1
  },
  resources: sh,
  returnEmptyString: !1
};
ye.use(Vu).init(ih);
const ah = async (t) => {
  const e = await au(/* @__PURE__ */ Object.assign({ "./assets/translations/locales/ar/common.json": () => import("./common-DUMcuKJ9.mjs"), "./assets/translations/locales/bn/common.json": () => import("./common-Cf8cnWXR.mjs"), "./assets/translations/locales/cs/common.json": () => import("./common-L0rV3tWV.mjs"), "./assets/translations/locales/da/common.json": () => import("./common-D8NkktBw.mjs"), "./assets/translations/locales/de/common.json": () => import("./common-CEe2UHk9.mjs"), "./assets/translations/locales/el/common.json": () => import("./common-DMKwE51w.mjs"), "./assets/translations/locales/en/common.json": () => Promise.resolve().then(() => rh), "./assets/translations/locales/es/common.json": () => import("./common-ZgjHcTBK.mjs"), "./assets/translations/locales/fi/common.json": () => import("./common-nFhhyX73.mjs"), "./assets/translations/locales/fr/common.json": () => import("./common-0tPdgbQ1.mjs"), "./assets/translations/locales/he/common.json": () => import("./common-CDV5oKY1.mjs"), "./assets/translations/locales/hi/common.json": () => import("./common-LsLzJAcM.mjs"), "./assets/translations/locales/hu/common.json": () => import("./common-CqMlX4gU.mjs"), "./assets/translations/locales/id/common.json": () => import("./common-C2J_ZsIt.mjs"), "./assets/translations/locales/it/common.json": () => import("./common-Cd_KsYxg.mjs"), "./assets/translations/locales/ja/common.json": () => import("./common-fzCYHZ7A.mjs"), "./assets/translations/locales/ms/common.json": () => import("./common-Dlh2pv83.mjs"), "./assets/translations/locales/nl/common.json": () => import("./common-CxLTTXnx.mjs"), "./assets/translations/locales/no/common.json": () => import("./common-C9Mu05Z3.mjs"), "./assets/translations/locales/pl/common.json": () => import("./common-wxiuhqHs.mjs"), "./assets/translations/locales/pt/common.json": () => import("./common-BwjaBfEr.mjs"), "./assets/translations/locales/ro/common.json": () => import("./common-BDSz_939.mjs"), "./assets/translations/locales/ru/common.json": () => import("./common-DzMxRCSG.mjs"), "./assets/translations/locales/sk/common.json": () => import("./common-_Q38Ihnu.mjs"), "./assets/translations/locales/sl/common.json": () => import("./common-uW78h8oG.mjs"), "./assets/translations/locales/sq/common.json": () => import("./common-BaY1NKe6.mjs"), "./assets/translations/locales/sr/common.json": () => import("./common-BQo1AVZ-.mjs"), "./assets/translations/locales/sv/common.json": () => import("./common-BWiPyq1w.mjs"), "./assets/translations/locales/th/common.json": () => import("./common-DGej3E5E.mjs"), "./assets/translations/locales/tl/common.json": () => import("./common-B5GA4du1.mjs"), "./assets/translations/locales/tr/common.json": () => import("./common-DVuJuDmW.mjs"), "./assets/translations/locales/uk/common.json": () => import("./common-BDYb4Mj7.mjs"), "./assets/translations/locales/zh/common.json": () => import("./common-fPNr3qjR.mjs") }), `./assets/translations/locales/${t}/common.json`);
  return ye.addResourceBundle(t, ri, {
    file_manager: e.default.file_manager
  }), e;
}, fo = () => Ln, po = (t) => t.startsWith("core.error.") ? t.replace("core.error.", "file_manager.errors.") : t.replace(/^(global\.|core\.)/g, "file_manager."), mo = dc(Nu, fo, po), Pe = fc({
  useTranslation: th,
  defaultNamespaces: Ln,
  namespaceMapper: fo,
  assetKeyMapper: po
}), ni = gc;
pc();
const nr = mc({
  httpClient: ni,
  useLocoTranslation: Pe,
  useRouter: () => ({
    push: async (t) => (window.location.assign(t), !0),
    replace: async (t) => (window.location.replace(t), !0)
  })
});
function oh(t, e = 2, r) {
  if (t < 0)
    return (r == null ? void 0 : r.whenNegative) ?? mo("file_manager.processing_size");
  if (t === 0)
    return "0 Bytes";
  const n = 1024, s = e < 0 ? 0 : e, i = ["Bytes", "KB", "MB", "GB"], a = Math.floor(Math.log(t) / Math.log(n));
  return parseFloat((t / Math.pow(n, a)).toFixed(s)) + " " + i[a];
}
const lh = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg", "tiff", "ico", "avif"];
function ws(t) {
  var r;
  const e = (r = t.name.split(".").pop()) == null ? void 0 : r.toLowerCase();
  return t.type.startsWith("image/") || lh.includes(e ?? "-");
}
async function go(t) {
  return new Promise((e, r) => {
    const n = new Image();
    n.src = t, n.crossOrigin = "Anonymous", n.onload = () => {
      const s = n.width / n.height;
      e([n, s]);
    }, n.onerror = (s) => {
      r(new Error("Failed to load image"));
    };
  });
}
function yo(t, e, r = 0.02) {
  return Math.abs(t - e) < r;
}
function bo(t, e = 0.02) {
  const n = [
    { label: "(1:1)", value: 1 },
    { label: "(16:9)", value: 1.7777777777777777 },
    { label: "(21:9)", value: 2.3333333333333335 },
    { label: "(4:3)", value: 1.3333333333333333 },
    { label: "(1.43:1)", value: 1.43 },
    { label: "(32:9)", value: 3.5555555555555554 },
    { label: "(1.41:1)", value: 1.41 },
    { label: "(9:16)", value: 0.5625 },
    { label: "(19.5:9)", value: 2.1666666666666665 },
    { label: "(12:7)", value: 1.7142857142857142 }
  ].find((s) => Math.abs(t - s.value) < e);
  return n == null ? void 0 : n.label;
}
function ch(t, e = 0.02) {
  const r = bo(t, e);
  let n = mo("file_manager.image_cropper.aspect_ratio.need_to_crop");
  return r && (n += ` ${r}`), n;
}
function Gi(t, e) {
  if (!e || isNaN(e))
    return t;
  const r = bo(e);
  if (!r)
    return t;
  const n = r.replace(/[\s:]+/g, "_"), s = t.name.split(".").pop(), a = `${t.name.replace(/\.[^.]+$/, "")}_${n}.${s}`;
  return new File([t], a, {
    type: t.type,
    lastModified: t.lastModified
  });
}
function uh(t, e) {
  return {
    id: t.id,
    name: t.filename,
    filename: t.filename,
    path: t.path,
    thumbnail: t.thumbnail || null,
    source: e,
    size: t.size,
    type: t.type,
    createdAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}
async function hh(t, e, r = "image/png") {
  const n = new OffscreenCanvas(t.width, t.height), s = n.getContext("2d");
  if (!s)
    throw new Error("Canvas context is not available");
  s.drawImage(t, 0, 0);
  const i = await n.convertToBlob({ type: r });
  return new File([i], e, { type: r });
}
function Ji(t, e) {
  const r = Le(null);
  We(() => {
    r.current !== null && e(r.current, t), r.current = t;
  }, [t]);
}
function Zi(t, e) {
  return {
    added: e.filter((r) => !t.includes(r)),
    removed: t.filter((r) => !e.includes(r))
  };
}
async function dh(t) {
  const e = await t.arrayBuffer(), r = await crypto.subtle.digest("SHA-256", e);
  return Array.from(new Uint8Array(r)).map((i) => i.toString(16).padStart(2, "0")).join("");
}
function ea(t, e) {
  const s = `${t.name.replace(/\.[^.]+$/, "")}.png`;
  return new File([e], s, {
    type: "image/png",
    lastModified: t.lastModified
  });
}
const um = {
  image: ["image/*"],
  csv: ["text/csv", "application/vnd.ms-excel", "application/csv", ".csv"]
}, ta = (t, e) => e.some((r) => {
  if (r.includes("*")) {
    const n = r.replace("*", ".*");
    return new RegExp(`^${n}$`).test(t);
  } else
    return t.toLowerCase() === r.toLowerCase();
}), fh = (t) => t.join(", ");
function hm(t) {
  var l;
  const e = (l = t.split(".").pop()) == null ? void 0 : l.toLowerCase();
  if (!e)
    return ie.Document;
  const r = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"], n = ["tiff", "heic", "raw"], s = ["mp4", "mov", "avi", "mkv", "webm"], i = ["mp3", "wav", "ogg", "aac", "flac"], a = ["ttf", "otf", "woff", "woff2"], o = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt", "csv"];
  return r.includes(e) ? ie.Image : n.includes(e) ? ie.ImageOther : s.includes(e) ? ie.Video : i.includes(e) ? ie.Audio : a.includes(e) ? ie.Font : (o.includes(e), ie.Document);
}
function ph({
  fileType: t,
  src: e,
  alt: r,
  name: n,
  size: s,
  className: i,
  onClose: a,
  showCloseButton: o = !0,
  isFetching: l
}) {
  const { t: u } = Pe();
  return l ? /* @__PURE__ */ v.jsxs("div", { className: ge("flex w-full flex-col items-end", i), children: [
    o && /* @__PURE__ */ v.jsx("button", { type: "button", onClick: a, className: "mb-5", children: /* @__PURE__ */ v.jsx(Ri, { width: 17, height: 17, className: "fill-text-primary cursor-pointer" }) }),
    /* @__PURE__ */ v.jsxs("div", { className: "flex w-full flex-col", children: [
      /* @__PURE__ */ v.jsx("div", { className: "bg-background-tertiary h-[300px] w-full animate-pulse rounded-md" }),
      /* @__PURE__ */ v.jsx("div", { className: "bg-background-tertiary mt-5 h-4 w-16 animate-pulse rounded-sm" }),
      /* @__PURE__ */ v.jsx("div", { className: "bg-background-tertiary mt-2 h-6 w-full animate-pulse rounded-sm" }),
      /* @__PURE__ */ v.jsx("div", { className: "bg-background-tertiary mt-2 h-4 w-16 animate-pulse rounded-sm" }),
      /* @__PURE__ */ v.jsx("div", { className: "bg-background-tertiary mt-2 h-6 w-full animate-pulse rounded-sm" })
    ] })
  ] }) : /* @__PURE__ */ v.jsxs("div", { className: ge("flex w-full flex-col items-end", i), children: [
    o && /* @__PURE__ */ v.jsx("button", { type: "button", onClick: a, className: "mb-5", children: /* @__PURE__ */ v.jsx(Ri, { width: 17, height: 17, className: "fill-text-primary cursor-pointer" }) }),
    /* @__PURE__ */ v.jsxs("div", { className: "flex w-full flex-col", children: [
      /* @__PURE__ */ v.jsx(Ut, { src: e ?? "", fileType: t, alt: r }),
      n && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "text-text-secondary mt-5 overflow-clip truncate text-sm",
            style: { lineHeight: 1.1 },
            children: u("file_manager.name")
          }
        ),
        /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "text-text-tertiary mt-2 truncate text-base font-semibold ",
            title: n,
            style: { lineHeight: 1.1 },
            children: n
          }
        )
      ] }),
      typeof s == "number" && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "text-text-secondary mt-[10px] overflow-clip truncate text-sm",
            style: { lineHeight: 1.1 },
            children: u("file_manager.size")
          }
        ),
        /* @__PURE__ */ v.jsx(
          "div",
          {
            className: "text-text-tertiary mt-2 text-base font-semibold",
            style: { lineHeight: 1.1 },
            children: oh(s)
          }
        )
      ] })
    ] })
  ] });
}
const vo = Ae.memo(({ file: t, className: e }) => t.type.startsWith("image/") ? /* @__PURE__ */ v.jsx(
  Ut,
  {
    src: URL.createObjectURL(t),
    fileType: ie.Image,
    alt: t.name,
    className: e,
    isThumbnail: !0,
    title: t.name
  }
) : t.type === "application/pdf" ? /* @__PURE__ */ v.jsx(
  "div",
  {
    className: ge(
      "pointer-events-none flex select-none items-center justify-center overflow-hidden rounded-md",
      e
    ),
    title: t.name,
    children: /* @__PURE__ */ v.jsx(
      "embed",
      {
        src: URL.createObjectURL(t),
        type: t.type,
        className: "h-full w-full",
        style: { border: "none" }
      }
    )
  }
) : t.type.startsWith("video/") ? /* @__PURE__ */ v.jsx(
  Ut,
  {
    src: URL.createObjectURL(t),
    fileType: ie.Video,
    alt: t.name,
    className: e,
    isThumbnail: !0,
    title: t.name
  }
) : /* @__PURE__ */ v.jsx(
  Ut,
  {
    src: "",
    fileType: ie.Document,
    className: e,
    isThumbnail: !0,
    title: t.name
  }
));
vo.displayName = "FilePreviewFromOS";
function ra({
  opened: t,
  onClose: e,
  onConfirm: r,
  onDecline: n,
  title: s,
  confirmationText: i = "",
  className: a,
  cancelButtonCaption: o,
  confirmButtonCaption: l,
  buttonClassName: u,
  buttonTextClassName: c,
  confirmationContent: h,
  afterLeave: d
}) {
  const { t: f } = Pe(), [p, y] = te(""), [m, S] = te(!1), [x, C] = te(!1), P = async () => {
    try {
      S(!0), await r(), S(!1), C(!0);
    } catch {
      S(!1), y(f("file_manager.something_went_wrong"));
    }
  }, j = () => {
    y(""), C(!1);
  };
  return /* @__PURE__ */ v.jsx(
    kn,
    {
      opened: t,
      onClose: () => {
        !x && n && n(), e();
      },
      title: s || f("file_manager.confirm_action"),
      afterLeave: () => {
        d && d(), j();
      },
      isFetching: m,
      isCentered: !0,
      className: a,
      children: /* @__PURE__ */ v.jsxs("form", { className: "flex flex-col gap-6 lg:gap-10", children: [
        i && /* @__PURE__ */ v.jsx("div", { className: "flex justify-center", children: /* @__PURE__ */ v.jsx("p", { className: "text-text-primary text-base", children: i }) }),
        h,
        /* @__PURE__ */ v.jsxs("div", { className: "flex justify-center gap-4", children: [
          /* @__PURE__ */ v.jsx(
            an,
            {
              isFetching: m,
              className: ge("w-full", u),
              buttonTextClassName: c,
              width: "large",
              onClick: async (w) => {
                w.preventDefault(), await P();
              },
              type: "submit",
              children: l || f("file_manager.confirm")
            }
          ),
          /* @__PURE__ */ v.jsx(
            Ja,
            {
              className: ge("w-full", u),
              width: "large",
              buttonTextClassName: c,
              onClick: (w) => {
                w.preventDefault(), n && n(), e();
              },
              disabled: m,
              children: o || f("file_manager.cancel")
            }
          )
        ] }),
        /* @__PURE__ */ v.jsx(En, { error: p, errorClassName: "text-center" })
      ] })
    }
  );
}
function mh({ label: t, ...e }) {
  const { t: r } = Pe();
  return /* @__PURE__ */ v.jsx(
    In,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: t ?? /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2 text-text-primary group-hover:text-brand-primary main-transition-colors", children: [
        /* @__PURE__ */ v.jsx(
          ec,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        r("file_manager.file_details")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
function gh({ label: t, ...e }) {
  const { t: r } = Pe();
  return /* @__PURE__ */ v.jsx(
    In,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: t ?? /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2 text-text-primary group-hover:text-brand-primary main-transition-colors", children: [
        /* @__PURE__ */ v.jsx(
          tc,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        r("file_manager.delete")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
function yh({ label: t, ...e }) {
  const { t: r } = Pe();
  return /* @__PURE__ */ v.jsx(
    In,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: t ?? /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2 text-text-primary group-hover:text-brand-primary main-transition-colors", children: [
        /* @__PURE__ */ v.jsx(
          rc,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        r("file_manager.rename")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
function bh({ label: t, ...e }) {
  const { t: r } = Pe();
  return /* @__PURE__ */ v.jsx(
    In,
    {
      labelClassName: "group hover:text-brand-primary w-full",
      label: t ?? /* @__PURE__ */ v.jsxs("div", { className: "flex items-center gap-2 text-text-primary group-hover:text-brand-primary main-transition-colors", children: [
        /* @__PURE__ */ v.jsx(
          nc,
          {
            className: "fill-text-primary group-hover:fill-brand-primary main-transition-colors",
            width: 18,
            height: 18
          }
        ),
        r("file_manager.download")
      ] }),
      ...e,
      onClick: e.onClick,
      children: void 0
    }
  );
}
var on = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(t) {
    return this.listeners.add(t), this.onSubscribe(), () => {
      this.listeners.delete(t), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}, $t = typeof window > "u" || "Deno" in globalThis;
function He() {
}
function vh(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function xs(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function wo(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function sr(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Ke(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function na(t, e) {
  const {
    type: r = "all",
    exact: n,
    fetchStatus: s,
    predicate: i,
    queryKey: a,
    stale: o
  } = t;
  if (a) {
    if (n) {
      if (e.queryHash !== si(a, e.options))
        return !1;
    } else if (!Wr(e.queryKey, a))
      return !1;
  }
  if (r !== "all") {
    const l = e.isActive();
    if (r === "active" && !l || r === "inactive" && l)
      return !1;
  }
  return !(typeof o == "boolean" && e.isStale() !== o || s && s !== e.state.fetchStatus || i && !i(e));
}
function sa(t, e) {
  const { exact: r, status: n, predicate: s, mutationKey: i } = t;
  if (i) {
    if (!e.options.mutationKey)
      return !1;
    if (r) {
      if (Hr(e.options.mutationKey) !== Hr(i))
        return !1;
    } else if (!Wr(e.options.mutationKey, i))
      return !1;
  }
  return !(n && e.state.status !== n || s && !s(e));
}
function si(t, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || Hr)(t);
}
function Hr(t) {
  return JSON.stringify(
    t,
    (e, r) => Cs(r) ? Object.keys(r).sort().reduce((n, s) => (n[s] = r[s], n), {}) : r
  );
}
function Wr(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? !Object.keys(e).some((r) => !Wr(t[r], e[r])) : !1;
}
function Ss(t, e) {
  if (t === e)
    return t;
  const r = ia(t) && ia(e);
  if (r || Cs(t) && Cs(e)) {
    const n = r ? t : Object.keys(t), s = n.length, i = r ? e : Object.keys(e), a = i.length, o = r ? [] : {};
    let l = 0;
    for (let u = 0; u < a; u++) {
      const c = r ? u : i[u];
      (!r && n.includes(c) || r) && t[c] === void 0 && e[c] === void 0 ? (o[c] = void 0, l++) : (o[c] = Ss(t[c], e[c]), o[c] === t[c] && t[c] !== void 0 && l++);
    }
    return s === a && l === s ? t : o;
  }
  return e;
}
function Es(t, e) {
  if (!e || Object.keys(t).length !== Object.keys(e).length)
    return !1;
  for (const r in t)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function ia(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function Cs(t) {
  if (!aa(t))
    return !1;
  const e = t.constructor;
  if (e === void 0)
    return !0;
  const r = e.prototype;
  return !(!aa(r) || !r.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(t) !== Object.prototype);
}
function aa(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function wh(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function Os(t, e, r) {
  if (typeof r.structuralSharing == "function")
    return r.structuralSharing(t, e);
  if (r.structuralSharing !== !1) {
    if (process.env.NODE_ENV !== "production")
      try {
        return Ss(t, e);
      } catch (n) {
        console.error(
          `Structural sharing requires data to be JSON serializable. To fix this, turn off structuralSharing or return JSON-serializable data from your queryFn. [${r.queryHash}]: ${n}`
        );
      }
    return Ss(t, e);
  }
  return e;
}
function xh(t, e, r = 0) {
  const n = [...t, e];
  return r && n.length > r ? n.slice(1) : n;
}
function Sh(t, e, r = 0) {
  const n = [e, ...t];
  return r && n.length > r ? n.slice(0, -1) : n;
}
var Pn = Symbol();
function xo(t, e) {
  return process.env.NODE_ENV !== "production" && t.queryFn === Pn && console.error(
    `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${t.queryHash}'`
  ), !t.queryFn && (e != null && e.initialPromise) ? () => e.initialPromise : !t.queryFn || t.queryFn === Pn ? () => Promise.reject(new Error(`Missing queryFn: '${t.queryHash}'`)) : t.queryFn;
}
var Ft, mt, or, $a, Eh = ($a = class extends on {
  constructor() {
    super();
    L(this, Ft, void 0);
    L(this, mt, void 0);
    L(this, or, void 0);
    I(this, or, (e) => {
      if (!$t && window.addEventListener) {
        const r = () => e();
        return window.addEventListener("visibilitychange", r, !1), () => {
          window.removeEventListener("visibilitychange", r);
        };
      }
    });
  }
  onSubscribe() {
    b(this, mt) || this.setEventListener(b(this, or));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = b(this, mt)) == null || e.call(this), I(this, mt, void 0));
  }
  setEventListener(e) {
    var r;
    I(this, or, e), (r = b(this, mt)) == null || r.call(this), I(this, mt, e((n) => {
      typeof n == "boolean" ? this.setFocused(n) : this.onFocus();
    }));
  }
  setFocused(e) {
    b(this, Ft) !== e && (I(this, Ft, e), this.onFocus());
  }
  onFocus() {
    const e = this.isFocused();
    this.listeners.forEach((r) => {
      r(e);
    });
  }
  isFocused() {
    var e;
    return typeof b(this, Ft) == "boolean" ? b(this, Ft) : ((e = globalThis.document) == null ? void 0 : e.visibilityState) !== "hidden";
  }
}, Ft = new WeakMap(), mt = new WeakMap(), or = new WeakMap(), $a), ii = new Eh(), lr, gt, cr, Ha, Ch = (Ha = class extends on {
  constructor() {
    super();
    L(this, lr, !0);
    L(this, gt, void 0);
    L(this, cr, void 0);
    I(this, cr, (e) => {
      if (!$t && window.addEventListener) {
        const r = () => e(!0), n = () => e(!1);
        return window.addEventListener("online", r, !1), window.addEventListener("offline", n, !1), () => {
          window.removeEventListener("online", r), window.removeEventListener("offline", n);
        };
      }
    });
  }
  onSubscribe() {
    b(this, gt) || this.setEventListener(b(this, cr));
  }
  onUnsubscribe() {
    var e;
    this.hasListeners() || ((e = b(this, gt)) == null || e.call(this), I(this, gt, void 0));
  }
  setEventListener(e) {
    var r;
    I(this, cr, e), (r = b(this, gt)) == null || r.call(this), I(this, gt, e(this.setOnline.bind(this)));
  }
  setOnline(e) {
    b(this, lr) !== e && (I(this, lr, e), this.listeners.forEach((n) => {
      n(e);
    }));
  }
  isOnline() {
    return b(this, lr);
  }
}, lr = new WeakMap(), gt = new WeakMap(), cr = new WeakMap(), Ha), Tn = new Ch();
function Rs() {
  let t, e;
  const r = new Promise((s, i) => {
    t = s, e = i;
  });
  r.status = "pending", r.catch(() => {
  });
  function n(s) {
    Object.assign(r, s), delete r.resolve, delete r.reject;
  }
  return r.resolve = (s) => {
    n({
      status: "fulfilled",
      value: s
    }), t(s);
  }, r.reject = (s) => {
    n({
      status: "rejected",
      reason: s
    }), e(s);
  }, r;
}
function Oh(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function So(t) {
  return (t ?? "online") === "online" ? Tn.isOnline() : !0;
}
var Eo = class extends Error {
  constructor(t) {
    super("CancelledError"), this.revert = t == null ? void 0 : t.revert, this.silent = t == null ? void 0 : t.silent;
  }
};
function ss(t) {
  return t instanceof Eo;
}
function Co(t) {
  let e = !1, r = 0, n = !1, s;
  const i = Rs(), a = (y) => {
    var m;
    n || (d(new Eo(y)), (m = t.abort) == null || m.call(t));
  }, o = () => {
    e = !0;
  }, l = () => {
    e = !1;
  }, u = () => ii.isFocused() && (t.networkMode === "always" || Tn.isOnline()) && t.canRun(), c = () => So(t.networkMode) && t.canRun(), h = (y) => {
    var m;
    n || (n = !0, (m = t.onSuccess) == null || m.call(t, y), s == null || s(), i.resolve(y));
  }, d = (y) => {
    var m;
    n || (n = !0, (m = t.onError) == null || m.call(t, y), s == null || s(), i.reject(y));
  }, f = () => new Promise((y) => {
    var m;
    s = (S) => {
      (n || u()) && y(S);
    }, (m = t.onPause) == null || m.call(t);
  }).then(() => {
    var y;
    s = void 0, n || (y = t.onContinue) == null || y.call(t);
  }), p = () => {
    if (n)
      return;
    let y;
    const m = r === 0 ? t.initialPromise : void 0;
    try {
      y = m ?? t.fn();
    } catch (S) {
      y = Promise.reject(S);
    }
    Promise.resolve(y).then(h).catch((S) => {
      var w;
      if (n)
        return;
      const x = t.retry ?? ($t ? 0 : 3), C = t.retryDelay ?? Oh, P = typeof C == "function" ? C(r, S) : C, j = x === !0 || typeof x == "number" && r < x || typeof x == "function" && x(r, S);
      if (e || !j) {
        d(S);
        return;
      }
      r++, (w = t.onFail) == null || w.call(t, r, S), wh(P).then(() => u() ? void 0 : f()).then(() => {
        e ? d(S) : p();
      });
    });
  };
  return {
    promise: i,
    cancel: a,
    continue: () => (s == null || s(), i),
    cancelRetry: o,
    continueRetry: l,
    canStart: c,
    start: () => (c() ? p() : f().then(p), i)
  };
}
function Rh() {
  let t = [], e = 0, r = (o) => {
    o();
  }, n = (o) => {
    o();
  }, s = (o) => setTimeout(o, 0);
  const i = (o) => {
    e ? t.push(o) : s(() => {
      r(o);
    });
  }, a = () => {
    const o = t;
    t = [], o.length && s(() => {
      n(() => {
        o.forEach((l) => {
          r(l);
        });
      });
    });
  };
  return {
    batch: (o) => {
      let l;
      e++;
      try {
        l = o();
      } finally {
        e--, e || a();
      }
      return l;
    },
    /**
     * All calls to the wrapped function will be batched.
     */
    batchCalls: (o) => (...l) => {
      i(() => {
        o(...l);
      });
    },
    schedule: i,
    /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */
    setNotifyFunction: (o) => {
      r = o;
    },
    /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */
    setBatchNotifyFunction: (o) => {
      n = o;
    },
    setScheduler: (o) => {
      s = o;
    }
  };
}
var xe = Rh(), Dt, Wa, Oo = (Wa = class {
  constructor() {
    L(this, Dt, void 0);
  }
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), xs(this.gcTime) && I(this, Dt, setTimeout(() => {
      this.optionalRemove();
    }, this.gcTime));
  }
  updateGcTime(t) {
    this.gcTime = Math.max(
      this.gcTime || 0,
      t ?? ($t ? 1 / 0 : 5 * 60 * 1e3)
    );
  }
  clearGcTimeout() {
    b(this, Dt) && (clearTimeout(b(this, Dt)), I(this, Dt, void 0));
  }
}, Dt = new WeakMap(), Wa), ur, hr, $e, Ee, Qr, At, qe, at, Va, _h = (Va = class extends Oo {
  constructor(e) {
    super();
    L(this, qe);
    L(this, ur, void 0);
    L(this, hr, void 0);
    L(this, $e, void 0);
    L(this, Ee, void 0);
    L(this, Qr, void 0);
    L(this, At, void 0);
    I(this, At, !1), I(this, Qr, e.defaultOptions), this.setOptions(e.options), this.observers = [], I(this, $e, e.cache), this.queryKey = e.queryKey, this.queryHash = e.queryHash, I(this, ur, Ph(this.options)), this.state = e.state ?? b(this, ur), this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get promise() {
    var e;
    return (e = b(this, Ee)) == null ? void 0 : e.promise;
  }
  setOptions(e) {
    this.options = { ...b(this, Qr), ...e }, this.updateGcTime(this.options.gcTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && b(this, $e).remove(this);
  }
  setData(e, r) {
    const n = Os(this.state.data, e, this.options);
    return G(this, qe, at).call(this, {
      data: n,
      type: "success",
      dataUpdatedAt: r == null ? void 0 : r.updatedAt,
      manual: r == null ? void 0 : r.manual
    }), n;
  }
  setState(e, r) {
    G(this, qe, at).call(this, { type: "setState", state: e, setStateOptions: r });
  }
  cancel(e) {
    var n, s;
    const r = (n = b(this, Ee)) == null ? void 0 : n.promise;
    return (s = b(this, Ee)) == null || s.cancel(e), r ? r.then(He).catch(He) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({ silent: !0 });
  }
  reset() {
    this.destroy(), this.setState(b(this, ur));
  }
  isActive() {
    return this.observers.some(
      (e) => Ke(e.options.enabled, this) !== !1
    );
  }
  isDisabled() {
    return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === Pn || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
  }
  isStale() {
    return this.state.isInvalidated ? !0 : this.getObserversCount() > 0 ? this.observers.some(
      (e) => e.getCurrentResult().isStale
    ) : this.state.data === void 0;
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || this.state.data === void 0 || !wo(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var r;
    const e = this.observers.find((n) => n.shouldFetchOnWindowFocus());
    e == null || e.refetch({ cancelRefetch: !1 }), (r = b(this, Ee)) == null || r.continue();
  }
  onOnline() {
    var r;
    const e = this.observers.find((n) => n.shouldFetchOnReconnect());
    e == null || e.refetch({ cancelRefetch: !1 }), (r = b(this, Ee)) == null || r.continue();
  }
  addObserver(e) {
    this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), b(this, $e).notify({ type: "observerAdded", query: this, observer: e }));
  }
  removeObserver(e) {
    this.observers.includes(e) && (this.observers = this.observers.filter((r) => r !== e), this.observers.length || (b(this, Ee) && (b(this, At) ? b(this, Ee).cancel({ revert: !0 }) : b(this, Ee).cancelRetry()), this.scheduleGc()), b(this, $e).notify({ type: "observerRemoved", query: this, observer: e }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || G(this, qe, at).call(this, { type: "invalidate" });
  }
  fetch(e, r) {
    var l, u, c;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.data !== void 0 && (r != null && r.cancelRefetch))
        this.cancel({ silent: !0 });
      else if (b(this, Ee))
        return b(this, Ee).continueRetry(), b(this, Ee).promise;
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const h = this.observers.find((d) => d.options.queryFn);
      h && this.setOptions(h.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || console.error(
      "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
    ));
    const n = new AbortController(), s = (h) => {
      Object.defineProperty(h, "signal", {
        enumerable: !0,
        get: () => (I(this, At, !0), n.signal)
      });
    }, i = () => {
      const h = xo(this.options, r), d = {
        queryKey: this.queryKey,
        meta: this.meta
      };
      return s(d), I(this, At, !1), this.options.persister ? this.options.persister(
        h,
        d,
        this
      ) : h(d);
    }, a = {
      fetchOptions: r,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: i
    };
    s(a), (l = this.options.behavior) == null || l.onFetch(
      a,
      this
    ), I(this, hr, this.state), (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((u = a.fetchOptions) == null ? void 0 : u.meta)) && G(this, qe, at).call(this, { type: "fetch", meta: (c = a.fetchOptions) == null ? void 0 : c.meta });
    const o = (h) => {
      var d, f, p, y;
      ss(h) && h.silent || G(this, qe, at).call(this, {
        type: "error",
        error: h
      }), ss(h) || ((f = (d = b(this, $e).config).onError) == null || f.call(
        d,
        h,
        this
      ), (y = (p = b(this, $e).config).onSettled) == null || y.call(
        p,
        this.state.data,
        h,
        this
      )), this.scheduleGc();
    };
    return I(this, Ee, Co({
      initialPromise: r == null ? void 0 : r.initialPromise,
      fn: a.fetchFn,
      abort: n.abort.bind(n),
      onSuccess: (h) => {
        var d, f, p, y;
        if (h === void 0) {
          process.env.NODE_ENV !== "production" && console.error(
            `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
          ), o(new Error(`${this.queryHash} data is undefined`));
          return;
        }
        try {
          this.setData(h);
        } catch (m) {
          o(m);
          return;
        }
        (f = (d = b(this, $e).config).onSuccess) == null || f.call(d, h, this), (y = (p = b(this, $e).config).onSettled) == null || y.call(
          p,
          h,
          this.state.error,
          this
        ), this.scheduleGc();
      },
      onError: o,
      onFail: (h, d) => {
        G(this, qe, at).call(this, { type: "failed", failureCount: h, error: d });
      },
      onPause: () => {
        G(this, qe, at).call(this, { type: "pause" });
      },
      onContinue: () => {
        G(this, qe, at).call(this, { type: "continue" });
      },
      retry: a.options.retry,
      retryDelay: a.options.retryDelay,
      networkMode: a.options.networkMode,
      canRun: () => !0
    })), b(this, Ee).start();
  }
}, ur = new WeakMap(), hr = new WeakMap(), $e = new WeakMap(), Ee = new WeakMap(), Qr = new WeakMap(), At = new WeakMap(), qe = new WeakSet(), at = function(e) {
  const r = (n) => {
    switch (e.type) {
      case "failed":
        return {
          ...n,
          fetchFailureCount: e.failureCount,
          fetchFailureReason: e.error
        };
      case "pause":
        return {
          ...n,
          fetchStatus: "paused"
        };
      case "continue":
        return {
          ...n,
          fetchStatus: "fetching"
        };
      case "fetch":
        return {
          ...n,
          ...Ro(n.data, this.options),
          fetchMeta: e.meta ?? null
        };
      case "success":
        return {
          ...n,
          data: e.data,
          dataUpdateCount: n.dataUpdateCount + 1,
          dataUpdatedAt: e.dataUpdatedAt ?? Date.now(),
          error: null,
          isInvalidated: !1,
          status: "success",
          ...!e.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          }
        };
      case "error":
        const s = e.error;
        return ss(s) && s.revert && b(this, hr) ? { ...b(this, hr), fetchStatus: "idle" } : {
          ...n,
          error: s,
          errorUpdateCount: n.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: n.fetchFailureCount + 1,
          fetchFailureReason: s,
          fetchStatus: "idle",
          status: "error"
        };
      case "invalidate":
        return {
          ...n,
          isInvalidated: !0
        };
      case "setState":
        return {
          ...n,
          ...e.state
        };
    }
  };
  this.state = r(this.state), xe.batch(() => {
    this.observers.forEach((n) => {
      n.onQueryUpdate();
    }), b(this, $e).notify({ query: this, type: "updated", action: e });
  });
}, Va);
function Ro(t, e) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: So(e.networkMode) ? "fetching" : "paused",
    ...t === void 0 && {
      error: null,
      status: "pending"
    }
  };
}
function Ph(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, r = e !== void 0, n = r ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: r ? n ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: r ? "success" : "pending",
    fetchStatus: "idle"
  };
}
var Xe, qa, Th = (qa = class extends on {
  constructor(e = {}) {
    super();
    L(this, Xe, void 0);
    this.config = e, I(this, Xe, /* @__PURE__ */ new Map());
  }
  build(e, r, n) {
    const s = r.queryKey, i = r.queryHash ?? si(s, r);
    let a = this.get(i);
    return a || (a = new _h({
      cache: this,
      queryKey: s,
      queryHash: i,
      options: e.defaultQueryOptions(r),
      state: n,
      defaultOptions: e.getQueryDefaults(s)
    }), this.add(a)), a;
  }
  add(e) {
    b(this, Xe).has(e.queryHash) || (b(this, Xe).set(e.queryHash, e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const r = b(this, Xe).get(e.queryHash);
    r && (e.destroy(), r === e && b(this, Xe).delete(e.queryHash), this.notify({ type: "removed", query: e }));
  }
  clear() {
    xe.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return b(this, Xe).get(e);
  }
  getAll() {
    return [...b(this, Xe).values()];
  }
  find(e) {
    const r = { exact: !0, ...e };
    return this.getAll().find(
      (n) => na(r, n)
    );
  }
  findAll(e = {}) {
    const r = this.getAll();
    return Object.keys(e).length > 0 ? r.filter((n) => na(e, n)) : r;
  }
  notify(e) {
    xe.batch(() => {
      this.listeners.forEach((r) => {
        r(e);
      });
    });
  }
  onFocus() {
    xe.batch(() => {
      this.getAll().forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    xe.batch(() => {
      this.getAll().forEach((e) => {
        e.onOnline();
      });
    });
  }
}, Xe = new WeakMap(), qa), Ge, Re, kt, Je, pt, Ka, Nh = (Ka = class extends Oo {
  constructor(e) {
    super();
    L(this, Je);
    L(this, Ge, void 0);
    L(this, Re, void 0);
    L(this, kt, void 0);
    this.mutationId = e.mutationId, I(this, Re, e.mutationCache), I(this, Ge, []), this.state = e.state || jh(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = e, this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(e) {
    b(this, Ge).includes(e) || (b(this, Ge).push(e), this.clearGcTimeout(), b(this, Re).notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    I(this, Ge, b(this, Ge).filter((r) => r !== e)), this.scheduleGc(), b(this, Re).notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    b(this, Ge).length || (this.state.status === "pending" ? this.scheduleGc() : b(this, Re).remove(this));
  }
  continue() {
    var e;
    return ((e = b(this, kt)) == null ? void 0 : e.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
    this.execute(this.state.variables);
  }
  async execute(e) {
    var s, i, a, o, l, u, c, h, d, f, p, y, m, S, x, C, P, j, w, _;
    I(this, kt, Co({
      fn: () => this.options.mutationFn ? this.options.mutationFn(e) : Promise.reject(new Error("No mutationFn found")),
      onFail: (O, R) => {
        G(this, Je, pt).call(this, { type: "failed", failureCount: O, error: R });
      },
      onPause: () => {
        G(this, Je, pt).call(this, { type: "pause" });
      },
      onContinue: () => {
        G(this, Je, pt).call(this, { type: "continue" });
      },
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => b(this, Re).canRun(this)
    }));
    const r = this.state.status === "pending", n = !b(this, kt).canStart();
    try {
      if (!r) {
        G(this, Je, pt).call(this, { type: "pending", variables: e, isPaused: n }), await ((i = (s = b(this, Re).config).onMutate) == null ? void 0 : i.call(
          s,
          e,
          this
        ));
        const R = await ((o = (a = this.options).onMutate) == null ? void 0 : o.call(a, e));
        R !== this.state.context && G(this, Je, pt).call(this, {
          type: "pending",
          context: R,
          variables: e,
          isPaused: n
        });
      }
      const O = await b(this, kt).start();
      return await ((u = (l = b(this, Re).config).onSuccess) == null ? void 0 : u.call(
        l,
        O,
        e,
        this.state.context,
        this
      )), await ((h = (c = this.options).onSuccess) == null ? void 0 : h.call(c, O, e, this.state.context)), await ((f = (d = b(this, Re).config).onSettled) == null ? void 0 : f.call(
        d,
        O,
        null,
        this.state.variables,
        this.state.context,
        this
      )), await ((y = (p = this.options).onSettled) == null ? void 0 : y.call(p, O, null, e, this.state.context)), G(this, Je, pt).call(this, { type: "success", data: O }), O;
    } catch (O) {
      try {
        throw await ((S = (m = b(this, Re).config).onError) == null ? void 0 : S.call(
          m,
          O,
          e,
          this.state.context,
          this
        )), await ((C = (x = this.options).onError) == null ? void 0 : C.call(
          x,
          O,
          e,
          this.state.context
        )), await ((j = (P = b(this, Re).config).onSettled) == null ? void 0 : j.call(
          P,
          void 0,
          O,
          this.state.variables,
          this.state.context,
          this
        )), await ((_ = (w = this.options).onSettled) == null ? void 0 : _.call(
          w,
          void 0,
          O,
          e,
          this.state.context
        )), O;
      } finally {
        G(this, Je, pt).call(this, { type: "error", error: O });
      }
    } finally {
      b(this, Re).runNext(this);
    }
  }
}, Ge = new WeakMap(), Re = new WeakMap(), kt = new WeakMap(), Je = new WeakSet(), pt = function(e) {
  const r = (n) => {
    switch (e.type) {
      case "failed":
        return {
          ...n,
          failureCount: e.failureCount,
          failureReason: e.error
        };
      case "pause":
        return {
          ...n,
          isPaused: !0
        };
      case "continue":
        return {
          ...n,
          isPaused: !1
        };
      case "pending":
        return {
          ...n,
          context: e.context,
          data: void 0,
          failureCount: 0,
          failureReason: null,
          error: null,
          isPaused: e.isPaused,
          status: "pending",
          variables: e.variables,
          submittedAt: Date.now()
        };
      case "success":
        return {
          ...n,
          data: e.data,
          failureCount: 0,
          failureReason: null,
          error: null,
          status: "success",
          isPaused: !1
        };
      case "error":
        return {
          ...n,
          data: void 0,
          error: e.error,
          failureCount: n.failureCount + 1,
          failureReason: e.error,
          isPaused: !1,
          status: "error"
        };
    }
  };
  this.state = r(this.state), xe.batch(() => {
    b(this, Ge).forEach((n) => {
      n.onMutationUpdate(e);
    }), b(this, Re).notify({
      mutation: this,
      type: "updated",
      action: e
    });
  });
}, Ka);
function jh() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0
  };
}
var Ie, Yr, Qa, Fh = (Qa = class extends on {
  constructor(e = {}) {
    super();
    L(this, Ie, void 0);
    L(this, Yr, void 0);
    this.config = e, I(this, Ie, /* @__PURE__ */ new Map()), I(this, Yr, Date.now());
  }
  build(e, r, n) {
    const s = new Nh({
      mutationCache: this,
      mutationId: ++gn(this, Yr)._,
      options: e.defaultMutationOptions(r),
      state: n
    });
    return this.add(s), s;
  }
  add(e) {
    const r = bn(e), n = b(this, Ie).get(r) ?? [];
    n.push(e), b(this, Ie).set(r, n), this.notify({ type: "added", mutation: e });
  }
  remove(e) {
    var n;
    const r = bn(e);
    if (b(this, Ie).has(r)) {
      const s = (n = b(this, Ie).get(r)) == null ? void 0 : n.filter((i) => i !== e);
      s && (s.length === 0 ? b(this, Ie).delete(r) : b(this, Ie).set(r, s));
    }
    this.notify({ type: "removed", mutation: e });
  }
  canRun(e) {
    var n;
    const r = (n = b(this, Ie).get(bn(e))) == null ? void 0 : n.find((s) => s.state.status === "pending");
    return !r || r === e;
  }
  runNext(e) {
    var n;
    const r = (n = b(this, Ie).get(bn(e))) == null ? void 0 : n.find((s) => s !== e && s.state.isPaused);
    return (r == null ? void 0 : r.continue()) ?? Promise.resolve();
  }
  clear() {
    xe.batch(() => {
      this.getAll().forEach((e) => {
        this.remove(e);
      });
    });
  }
  getAll() {
    return [...b(this, Ie).values()].flat();
  }
  find(e) {
    const r = { exact: !0, ...e };
    return this.getAll().find(
      (n) => sa(r, n)
    );
  }
  findAll(e = {}) {
    return this.getAll().filter((r) => sa(e, r));
  }
  notify(e) {
    xe.batch(() => {
      this.listeners.forEach((r) => {
        r(e);
      });
    });
  }
  resumePausedMutations() {
    const e = this.getAll().filter((r) => r.state.isPaused);
    return xe.batch(
      () => Promise.all(
        e.map((r) => r.continue().catch(He))
      )
    );
  }
}, Ie = new WeakMap(), Yr = new WeakMap(), Qa);
function bn(t) {
  var e;
  return ((e = t.options.scope) == null ? void 0 : e.id) ?? String(t.mutationId);
}
function Nn(t) {
  return {
    onFetch: (e, r) => {
      var c, h, d, f, p;
      const n = e.options, s = (d = (h = (c = e.fetchOptions) == null ? void 0 : c.meta) == null ? void 0 : h.fetchMore) == null ? void 0 : d.direction, i = ((f = e.state.data) == null ? void 0 : f.pages) || [], a = ((p = e.state.data) == null ? void 0 : p.pageParams) || [];
      let o = { pages: [], pageParams: [] }, l = 0;
      const u = async () => {
        let y = !1;
        const m = (C) => {
          Object.defineProperty(C, "signal", {
            enumerable: !0,
            get: () => (e.signal.aborted ? y = !0 : e.signal.addEventListener("abort", () => {
              y = !0;
            }), e.signal)
          });
        }, S = xo(e.options, e.fetchOptions), x = async (C, P, j) => {
          if (y)
            return Promise.reject();
          if (P == null && C.pages.length)
            return Promise.resolve(C);
          const w = {
            queryKey: e.queryKey,
            pageParam: P,
            direction: j ? "backward" : "forward",
            meta: e.options.meta
          };
          m(w);
          const _ = await S(
            w
          ), { maxPages: O } = e.options, R = j ? Sh : xh;
          return {
            pages: R(C.pages, _, O),
            pageParams: R(C.pageParams, P, O)
          };
        };
        if (s && i.length) {
          const C = s === "backward", P = C ? _o : _s, j = {
            pages: i,
            pageParams: a
          }, w = P(n, j);
          o = await x(j, w, C);
        } else {
          const C = t ?? i.length;
          do {
            const P = l === 0 ? a[0] ?? n.initialPageParam : _s(n, o);
            if (l > 0 && P == null)
              break;
            o = await x(o, P), l++;
          } while (l < C);
        }
        return o;
      };
      e.options.persister ? e.fetchFn = () => {
        var y, m;
        return (m = (y = e.options).persister) == null ? void 0 : m.call(
          y,
          u,
          {
            queryKey: e.queryKey,
            meta: e.options.meta,
            signal: e.signal
          },
          r
        );
      } : e.fetchFn = u;
    }
  };
}
function _s(t, { pages: e, pageParams: r }) {
  const n = e.length - 1;
  return e.length > 0 ? t.getNextPageParam(
    e[n],
    e,
    r[n],
    r
  ) : void 0;
}
function _o(t, { pages: e, pageParams: r }) {
  var n;
  return e.length > 0 ? (n = t.getPreviousPageParam) == null ? void 0 : n.call(t, e[0], e, r[0], r) : void 0;
}
function Dh(t, e) {
  return e ? _s(t, e) != null : !1;
}
function Ah(t, e) {
  return !e || !t.getPreviousPageParam ? !1 : _o(t, e) != null;
}
var fe, yt, bt, dr, fr, vt, pr, mr, Ya, kh = (Ya = class {
  constructor(t = {}) {
    L(this, fe, void 0);
    L(this, yt, void 0);
    L(this, bt, void 0);
    L(this, dr, void 0);
    L(this, fr, void 0);
    L(this, vt, void 0);
    L(this, pr, void 0);
    L(this, mr, void 0);
    I(this, fe, t.queryCache || new Th()), I(this, yt, t.mutationCache || new Fh()), I(this, bt, t.defaultOptions || {}), I(this, dr, /* @__PURE__ */ new Map()), I(this, fr, /* @__PURE__ */ new Map()), I(this, vt, 0);
  }
  mount() {
    gn(this, vt)._++, b(this, vt) === 1 && (I(this, pr, ii.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), b(this, fe).onFocus());
    })), I(this, mr, Tn.subscribe(async (t) => {
      t && (await this.resumePausedMutations(), b(this, fe).onOnline());
    })));
  }
  unmount() {
    var t, e;
    gn(this, vt)._--, b(this, vt) === 0 && ((t = b(this, pr)) == null || t.call(this), I(this, pr, void 0), (e = b(this, mr)) == null || e.call(this), I(this, mr, void 0));
  }
  isFetching(t) {
    return b(this, fe).findAll({ ...t, fetchStatus: "fetching" }).length;
  }
  isMutating(t) {
    return b(this, yt).findAll({ ...t, status: "pending" }).length;
  }
  getQueryData(t) {
    var r;
    const e = this.defaultQueryOptions({ queryKey: t });
    return (r = b(this, fe).get(e.queryHash)) == null ? void 0 : r.state.data;
  }
  ensureQueryData(t) {
    const e = this.getQueryData(t.queryKey);
    if (e === void 0)
      return this.fetchQuery(t);
    {
      const r = this.defaultQueryOptions(t), n = b(this, fe).build(this, r);
      return t.revalidateIfStale && n.isStaleByTime(sr(r.staleTime, n)) && this.prefetchQuery(r), Promise.resolve(e);
    }
  }
  getQueriesData(t) {
    return b(this, fe).findAll(t).map(({ queryKey: e, state: r }) => {
      const n = r.data;
      return [e, n];
    });
  }
  setQueryData(t, e, r) {
    const n = this.defaultQueryOptions({ queryKey: t }), s = b(this, fe).get(
      n.queryHash
    ), i = s == null ? void 0 : s.state.data, a = vh(e, i);
    if (a !== void 0)
      return b(this, fe).build(this, n).setData(a, { ...r, manual: !0 });
  }
  setQueriesData(t, e, r) {
    return xe.batch(
      () => b(this, fe).findAll(t).map(({ queryKey: n }) => [
        n,
        this.setQueryData(n, e, r)
      ])
    );
  }
  getQueryState(t) {
    var r;
    const e = this.defaultQueryOptions({ queryKey: t });
    return (r = b(this, fe).get(e.queryHash)) == null ? void 0 : r.state;
  }
  removeQueries(t) {
    const e = b(this, fe);
    xe.batch(() => {
      e.findAll(t).forEach((r) => {
        e.remove(r);
      });
    });
  }
  resetQueries(t, e) {
    const r = b(this, fe), n = {
      type: "active",
      ...t
    };
    return xe.batch(() => (r.findAll(t).forEach((s) => {
      s.reset();
    }), this.refetchQueries(n, e)));
  }
  cancelQueries(t = {}, e = {}) {
    const r = { revert: !0, ...e }, n = xe.batch(
      () => b(this, fe).findAll(t).map((s) => s.cancel(r))
    );
    return Promise.all(n).then(He).catch(He);
  }
  invalidateQueries(t = {}, e = {}) {
    return xe.batch(() => {
      if (b(this, fe).findAll(t).forEach((n) => {
        n.invalidate();
      }), t.refetchType === "none")
        return Promise.resolve();
      const r = {
        ...t,
        type: t.refetchType ?? t.type ?? "active"
      };
      return this.refetchQueries(r, e);
    });
  }
  refetchQueries(t = {}, e) {
    const r = {
      ...e,
      cancelRefetch: (e == null ? void 0 : e.cancelRefetch) ?? !0
    }, n = xe.batch(
      () => b(this, fe).findAll(t).filter((s) => !s.isDisabled()).map((s) => {
        let i = s.fetch(void 0, r);
        return r.throwOnError || (i = i.catch(He)), s.state.fetchStatus === "paused" ? Promise.resolve() : i;
      })
    );
    return Promise.all(n).then(He);
  }
  fetchQuery(t) {
    const e = this.defaultQueryOptions(t);
    e.retry === void 0 && (e.retry = !1);
    const r = b(this, fe).build(this, e);
    return r.isStaleByTime(
      sr(e.staleTime, r)
    ) ? r.fetch(e) : Promise.resolve(r.state.data);
  }
  prefetchQuery(t) {
    return this.fetchQuery(t).then(He).catch(He);
  }
  fetchInfiniteQuery(t) {
    return t.behavior = Nn(t.pages), this.fetchQuery(t);
  }
  prefetchInfiniteQuery(t) {
    return this.fetchInfiniteQuery(t).then(He).catch(He);
  }
  ensureInfiniteQueryData(t) {
    return t.behavior = Nn(t.pages), this.ensureQueryData(t);
  }
  resumePausedMutations() {
    return Tn.isOnline() ? b(this, yt).resumePausedMutations() : Promise.resolve();
  }
  getQueryCache() {
    return b(this, fe);
  }
  getMutationCache() {
    return b(this, yt);
  }
  getDefaultOptions() {
    return b(this, bt);
  }
  setDefaultOptions(t) {
    I(this, bt, t);
  }
  setQueryDefaults(t, e) {
    b(this, dr).set(Hr(t), {
      queryKey: t,
      defaultOptions: e
    });
  }
  getQueryDefaults(t) {
    const e = [...b(this, dr).values()];
    let r = {};
    return e.forEach((n) => {
      Wr(t, n.queryKey) && (r = { ...r, ...n.defaultOptions });
    }), r;
  }
  setMutationDefaults(t, e) {
    b(this, fr).set(Hr(t), {
      mutationKey: t,
      defaultOptions: e
    });
  }
  getMutationDefaults(t) {
    const e = [...b(this, fr).values()];
    let r = {};
    return e.forEach((n) => {
      Wr(t, n.mutationKey) && (r = { ...r, ...n.defaultOptions });
    }), r;
  }
  defaultQueryOptions(t) {
    if (t._defaulted)
      return t;
    const e = {
      ...b(this, bt).queries,
      ...this.getQueryDefaults(t.queryKey),
      ...t,
      _defaulted: !0
    };
    return e.queryHash || (e.queryHash = si(
      e.queryKey,
      e
    )), e.refetchOnReconnect === void 0 && (e.refetchOnReconnect = e.networkMode !== "always"), e.throwOnError === void 0 && (e.throwOnError = !!e.suspense), !e.networkMode && e.persister && (e.networkMode = "offlineFirst"), e.enabled !== !0 && e.queryFn === Pn && (e.enabled = !1), e;
  }
  defaultMutationOptions(t) {
    return t != null && t._defaulted ? t : {
      ...b(this, bt).mutations,
      ...(t == null ? void 0 : t.mutationKey) && this.getMutationDefaults(t.mutationKey),
      ...t,
      _defaulted: !0
    };
  }
  clear() {
    b(this, fe).clear(), b(this, yt).clear();
  }
}, fe = new WeakMap(), yt = new WeakMap(), bt = new WeakMap(), dr = new WeakMap(), fr = new WeakMap(), vt = new WeakMap(), pr = new WeakMap(), mr = new WeakMap(), Ya), je, J, Xr, _e, It, gr, wt, Ze, Gr, yr, br, Mt, Lt, xt, vr, zt, Lr, Jr, Ps, Zr, Ts, en, Ns, tn, js, rn, Fs, nn, Ds, sn, As, An, To, Xa, Po = (Xa = class extends on {
  constructor(e, r) {
    super();
    L(this, zt);
    L(this, Jr);
    L(this, Zr);
    L(this, en);
    L(this, tn);
    L(this, rn);
    L(this, nn);
    L(this, sn);
    L(this, An);
    L(this, je, void 0);
    L(this, J, void 0);
    L(this, Xr, void 0);
    L(this, _e, void 0);
    L(this, It, void 0);
    L(this, gr, void 0);
    L(this, wt, void 0);
    L(this, Ze, void 0);
    L(this, Gr, void 0);
    L(this, yr, void 0);
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    L(this, br, void 0);
    L(this, Mt, void 0);
    L(this, Lt, void 0);
    L(this, xt, void 0);
    L(this, vr, /* @__PURE__ */ new Set());
    this.options = r, I(this, je, e), I(this, Ze, null), I(this, wt, Rs()), this.options.experimental_prefetchInRender || b(this, wt).reject(
      new Error("experimental_prefetchInRender feature flag is not enabled")
    ), this.bindMethods(), this.setOptions(r);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (b(this, J).addObserver(this), oa(b(this, J), this.options) ? G(this, zt, Lr).call(this) : this.updateResult(), G(this, tn, js).call(this));
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return ks(
      b(this, J),
      this.options,
      this.options.refetchOnReconnect
    );
  }
  shouldFetchOnWindowFocus() {
    return ks(
      b(this, J),
      this.options,
      this.options.refetchOnWindowFocus
    );
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), G(this, rn, Fs).call(this), G(this, nn, Ds).call(this), b(this, J).removeObserver(this);
  }
  setOptions(e, r) {
    const n = this.options, s = b(this, J);
    if (this.options = b(this, je).defaultQueryOptions(e), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof Ke(this.options.enabled, b(this, J)) != "boolean")
      throw new Error(
        "Expected enabled to be a boolean or a callback that returns a boolean"
      );
    G(this, sn, As).call(this), b(this, J).setOptions(this.options), n._defaulted && !Es(this.options, n) && b(this, je).getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: b(this, J),
      observer: this
    });
    const i = this.hasListeners();
    i && la(
      b(this, J),
      s,
      this.options,
      n
    ) && G(this, zt, Lr).call(this), this.updateResult(r), i && (b(this, J) !== s || Ke(this.options.enabled, b(this, J)) !== Ke(n.enabled, b(this, J)) || sr(this.options.staleTime, b(this, J)) !== sr(n.staleTime, b(this, J))) && G(this, Jr, Ps).call(this);
    const a = G(this, Zr, Ts).call(this);
    i && (b(this, J) !== s || Ke(this.options.enabled, b(this, J)) !== Ke(n.enabled, b(this, J)) || a !== b(this, xt)) && G(this, en, Ns).call(this, a);
  }
  getOptimisticResult(e) {
    const r = b(this, je).getQueryCache().build(b(this, je), e), n = this.createResult(r, e);
    return Mh(this, n) && (I(this, _e, n), I(this, gr, this.options), I(this, It, b(this, J).state)), n;
  }
  getCurrentResult() {
    return b(this, _e);
  }
  trackResult(e, r) {
    const n = {};
    return Object.keys(e).forEach((s) => {
      Object.defineProperty(n, s, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackProp(s), r == null || r(s), e[s])
      });
    }), n;
  }
  trackProp(e) {
    b(this, vr).add(e);
  }
  getCurrentQuery() {
    return b(this, J);
  }
  refetch({ ...e } = {}) {
    return this.fetch({
      ...e
    });
  }
  fetchOptimistic(e) {
    const r = b(this, je).defaultQueryOptions(e), n = b(this, je).getQueryCache().build(b(this, je), r);
    return n.fetch().then(() => this.createResult(n, r));
  }
  fetch(e) {
    return G(this, zt, Lr).call(this, {
      ...e,
      cancelRefetch: e.cancelRefetch ?? !0
    }).then(() => (this.updateResult(), b(this, _e)));
  }
  createResult(e, r) {
    var O;
    const n = b(this, J), s = this.options, i = b(this, _e), a = b(this, It), o = b(this, gr), u = e !== n ? e.state : b(this, Xr), { state: c } = e;
    let h = { ...c }, d = !1, f;
    if (r._optimisticResults) {
      const R = this.hasListeners(), N = !R && oa(e, r), k = R && la(e, n, r, s);
      (N || k) && (h = {
        ...h,
        ...Ro(c.data, e.options)
      }), r._optimisticResults === "isRestoring" && (h.fetchStatus = "idle");
    }
    let { error: p, errorUpdatedAt: y, status: m } = h;
    if (r.select && h.data !== void 0)
      if (i && h.data === (a == null ? void 0 : a.data) && r.select === b(this, Gr))
        f = b(this, yr);
      else
        try {
          I(this, Gr, r.select), f = r.select(h.data), f = Os(i == null ? void 0 : i.data, f, r), I(this, yr, f), I(this, Ze, null);
        } catch (R) {
          I(this, Ze, R);
        }
    else
      f = h.data;
    if (r.placeholderData !== void 0 && f === void 0 && m === "pending") {
      let R;
      if (i != null && i.isPlaceholderData && r.placeholderData === (o == null ? void 0 : o.placeholderData))
        R = i.data;
      else if (R = typeof r.placeholderData == "function" ? r.placeholderData(
        (O = b(this, br)) == null ? void 0 : O.state.data,
        b(this, br)
      ) : r.placeholderData, r.select && R !== void 0)
        try {
          R = r.select(R), I(this, Ze, null);
        } catch (N) {
          I(this, Ze, N);
        }
      R !== void 0 && (m = "success", f = Os(
        i == null ? void 0 : i.data,
        R,
        r
      ), d = !0);
    }
    b(this, Ze) && (p = b(this, Ze), f = b(this, yr), y = Date.now(), m = "error");
    const S = h.fetchStatus === "fetching", x = m === "pending", C = m === "error", P = x && S, j = f !== void 0, _ = {
      status: m,
      fetchStatus: h.fetchStatus,
      isPending: x,
      isSuccess: m === "success",
      isError: C,
      isInitialLoading: P,
      isLoading: P,
      data: f,
      dataUpdatedAt: h.dataUpdatedAt,
      error: p,
      errorUpdatedAt: y,
      failureCount: h.fetchFailureCount,
      failureReason: h.fetchFailureReason,
      errorUpdateCount: h.errorUpdateCount,
      isFetched: h.dataUpdateCount > 0 || h.errorUpdateCount > 0,
      isFetchedAfterMount: h.dataUpdateCount > u.dataUpdateCount || h.errorUpdateCount > u.errorUpdateCount,
      isFetching: S,
      isRefetching: S && !x,
      isLoadingError: C && !j,
      isPaused: h.fetchStatus === "paused",
      isPlaceholderData: d,
      isRefetchError: C && j,
      isStale: ai(e, r),
      refetch: this.refetch,
      promise: b(this, wt)
    };
    if (this.options.experimental_prefetchInRender) {
      const R = (F) => {
        _.status === "error" ? F.reject(_.error) : _.data !== void 0 && F.resolve(_.data);
      }, N = () => {
        const F = I(this, wt, _.promise = Rs());
        R(F);
      }, k = b(this, wt);
      switch (k.status) {
        case "pending":
          e.queryHash === n.queryHash && R(k);
          break;
        case "fulfilled":
          (_.status === "error" || _.data !== k.value) && N();
          break;
        case "rejected":
          (_.status !== "error" || _.error !== k.reason) && N();
          break;
      }
    }
    return _;
  }
  updateResult(e) {
    const r = b(this, _e), n = this.createResult(b(this, J), this.options);
    if (I(this, It, b(this, J).state), I(this, gr, this.options), b(this, It).data !== void 0 && I(this, br, b(this, J)), Es(n, r))
      return;
    I(this, _e, n);
    const s = {}, i = () => {
      if (!r)
        return !0;
      const { notifyOnChangeProps: a } = this.options, o = typeof a == "function" ? a() : a;
      if (o === "all" || !o && !b(this, vr).size)
        return !0;
      const l = new Set(
        o ?? b(this, vr)
      );
      return this.options.throwOnError && l.add("error"), Object.keys(b(this, _e)).some((u) => {
        const c = u;
        return b(this, _e)[c] !== r[c] && l.has(c);
      });
    };
    (e == null ? void 0 : e.listeners) !== !1 && i() && (s.listeners = !0), G(this, An, To).call(this, { ...s, ...e });
  }
  onQueryUpdate() {
    this.updateResult(), this.hasListeners() && G(this, tn, js).call(this);
  }
}, je = new WeakMap(), J = new WeakMap(), Xr = new WeakMap(), _e = new WeakMap(), It = new WeakMap(), gr = new WeakMap(), wt = new WeakMap(), Ze = new WeakMap(), Gr = new WeakMap(), yr = new WeakMap(), br = new WeakMap(), Mt = new WeakMap(), Lt = new WeakMap(), xt = new WeakMap(), vr = new WeakMap(), zt = new WeakSet(), Lr = function(e) {
  G(this, sn, As).call(this);
  let r = b(this, J).fetch(
    this.options,
    e
  );
  return e != null && e.throwOnError || (r = r.catch(He)), r;
}, Jr = new WeakSet(), Ps = function() {
  G(this, rn, Fs).call(this);
  const e = sr(
    this.options.staleTime,
    b(this, J)
  );
  if ($t || b(this, _e).isStale || !xs(e))
    return;
  const n = wo(b(this, _e).dataUpdatedAt, e) + 1;
  I(this, Mt, setTimeout(() => {
    b(this, _e).isStale || this.updateResult();
  }, n));
}, Zr = new WeakSet(), Ts = function() {
  return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(b(this, J)) : this.options.refetchInterval) ?? !1;
}, en = new WeakSet(), Ns = function(e) {
  G(this, nn, Ds).call(this), I(this, xt, e), !($t || Ke(this.options.enabled, b(this, J)) === !1 || !xs(b(this, xt)) || b(this, xt) === 0) && I(this, Lt, setInterval(() => {
    (this.options.refetchIntervalInBackground || ii.isFocused()) && G(this, zt, Lr).call(this);
  }, b(this, xt)));
}, tn = new WeakSet(), js = function() {
  G(this, Jr, Ps).call(this), G(this, en, Ns).call(this, G(this, Zr, Ts).call(this));
}, rn = new WeakSet(), Fs = function() {
  b(this, Mt) && (clearTimeout(b(this, Mt)), I(this, Mt, void 0));
}, nn = new WeakSet(), Ds = function() {
  b(this, Lt) && (clearInterval(b(this, Lt)), I(this, Lt, void 0));
}, sn = new WeakSet(), As = function() {
  const e = b(this, je).getQueryCache().build(b(this, je), this.options);
  if (e === b(this, J))
    return;
  const r = b(this, J);
  I(this, J, e), I(this, Xr, e.state), this.hasListeners() && (r == null || r.removeObserver(this), e.addObserver(this));
}, An = new WeakSet(), To = function(e) {
  xe.batch(() => {
    e.listeners && this.listeners.forEach((r) => {
      r(b(this, _e));
    }), b(this, je).getQueryCache().notify({
      query: b(this, J),
      type: "observerResultsUpdated"
    });
  });
}, Xa);
function Ih(t, e) {
  return Ke(e.enabled, t) !== !1 && t.state.data === void 0 && !(t.state.status === "error" && e.retryOnMount === !1);
}
function oa(t, e) {
  return Ih(t, e) || t.state.data !== void 0 && ks(t, e, e.refetchOnMount);
}
function ks(t, e, r) {
  if (Ke(e.enabled, t) !== !1) {
    const n = typeof r == "function" ? r(t) : r;
    return n === "always" || n !== !1 && ai(t, e);
  }
  return !1;
}
function la(t, e, r, n) {
  return (t !== e || Ke(n.enabled, t) === !1) && (!r.suspense || t.state.status !== "error") && ai(t, r);
}
function ai(t, e) {
  return Ke(e.enabled, t) !== !1 && t.isStaleByTime(sr(e.staleTime, t));
}
function Mh(t, e) {
  return !Es(t.getCurrentResult(), e);
}
var Lh = class extends Po {
  constructor(t, e) {
    super(t, e);
  }
  bindMethods() {
    super.bindMethods(), this.fetchNextPage = this.fetchNextPage.bind(this), this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }
  setOptions(t, e) {
    super.setOptions(
      {
        ...t,
        behavior: Nn()
      },
      e
    );
  }
  getOptimisticResult(t) {
    return t.behavior = Nn(), super.getOptimisticResult(t);
  }
  fetchNextPage(t) {
    return this.fetch({
      ...t,
      meta: {
        fetchMore: { direction: "forward" }
      }
    });
  }
  fetchPreviousPage(t) {
    return this.fetch({
      ...t,
      meta: {
        fetchMore: { direction: "backward" }
      }
    });
  }
  createResult(t, e) {
    var p, y;
    const { state: r } = t, n = super.createResult(t, e), { isFetching: s, isRefetching: i, isError: a, isRefetchError: o } = n, l = (y = (p = r.fetchMeta) == null ? void 0 : p.fetchMore) == null ? void 0 : y.direction, u = a && l === "forward", c = s && l === "forward", h = a && l === "backward", d = s && l === "backward";
    return {
      ...n,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: Dh(e, r.data),
      hasPreviousPage: Ah(e, r.data),
      isFetchNextPageError: u,
      isFetchingNextPage: c,
      isFetchPreviousPageError: h,
      isFetchingPreviousPage: d,
      isRefetchError: o && !u && !h,
      isRefetching: i && !c && !d
    };
  }
}, No = Se.createContext(
  void 0
), zn = (t) => {
  const e = Se.useContext(No);
  if (!e)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
}, zh = ({
  client: t,
  children: e
}) => (Se.useEffect(() => (t.mount(), () => {
  t.unmount();
}), [t]), /* @__PURE__ */ v.jsx(No.Provider, { value: t, children: e })), jo = Se.createContext(!1), Uh = () => Se.useContext(jo);
jo.Provider;
function Bh() {
  let t = !1;
  return {
    clearReset: () => {
      t = !1;
    },
    reset: () => {
      t = !0;
    },
    isReset: () => t
  };
}
var $h = Se.createContext(Bh()), Hh = () => Se.useContext($h);
function Wh(t, e) {
  return typeof t == "function" ? t(...e) : !!t;
}
function Vh() {
}
var qh = (t, e) => {
  (t.suspense || t.throwOnError || t.experimental_prefetchInRender) && (e.isReset() || (t.retryOnMount = !1));
}, Kh = (t) => {
  Se.useEffect(() => {
    t.clearReset();
  }, [t]);
}, Qh = ({
  result: t,
  errorResetBoundary: e,
  throwOnError: r,
  query: n
}) => t.isError && !e.isReset() && !t.isFetching && n && Wh(r, [t.error, n]), Yh = (t) => {
  t.suspense && (t.staleTime === void 0 && (t.staleTime = 1e3), typeof t.gcTime == "number" && (t.gcTime = Math.max(t.gcTime, 1e3)));
}, Xh = (t, e) => t.isLoading && t.isFetching && !e, Gh = (t, e) => (t == null ? void 0 : t.suspense) && e.isPending, ca = (t, e, r) => e.fetchOptimistic(t).catch(() => {
  r.clearReset();
});
function Fo(t, e, r) {
  var c, h, d, f, p;
  if (process.env.NODE_ENV !== "production" && (typeof t != "object" || Array.isArray(t)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const n = zn(), s = Uh(), i = Hh(), a = n.defaultQueryOptions(t);
  (h = (c = n.getDefaultOptions().queries) == null ? void 0 : c._experimental_beforeQuery) == null || h.call(
    c,
    a
  ), a._optimisticResults = s ? "isRestoring" : "optimistic", Yh(a), qh(a, i), Kh(i);
  const o = !n.getQueryCache().get(a.queryHash), [l] = Se.useState(
    () => new e(
      n,
      a
    )
  ), u = l.getOptimisticResult(a);
  if (Se.useSyncExternalStore(
    Se.useCallback(
      (y) => {
        const m = s ? () => {
        } : l.subscribe(xe.batchCalls(y));
        return l.updateResult(), m;
      },
      [l, s]
    ),
    () => l.getCurrentResult(),
    () => l.getCurrentResult()
  ), Se.useEffect(() => {
    l.setOptions(a, { listeners: !1 });
  }, [a, l]), Gh(a, u))
    throw ca(a, l, i);
  if (Qh({
    result: u,
    errorResetBoundary: i,
    throwOnError: a.throwOnError,
    query: n.getQueryCache().get(a.queryHash)
  }))
    throw u.error;
  if ((f = (d = n.getDefaultOptions().queries) == null ? void 0 : d._experimental_afterQuery) == null || f.call(
    d,
    a,
    u
  ), a.experimental_prefetchInRender && !$t && Xh(u, s)) {
    const y = o ? (
      // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
      ca(a, l, i)
    ) : (
      // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
      (p = n.getQueryCache().get(a.queryHash)) == null ? void 0 : p.promise
    );
    y == null || y.catch(Vh).finally(() => {
      l.updateResult();
    });
  }
  return a.notifyOnChangeProps ? u : l.trackResult(u);
}
function Do(t, e) {
  return Fo(t, Po);
}
function Jh(t, e) {
  return Fo(
    t,
    Lh
  );
}
const Zh = new kh({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchInterval: !1,
      refetchOnWindowFocus: !1,
      refetchOnMount: !1,
      refetchIntervalInBackground: !1
    }
  }
});
function dm({ children: t }) {
  return /* @__PURE__ */ v.jsx(zh, { client: Zh, children: t });
}
const ed = Ga(null), fm = ({
  children: t,
  languageCode: e
}) => {
  const [r, n] = te(e), s = Yl((i) => {
    ye.hasResourceBundle(i, ri) ? (ye.changeLanguage(i), n(i)) : ah(i).then(() => {
      ye.changeLanguage(i), n(i);
    });
  }, []);
  return We(() => {
    ye.isInitialized && s(e);
  }, [e, s]), /* @__PURE__ */ v.jsx(ed.Provider, { value: { currentLanguageCode: r, changeLocale: s }, children: t });
}, Ao = async ({
  startFrom: t,
  limit: e,
  order: r,
  sortColumn: n,
  sortDirection: s,
  filter: i
}) => {
  var o, l;
  return (await ni.get(
    "/api/dashboard/customer/data-files?" + (i != null && i.name ? `&filter[names][]=${i == null ? void 0 : i.name}` : "") + ((o = i == null ? void 0 : i.source) != null && o.length ? i.source.map((u) => `&filter[sources][]=${encodeURIComponent(u)}`).join("") : "") + ((l = i == null ? void 0 : i.type) != null && l.length ? i.type.map((u) => `&filter[types][]=${encodeURIComponent(u)}`).join("") : "") + (t ? `&pagination[startFrom]=${t}` : "") + (n ? `&pagination[sortColumn]=${n}` : "") + (s ? `&pagination[sortDirection]=${s}` : "") + (e ? `&pagination[limit]=${e}` : "") + (r ? `&pagination[order]=${r}` : "")
  )).data;
}, pm = ({
  startFrom: t,
  limit: e = 10,
  order: r = ei.Next,
  sortColumn: n,
  sortDirection: s,
  filter: i
}, a) => {
  const o = zn(), l = ["data-files"], u = [
    "data-files",
    { startFrom: t, limit: e, order: r, sortColumn: n, sortDirection: s, filter: i }
  ];
  return {
    ...Do({
      queryKey: u,
      queryFn: () => Ao({ startFrom: t, limit: e, order: r, sortColumn: n, sortDirection: s, filter: i }),
      ...a
    }),
    resetAndRefetch: () => {
      o.invalidateQueries({ queryKey: l });
    },
    triggerFetch: () => {
      o.fetchQuery({ queryKey: u });
    },
    deleteItemFromData: (y) => {
      o.getQueryCache().findAll({ queryKey: l }).forEach((S) => {
        o.setQueryData(
          S.queryKey,
          (x) => {
            if (x)
              return {
                ...x,
                items: x.items.filter((C) => C.id !== y)
              };
          }
        );
      });
    },
    renameItemFromData: ({ id: y, name: m }) => {
      o.getQueryCache().findAll({ queryKey: l }).forEach((x) => {
        o.setQueryData(
          x.queryKey,
          (C) => {
            if (C)
              return {
                ...C,
                items: C.items.map((P) => P.id === y ? { ...P, name: m } : P)
              };
          }
        );
      });
    }
  };
}, td = ({
  limit: t = 10,
  order: e = ei.Next,
  sortColumn: r,
  sortDirection: n,
  filter: s
}, i) => {
  const a = zn(), o = [
    "infinite-data-files",
    { limit: t, order: e, sortColumn: r, sortDirection: n, filter: s }
  ];
  return { ...Jh({
    initialPageParam: void 0,
    queryKey: o,
    queryFn: ({ pageParam: d }) => Ao({
      startFrom: typeof d == "string" ? d : void 0,
      limit: t,
      order: e,
      sortColumn: r,
      sortDirection: n,
      filter: s
    }),
    getPreviousPageParam: (d) => {
      if (!d.hasMore)
        return;
      const f = d.items[0];
      if (f)
        return encodeURIComponent(
          JSON.stringify({
            id: f.id,
            field: f[r ?? "name"]
          })
        );
    },
    getNextPageParam: (d) => {
      if (!d.hasMore)
        return;
      const f = d.items[d.items.length - 1];
      if (f)
        return encodeURIComponent(
          JSON.stringify({
            id: f.id,
            field: f[r ?? "name"]
          })
        );
    },
    ...i
  }), resetAndRefetch: () => {
    a.invalidateQueries({ queryKey: o });
  }, deleteItemFromData: (d) => {
    a.setQueryData(o, (f) => f && {
      ...f,
      pages: f.pages.map((p) => ({
        ...p,
        items: p.items.filter((y) => y.id !== d)
      }))
    });
  }, renameItemFromData: ({ id: d, name: f }) => {
    a.setQueryData(o, (p) => p && {
      ...p,
      pages: p.pages.map((y) => ({
        ...y,
        items: y.items.map((m) => m.id === d ? { ...m, name: f } : m)
      }))
    });
  } };
}, rd = ({ id: t }, e) => {
  const r = zn(), n = ["file-details", { id: t }];
  return { ...Do({
    queryKey: n,
    retry: !1,
    refetchInterval: !1,
    refetchOnWindowFocus: !1,
    enabled: typeof t < "u",
    queryFn: async ({ queryKey: a }) => {
      const [, { id: o }] = a;
      return (await ni.get("/api/dashboard/customer/data-files/" + o)).data;
    },
    ...e
  }), resetAndRefetch: () => {
    r.invalidateQueries({ queryKey: n });
  } };
}, nd = () => {
  const { fetcher: t } = nr({
    method: tr.delete
  }), { fetcher: e } = nr({
    method: tr.get
  }), { fetcher: r } = nr({
    method: tr.post
  });
  return { deleteFile: async ({ id: a }) => {
    await t("/api/dashboard/customer/data-files/" + a);
  }, downloadFile: async ({ id: a }) => {
    const { link: o } = await e(`/api/dashboard/customer/data-files/${a}/download-link`), l = document.createElement("a");
    l.setAttribute("href", o), l.setAttribute("download", ""), l.click();
  }, renameFile: async ({ id: a, name: o }) => await r(`/api/dashboard/customer/data-files/${a}/rename`, {
    name: o
  }) };
};
function sd({
  isFetching: t,
  values: e,
  disabled: r,
  disabledFileSourceSelect: n,
  disabledFileTypeSelect: s,
  onChange: i,
  onSubmit: a
}) {
  const { t: o } = Pe();
  return /* @__PURE__ */ v.jsxs(
    "form",
    {
      onSubmit: (l) => {
        l.preventDefault(), l.stopPropagation(), a();
      },
      className: "flex flex-col gap-2 sm:grid sm:grid-cols-2 lg:flex lg:flex-row lg:items-end lg:flex-wrap",
      children: [
        /* @__PURE__ */ v.jsx(
          sc,
          {
            disabled: t || r,
            label: o("file_manager.file_selector.search_file"),
            placeholder: o("file_manager.search"),
            value: e.name,
            onClear: () => i == null ? void 0 : i({ ...e, name: "" }),
            onChange: (l) => i == null ? void 0 : i({ ...e, name: l.target.value }),
            showSearchIcon: !0,
            className: "lg:flex-2",
            labelClassName: "text-text-primary text-lg font-bold",
            searchIconClassName: "left-3 top-[31px]",
            closeIconClassName: "top-[31px]",
            inputClassName: "!pl-[40px] pr-4"
          }
        ),
        /* @__PURE__ */ v.jsx(
          _i,
          {
            disabled: t || r || n,
            placeholder: o("file_manager.select_source"),
            value: e.source,
            data: Object.values(oe).filter((l) => l !== oe.BlockPreview && l !== oe.Community).map((l) => ({
              id: l,
              caption: o(Sc[l])
            })),
            onChange: (l) => i == null ? void 0 : i({ ...e, source: l }),
            containerClassName: "self-auto sm:self-end"
          }
        ),
        /* @__PURE__ */ v.jsx(
          _i,
          {
            disabled: t || r || s,
            placeholder: o("file_manager.select_type"),
            value: e.type,
            data: Object.values(ie).map((l) => ({
              id: l,
              caption: o(Ec[l])
            })),
            onChange: (l) => i == null ? void 0 : i({ ...e, type: l }),
            containerClassName: "self-auto sm:self-end"
          }
        ),
        /* @__PURE__ */ v.jsx(
          an,
          {
            type: "submit",
            isFetching: t,
            disabled: r,
            className: "min-w-14",
            children: o("file_manager.search")
          }
        )
      ]
    }
  );
}
function Gt(t, e, r) {
  let n = r.initialDeps ?? [], s;
  return () => {
    var i, a, o, l;
    let u;
    r.key && ((i = r.debug) != null && i.call(r)) && (u = Date.now());
    const c = t();
    if (!(c.length !== n.length || c.some((f, p) => n[p] !== f)))
      return s;
    n = c;
    let d;
    if (r.key && ((a = r.debug) != null && a.call(r)) && (d = Date.now()), s = e(...c), r.key && ((o = r.debug) != null && o.call(r))) {
      const f = Math.round((Date.now() - u) * 100) / 100, p = Math.round((Date.now() - d) * 100) / 100, y = p / 16, m = (S, x) => {
        for (S = String(S); S.length < x; )
          S = " " + S;
        return S;
      };
      console.info(
        `%c⏱ ${m(p, 5)} /${m(f, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * y, 120)
        )}deg 100% 31%);`,
        r == null ? void 0 : r.key
      );
    }
    return (l = r == null ? void 0 : r.onChange) == null || l.call(r, s), s;
  };
}
function is(t, e) {
  if (t === void 0)
    throw new Error("Unexpected undefined");
  return t;
}
const id = (t, e) => Math.abs(t - e) < 1, ad = (t, e, r) => {
  let n;
  return function(...s) {
    t.clearTimeout(n), n = t.setTimeout(() => e.apply(this, s), r);
  };
}, od = (t) => t, ld = (t) => {
  const e = Math.max(t.startIndex - t.overscan, 0), r = Math.min(t.endIndex + t.overscan, t.count - 1), n = [];
  for (let s = e; s <= r; s++)
    n.push(s);
  return n;
}, cd = (t, e) => {
  const r = t.scrollElement;
  if (!r)
    return;
  const n = t.targetWindow;
  if (!n)
    return;
  const s = (a) => {
    const { width: o, height: l } = a;
    e({ width: Math.round(o), height: Math.round(l) });
  };
  if (s(r.getBoundingClientRect()), !n.ResizeObserver)
    return () => {
    };
  const i = new n.ResizeObserver((a) => {
    const o = a[0];
    if (o != null && o.borderBoxSize) {
      const l = o.borderBoxSize[0];
      if (l) {
        s({ width: l.inlineSize, height: l.blockSize });
        return;
      }
    }
    s(r.getBoundingClientRect());
  });
  return i.observe(r, { box: "border-box" }), () => {
    i.unobserve(r);
  };
}, ua = {
  passive: !0
}, ud = typeof window > "u" ? !0 : "onscrollend" in window, hd = (t, e) => {
  const r = t.scrollElement;
  if (!r)
    return;
  const n = t.targetWindow;
  if (!n)
    return;
  let s = 0;
  const i = ud ? () => {
  } : ad(
    n,
    () => {
      e(s, !1);
    },
    t.options.isScrollingResetDelay
  ), a = (u) => () => {
    const { horizontal: c, isRtl: h } = t.options;
    s = c ? r.scrollLeft * (h && -1 || 1) : r.scrollTop, i(), e(s, u);
  }, o = a(!0), l = a(!1);
  return l(), r.addEventListener("scroll", o, ua), r.addEventListener("scrollend", l, ua), () => {
    r.removeEventListener("scroll", o), r.removeEventListener("scrollend", l);
  };
}, dd = (t, e, r) => {
  if (e != null && e.borderBoxSize) {
    const n = e.borderBoxSize[0];
    if (n)
      return Math.round(
        n[r.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    t.getBoundingClientRect()[r.options.horizontal ? "width" : "height"]
  );
}, fd = (t, {
  adjustments: e = 0,
  behavior: r
}, n) => {
  var s, i;
  const a = t + e;
  (i = (s = n.scrollElement) == null ? void 0 : s.scrollTo) == null || i.call(s, {
    [n.options.horizontal ? "left" : "top"]: a,
    behavior: r
  });
};
class pd {
  constructor(e) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let r = null;
      const n = () => r || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : r = new this.targetWindow.ResizeObserver((s) => {
        s.forEach((i) => {
          this._measureElement(i.target, i);
        });
      }));
      return {
        disconnect: () => {
          var s;
          (s = n()) == null || s.disconnect(), r = null;
        },
        observe: (s) => {
          var i;
          return (i = n()) == null ? void 0 : i.observe(s, { box: "border-box" });
        },
        unobserve: (s) => {
          var i;
          return (i = n()) == null ? void 0 : i.unobserve(s);
        }
      };
    })(), this.range = null, this.setOptions = (r) => {
      Object.entries(r).forEach(([n, s]) => {
        typeof s > "u" && delete r[n];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: od,
        rangeExtractor: ld,
        onChange: () => {
        },
        measureElement: dd,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        ...r
      };
    }, this.notify = (r) => {
      var n, s;
      (s = (n = this.options).onChange) == null || s.call(n, this, r);
    }, this.maybeNotify = Gt(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (r) => {
        this.notify(r);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((r) => r()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var r;
      const n = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== n) {
        if (this.cleanup(), !n) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = n, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((r = this.scrollElement) == null ? void 0 : r.window) ?? null, this.elementsCache.forEach((s) => {
          this.observer.observe(s);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (s) => {
            this.scrollRect = s, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (s, i) => {
            this.scrollAdjustments = 0, this.scrollDirection = i ? this.getScrollOffset() < s ? "forward" : "backward" : null, this.scrollOffset = s, this.isScrolling = i, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (r, n) => {
      const s = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let a = n - 1; a >= 0; a--) {
        const o = r[a];
        if (s.has(o.lane))
          continue;
        const l = i.get(
          o.lane
        );
        if (l == null || o.end > l.end ? i.set(o.lane, o) : o.end < l.end && s.set(o.lane, !0), s.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((a, o) => a.end === o.end ? a.index - o.index : a.end - o.end)[0] : void 0;
    }, this.getMeasurementOptions = Gt(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (r, n, s, i, a) => (this.pendingMeasuredCacheIndexes = [], {
        count: r,
        paddingStart: n,
        scrollMargin: s,
        getItemKey: i,
        enabled: a
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Gt(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: r, paddingStart: n, scrollMargin: s, getItemKey: i, enabled: a }, o) => {
        if (!a)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((c) => {
          this.itemSizeCache.set(c.key, c.size);
        }));
        const l = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const u = this.measurementsCache.slice(0, l);
        for (let c = l; c < r; c++) {
          const h = i(c), d = this.options.lanes === 1 ? u[c - 1] : this.getFurthestMeasurement(u, c), f = d ? d.end + this.options.gap : n + s, p = o.get(h), y = typeof p == "number" ? p : this.options.estimateSize(c), m = f + y, S = d ? d.lane : c % this.options.lanes;
          u[c] = {
            index: c,
            start: f,
            size: y,
            end: m,
            key: h,
            lane: S
          };
        }
        return this.measurementsCache = u, u;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Gt(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (r, n, s) => this.range = r.length > 0 && n > 0 ? md({
        measurements: r,
        outerSize: n,
        scrollOffset: s
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = Gt(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (r, n, s, i) => n === null ? [] : r({
        startIndex: n.startIndex,
        endIndex: n.endIndex,
        overscan: s,
        count: i
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (r) => {
      const n = this.options.indexAttribute, s = r.getAttribute(n);
      return s ? parseInt(s, 10) : (console.warn(
        `Missing attribute name '${n}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (r, n) => {
      const s = this.indexFromElement(r), i = this.measurementsCache[s];
      if (!i)
        return;
      const a = i.key, o = this.elementsCache.get(a);
      o !== r && (o && this.observer.unobserve(o), this.observer.observe(r), this.elementsCache.set(a, r)), r.isConnected && this.resizeItem(s, this.options.measureElement(r, n, this));
    }, this.resizeItem = (r, n) => {
      const s = this.measurementsCache[r];
      if (!s)
        return;
      const i = this.itemSizeCache.get(s.key) ?? s.size, a = n - i;
      a !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(s, a, this) : s.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", a), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += a,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(s.index), this.itemSizeCache = new Map(this.itemSizeCache.set(s.key, n)), this.notify(!1));
    }, this.measureElement = (r) => {
      if (!r) {
        this.elementsCache.forEach((n, s) => {
          n.isConnected || (this.observer.unobserve(n), this.elementsCache.delete(s));
        });
        return;
      }
      this._measureElement(r, void 0);
    }, this.getVirtualItems = Gt(
      () => [this.getIndexes(), this.getMeasurements()],
      (r, n) => {
        const s = [];
        for (let i = 0, a = r.length; i < a; i++) {
          const o = r[i], l = n[o];
          s.push(l);
        }
        return s;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (r) => {
      const n = this.getMeasurements();
      if (n.length !== 0)
        return is(
          n[ko(
            0,
            n.length - 1,
            (s) => is(n[s]).start,
            r
          )]
        );
    }, this.getOffsetForAlignment = (r, n) => {
      const s = this.getSize(), i = this.getScrollOffset();
      n === "auto" && (r <= i ? n = "start" : r >= i + s ? n = "end" : n = "start"), n === "start" ? r = r : n === "end" ? r = r - s : n === "center" && (r = r - s / 2);
      const a = this.options.horizontal ? "scrollWidth" : "scrollHeight", l = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[a] : this.scrollElement[a] : 0) - s;
      return Math.max(Math.min(l, r), 0);
    }, this.getOffsetForIndex = (r, n = "auto") => {
      r = Math.max(0, Math.min(r, this.options.count - 1));
      const s = this.measurementsCache[r];
      if (!s)
        return;
      const i = this.getSize(), a = this.getScrollOffset();
      if (n === "auto")
        if (s.end >= a + i - this.options.scrollPaddingEnd)
          n = "end";
        else if (s.start <= a + this.options.scrollPaddingStart)
          n = "start";
        else
          return [a, n];
      const o = n === "end" ? s.end + this.options.scrollPaddingEnd : s.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(o, n), n];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (r, { align: n = "start", behavior: s } = {}) => {
      this.cancelScrollToIndex(), s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(r, n), {
        adjustments: void 0,
        behavior: s
      });
    }, this.scrollToIndex = (r, { align: n = "auto", behavior: s } = {}) => {
      r = Math.max(0, Math.min(r, this.options.count - 1)), this.cancelScrollToIndex(), s === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const i = this.getOffsetForIndex(r, n);
      if (!i)
        return;
      const [a, o] = i;
      this._scrollToOffset(a, { adjustments: void 0, behavior: s }), s !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(r)
        )) {
          const [u] = is(
            this.getOffsetForIndex(r, o)
          );
          id(u, this.getScrollOffset()) || this.scrollToIndex(r, { align: o, behavior: s });
        } else
          this.scrollToIndex(r, { align: o, behavior: s });
      }));
    }, this.scrollBy = (r, { behavior: n } = {}) => {
      this.cancelScrollToIndex(), n === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + r, {
        adjustments: void 0,
        behavior: n
      });
    }, this.getTotalSize = () => {
      var r;
      const n = this.getMeasurements();
      let s;
      return n.length === 0 ? s = this.options.paddingStart : s = this.options.lanes === 1 ? ((r = n[n.length - 1]) == null ? void 0 : r.end) ?? 0 : Math.max(
        ...n.slice(-this.options.lanes).map((i) => i.end)
      ), Math.max(
        s - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (r, {
      adjustments: n,
      behavior: s
    }) => {
      this.options.scrollToFn(r, { behavior: s, adjustments: n }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(e);
  }
}
const ko = (t, e, r, n) => {
  for (; t <= e; ) {
    const s = (t + e) / 2 | 0, i = r(s);
    if (i < n)
      t = s + 1;
    else if (i > n)
      e = s - 1;
    else
      return s;
  }
  return t > 0 ? t - 1 : 0;
};
function md({
  measurements: t,
  outerSize: e,
  scrollOffset: r
}) {
  const n = t.length - 1, i = ko(0, n, (o) => t[o].start, r);
  let a = i;
  for (; a < n && t[a].end < r + e; )
    a++;
  return { startIndex: i, endIndex: a };
}
const gd = typeof document < "u" ? Se.useLayoutEffect : Se.useEffect;
function yd(t) {
  const e = Se.useReducer(() => ({}), {})[1], r = {
    ...t,
    onChange: (s, i) => {
      var a;
      i ? bc(e) : e(), (a = t.onChange) == null || a.call(t, s, i);
    }
  }, [n] = Se.useState(
    () => new pd(r)
  );
  return n.setOptions(r), Se.useEffect(() => n._didMount(), []), gd(() => n._willUpdate()), n;
}
function ha(t) {
  return yd({
    observeElementRect: cd,
    observeElementOffset: hd,
    scrollToFn: fd,
    ...t
  });
}
const Is = 2, bd = 6, vd = Is * 2 + bd;
function wd({
  initialItemWidth: t = 150,
  initialItemHeight: e = 180,
  rowGap: r = 18,
  columnGap: n = 16,
  columnCount: s = 6,
  dataFilesApi: i,
  specialElementInGrid: a,
  onSelect: o,
  onDetails: l,
  onDelete: u,
  onRename: c,
  onDownload: h
}) {
  var ce;
  const d = Ae.useRef(null), f = Ae.useRef(null), [p, y] = te(s), [m, S] = te(t), [x, C] = te(e), [P, j] = te(), { data: w, fetchNextPage: _, hasNextPage: O, isFetchingNextPage: R, isFetching: N } = i, k = "specialElementInGridId", F = a ? p >= 2 ? [k, k] : [k] : [], U = [...F, ...((ce = w == null ? void 0 : w.pages) == null ? void 0 : ce.flatMap(($) => $.items)) ?? []], z = U.length;
  We(() => {
    const $ = () => {
      if (d.current) {
        const ne = d.current.offsetWidth - vd, W = Math.floor(ne / (t + n));
        y(W || 1);
        const A = (ne - n * (W - 1)) / W;
        S(A), C(A / t * e);
      }
    };
    $();
    const K = new ResizeObserver($);
    return d.current && K.observe(d.current), () => K.disconnect();
  }, [t, e, n]);
  const M = ha({
    count: Math.ceil(z / p),
    gap: r,
    getScrollElement: () => d.current,
    estimateSize: () => x
  }), re = ha({
    count: p,
    gap: n,
    getScrollElement: () => d.current,
    estimateSize: () => m,
    horizontal: !0
  });
  return We(() => {
    if (!f.current || !O || R)
      return;
    const $ = new IntersectionObserver(
      (K) => {
        K[0].isIntersecting && _();
      },
      { root: d.current, threshold: 0.1 }
    );
    return $.observe(f.current), () => {
      f.current && $.unobserve(f.current);
    };
  }, [_, O, R]), We(() => {
    const $ = U.filter(xc).find((K) => K.id === P);
    o == null || o($);
  }, [P]), /* @__PURE__ */ v.jsxs(
    "div",
    {
      ref: d,
      className: "relative overflow-auto w-full h-[400px] customScroll",
      style: { paddingTop: Is, paddingLeft: Is },
      children: [
        /* @__PURE__ */ v.jsxs(
          "div",
          {
            style: {
              height: M.getTotalSize(),
              width: re.getTotalSize()
            },
            className: "relative",
            children: [
              N && !R ? Array.from({ length: 10 }).map(($, K) => /* @__PURE__ */ v.jsx(
                "div",
                {
                  className: "absolute bg-background-tertiary animate-pulse rounded-md",
                  style: {
                    top: Math.floor(K / p) * (x + r),
                    left: K % p * (m + n),
                    height: x,
                    width: m
                  }
                },
                K
              )) : M.getVirtualItems().map(
                ($) => re.getVirtualItems().map((K) => {
                  const ne = $.index * p + K.index, W = U[ne];
                  if (!W)
                    return null;
                  let A = Math.floor(ne / p) * (x + r);
                  const Q = ne % p * (m + n);
                  let Z = 0;
                  switch (p) {
                    case 1:
                      Z = 180;
                      break;
                    case 2:
                      Z = 80;
                      break;
                  }
                  return a && (A = A - Z), k === W ? ne === 0 ? /* @__PURE__ */ v.jsx(
                    "div",
                    {
                      style: {
                        top: 0,
                        left: 0,
                        height: x - Z,
                        width: m * F.length + n * (F.length - 1)
                      },
                      children: a
                    },
                    W + ne
                  ) : null : /* @__PURE__ */ v.jsx(
                    iu,
                    {
                      src: W.thumbnail ?? W.path ?? void 0,
                      alt: W.name,
                      name: W.name,
                      imageWidth: m,
                      imageHeight: m * 0.869,
                      secondaryText: W.type,
                      fileType: W.type,
                      style: {
                        top: A,
                        left: Q,
                        height: x,
                        width: m
                      },
                      selected: P === W.id,
                      onSelect: (Te) => {
                        j(Te ? W.id : void 0);
                      },
                      className: "absolute",
                      actionMenu: {
                        menuItems: [
                          l ? /* @__PURE__ */ v.jsx(
                            mh,
                            {
                              onClick: () => l(W)
                            },
                            "details"
                          ) : void 0,
                          u ? /* @__PURE__ */ v.jsx(
                            gh,
                            {
                              onClick: () => u(W)
                            },
                            "delete"
                          ) : void 0,
                          c ? /* @__PURE__ */ v.jsx(
                            yh,
                            {
                              onClick: () => c(W)
                            },
                            "rename"
                          ) : void 0,
                          h ? /* @__PURE__ */ v.jsx(
                            bh,
                            {
                              onClick: () => h(W)
                            },
                            "download"
                          ) : void 0
                        ].filter(Boolean)
                      }
                    },
                    W.id
                  );
                })
              ),
              O && /* @__PURE__ */ v.jsx("div", { ref: f, className: "absolute bottom-0" })
            ]
          }
        ),
        /* @__PURE__ */ v.jsx("div", { className: "flex items-center justify-center w-full pt-4 h-11", children: R && /* @__PURE__ */ v.jsx(ic, {}) })
      ]
    }
  );
}
function Io(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: xd } = Object.prototype, { getPrototypeOf: oi } = Object, Un = /* @__PURE__ */ ((t) => (e) => {
  const r = xd.call(e);
  return t[r] || (t[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Ye = (t) => (t = t.toLowerCase(), (e) => Un(e) === t), Bn = (t) => (e) => typeof e === t, { isArray: xr } = Array, Vr = Bn("undefined");
function Sd(t) {
  return t !== null && !Vr(t) && t.constructor !== null && !Vr(t.constructor) && ze(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const Mo = Ye("ArrayBuffer");
function Ed(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && Mo(t.buffer), e;
}
const Cd = Bn("string"), ze = Bn("function"), Lo = Bn("number"), $n = (t) => t !== null && typeof t == "object", Od = (t) => t === !0 || t === !1, xn = (t) => {
  if (Un(t) !== "object")
    return !1;
  const e = oi(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, Rd = Ye("Date"), _d = Ye("File"), Pd = Ye("Blob"), Td = Ye("FileList"), Nd = (t) => $n(t) && ze(t.pipe), jd = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || ze(t.append) && ((e = Un(t)) === "formdata" || // detect form-data instance
  e === "object" && ze(t.toString) && t.toString() === "[object FormData]"));
}, Fd = Ye("URLSearchParams"), [Dd, Ad, kd, Id] = ["ReadableStream", "Request", "Response", "Headers"].map(Ye), Md = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ln(t, e, { allOwnKeys: r = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let n, s;
  if (typeof t != "object" && (t = [t]), xr(t))
    for (n = 0, s = t.length; n < s; n++)
      e.call(null, t[n], n, t);
  else {
    const i = r ? Object.getOwnPropertyNames(t) : Object.keys(t), a = i.length;
    let o;
    for (n = 0; n < a; n++)
      o = i[n], e.call(null, t[o], o, t);
  }
}
function zo(t, e) {
  e = e.toLowerCase();
  const r = Object.keys(t);
  let n = r.length, s;
  for (; n-- > 0; )
    if (s = r[n], e === s.toLowerCase())
      return s;
  return null;
}
const jt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Uo = (t) => !Vr(t) && t !== jt;
function Ms() {
  const { caseless: t } = Uo(this) && this || {}, e = {}, r = (n, s) => {
    const i = t && zo(e, s) || s;
    xn(e[i]) && xn(n) ? e[i] = Ms(e[i], n) : xn(n) ? e[i] = Ms({}, n) : xr(n) ? e[i] = n.slice() : e[i] = n;
  };
  for (let n = 0, s = arguments.length; n < s; n++)
    arguments[n] && ln(arguments[n], r);
  return e;
}
const Ld = (t, e, r, { allOwnKeys: n } = {}) => (ln(e, (s, i) => {
  r && ze(s) ? t[i] = Io(s, r) : t[i] = s;
}, { allOwnKeys: n }), t), zd = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), Ud = (t, e, r, n) => {
  t.prototype = Object.create(e.prototype, n), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), r && Object.assign(t.prototype, r);
}, Bd = (t, e, r, n) => {
  let s, i, a;
  const o = {};
  if (e = e || {}, t == null)
    return e;
  do {
    for (s = Object.getOwnPropertyNames(t), i = s.length; i-- > 0; )
      a = s[i], (!n || n(a, t, e)) && !o[a] && (e[a] = t[a], o[a] = !0);
    t = r !== !1 && oi(t);
  } while (t && (!r || r(t, e)) && t !== Object.prototype);
  return e;
}, $d = (t, e, r) => {
  t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= e.length;
  const n = t.indexOf(e, r);
  return n !== -1 && n === r;
}, Hd = (t) => {
  if (!t)
    return null;
  if (xr(t))
    return t;
  let e = t.length;
  if (!Lo(e))
    return null;
  const r = new Array(e);
  for (; e-- > 0; )
    r[e] = t[e];
  return r;
}, Wd = /* @__PURE__ */ ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && oi(Uint8Array)), Vd = (t, e) => {
  const n = (t && t[Symbol.iterator]).call(t);
  let s;
  for (; (s = n.next()) && !s.done; ) {
    const i = s.value;
    e.call(t, i[0], i[1]);
  }
}, qd = (t, e) => {
  let r;
  const n = [];
  for (; (r = t.exec(e)) !== null; )
    n.push(r);
  return n;
}, Kd = Ye("HTMLFormElement"), Qd = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, s) {
    return n.toUpperCase() + s;
  }
), da = (({ hasOwnProperty: t }) => (e, r) => t.call(e, r))(Object.prototype), Yd = Ye("RegExp"), Bo = (t, e) => {
  const r = Object.getOwnPropertyDescriptors(t), n = {};
  ln(r, (s, i) => {
    let a;
    (a = e(s, i, t)) !== !1 && (n[i] = a || s);
  }), Object.defineProperties(t, n);
}, Xd = (t) => {
  Bo(t, (e, r) => {
    if (ze(t) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = t[r];
    if (ze(n)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, Gd = (t, e) => {
  const r = {}, n = (s) => {
    s.forEach((i) => {
      r[i] = !0;
    });
  };
  return xr(t) ? n(t) : n(String(t).split(e)), r;
}, Jd = () => {
}, Zd = (t, e) => t != null && Number.isFinite(t = +t) ? t : e, as = "abcdefghijklmnopqrstuvwxyz", fa = "0123456789", $o = {
  DIGIT: fa,
  ALPHA: as,
  ALPHA_DIGIT: as + as.toUpperCase() + fa
}, ef = (t = 16, e = $o.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = e;
  for (; t--; )
    r += e[Math.random() * n | 0];
  return r;
};
function tf(t) {
  return !!(t && ze(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const rf = (t) => {
  const e = new Array(10), r = (n, s) => {
    if ($n(n)) {
      if (e.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        e[s] = n;
        const i = xr(n) ? [] : {};
        return ln(n, (a, o) => {
          const l = r(a, s + 1);
          !Vr(l) && (i[o] = l);
        }), e[s] = void 0, i;
      }
    }
    return n;
  };
  return r(t, 0);
}, nf = Ye("AsyncFunction"), sf = (t) => t && ($n(t) || ze(t)) && ze(t.then) && ze(t.catch), Ho = ((t, e) => t ? setImmediate : e ? ((r, n) => (jt.addEventListener("message", ({ source: s, data: i }) => {
  s === jt && i === r && n.length && n.shift()();
}, !1), (s) => {
  n.push(s), jt.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  ze(jt.postMessage)
), af = typeof queueMicrotask < "u" ? queueMicrotask.bind(jt) : typeof process < "u" && process.nextTick || Ho, E = {
  isArray: xr,
  isArrayBuffer: Mo,
  isBuffer: Sd,
  isFormData: jd,
  isArrayBufferView: Ed,
  isString: Cd,
  isNumber: Lo,
  isBoolean: Od,
  isObject: $n,
  isPlainObject: xn,
  isReadableStream: Dd,
  isRequest: Ad,
  isResponse: kd,
  isHeaders: Id,
  isUndefined: Vr,
  isDate: Rd,
  isFile: _d,
  isBlob: Pd,
  isRegExp: Yd,
  isFunction: ze,
  isStream: Nd,
  isURLSearchParams: Fd,
  isTypedArray: Wd,
  isFileList: Td,
  forEach: ln,
  merge: Ms,
  extend: Ld,
  trim: Md,
  stripBOM: zd,
  inherits: Ud,
  toFlatObject: Bd,
  kindOf: Un,
  kindOfTest: Ye,
  endsWith: $d,
  toArray: Hd,
  forEachEntry: Vd,
  matchAll: qd,
  isHTMLForm: Kd,
  hasOwnProperty: da,
  hasOwnProp: da,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Bo,
  freezeMethods: Xd,
  toObjectSet: Gd,
  toCamelCase: Qd,
  noop: Jd,
  toFiniteNumber: Zd,
  findKey: zo,
  global: jt,
  isContextDefined: Uo,
  ALPHABET: $o,
  generateString: ef,
  isSpecCompliantForm: tf,
  toJSONObject: rf,
  isAsyncFn: nf,
  isThenable: sf,
  setImmediate: Ho,
  asap: af
};
function V(t, e, r, n, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), r && (this.config = r), n && (this.request = n), s && (this.response = s);
}
E.inherits(V, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: E.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Wo = V.prototype, Vo = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  Vo[t] = { value: t };
});
Object.defineProperties(V, Vo);
Object.defineProperty(Wo, "isAxiosError", { value: !0 });
V.from = (t, e, r, n, s, i) => {
  const a = Object.create(Wo);
  return E.toFlatObject(t, a, function(l) {
    return l !== Error.prototype;
  }, (o) => o !== "isAxiosError"), V.call(a, t.message, e, r, n, s), a.cause = t, a.name = t.name, i && Object.assign(a, i), a;
};
const of = null;
function Ls(t) {
  return E.isPlainObject(t) || E.isArray(t);
}
function qo(t) {
  return E.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function pa(t, e, r) {
  return t ? t.concat(e).map(function(s, i) {
    return s = qo(s), !r && i ? "[" + s + "]" : s;
  }).join(r ? "." : "") : e;
}
function lf(t) {
  return E.isArray(t) && !t.some(Ls);
}
const cf = E.toFlatObject(E, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Hn(t, e, r) {
  if (!E.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), r = E.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(y, m) {
    return !E.isUndefined(m[y]);
  });
  const n = r.metaTokens, s = r.visitor || c, i = r.dots, a = r.indexes, l = (r.Blob || typeof Blob < "u" && Blob) && E.isSpecCompliantForm(e);
  if (!E.isFunction(s))
    throw new TypeError("visitor must be a function");
  function u(p) {
    if (p === null)
      return "";
    if (E.isDate(p))
      return p.toISOString();
    if (!l && E.isBlob(p))
      throw new V("Blob is not supported. Use a Buffer instead.");
    return E.isArrayBuffer(p) || E.isTypedArray(p) ? l && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function c(p, y, m) {
    let S = p;
    if (p && !m && typeof p == "object") {
      if (E.endsWith(y, "{}"))
        y = n ? y : y.slice(0, -2), p = JSON.stringify(p);
      else if (E.isArray(p) && lf(p) || (E.isFileList(p) || E.endsWith(y, "[]")) && (S = E.toArray(p)))
        return y = qo(y), S.forEach(function(C, P) {
          !(E.isUndefined(C) || C === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? pa([y], P, i) : a === null ? y : y + "[]",
            u(C)
          );
        }), !1;
    }
    return Ls(p) ? !0 : (e.append(pa(m, y, i), u(p)), !1);
  }
  const h = [], d = Object.assign(cf, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: Ls
  });
  function f(p, y) {
    if (!E.isUndefined(p)) {
      if (h.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + y.join("."));
      h.push(p), E.forEach(p, function(S, x) {
        (!(E.isUndefined(S) || S === null) && s.call(
          e,
          S,
          E.isString(x) ? x.trim() : x,
          y,
          d
        )) === !0 && f(S, y ? y.concat(x) : [x]);
      }), h.pop();
    }
  }
  if (!E.isObject(t))
    throw new TypeError("data must be an object");
  return f(t), e;
}
function ma(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(n) {
    return e[n];
  });
}
function li(t, e) {
  this._pairs = [], t && Hn(t, this, e);
}
const Ko = li.prototype;
Ko.append = function(e, r) {
  this._pairs.push([e, r]);
};
Ko.toString = function(e) {
  const r = e ? function(n) {
    return e.call(this, n, ma);
  } : ma;
  return this._pairs.map(function(s) {
    return r(s[0]) + "=" + r(s[1]);
  }, "").join("&");
};
function uf(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Qo(t, e, r) {
  if (!e)
    return t;
  const n = r && r.encode || uf, s = r && r.serialize;
  let i;
  if (s ? i = s(e, r) : i = E.isURLSearchParams(e) ? e.toString() : new li(e, r).toString(n), i) {
    const a = t.indexOf("#");
    a !== -1 && (t = t.slice(0, a)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}
class ga {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, r, n) {
    return this.handlers.push({
      fulfilled: e,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    E.forEach(this.handlers, function(n) {
      n !== null && e(n);
    });
  }
}
const Yo = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, hf = typeof URLSearchParams < "u" ? URLSearchParams : li, df = typeof FormData < "u" ? FormData : null, ff = typeof Blob < "u" ? Blob : null, pf = {
  isBrowser: !0,
  classes: {
    URLSearchParams: hf,
    FormData: df,
    Blob: ff
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, ci = typeof window < "u" && typeof document < "u", mf = ((t) => ci && ["ReactNative", "NativeScript", "NS"].indexOf(t) < 0)(typeof navigator < "u" && navigator.product), gf = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", yf = ci && window.location.href || "http://localhost", bf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: ci,
  hasStandardBrowserEnv: mf,
  hasStandardBrowserWebWorkerEnv: gf,
  origin: yf
}, Symbol.toStringTag, { value: "Module" })), Qe = {
  ...bf,
  ...pf
};
function vf(t, e) {
  return Hn(t, new Qe.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, s, i) {
      return Qe.isNode && E.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function wf(t) {
  return E.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function xf(t) {
  const e = {}, r = Object.keys(t);
  let n;
  const s = r.length;
  let i;
  for (n = 0; n < s; n++)
    i = r[n], e[i] = t[i];
  return e;
}
function Xo(t) {
  function e(r, n, s, i) {
    let a = r[i++];
    if (a === "__proto__")
      return !0;
    const o = Number.isFinite(+a), l = i >= r.length;
    return a = !a && E.isArray(s) ? s.length : a, l ? (E.hasOwnProp(s, a) ? s[a] = [s[a], n] : s[a] = n, !o) : ((!s[a] || !E.isObject(s[a])) && (s[a] = []), e(r, n, s[a], i) && E.isArray(s[a]) && (s[a] = xf(s[a])), !o);
  }
  if (E.isFormData(t) && E.isFunction(t.entries)) {
    const r = {};
    return E.forEachEntry(t, (n, s) => {
      e(wf(n), s, r, 0);
    }), r;
  }
  return null;
}
function Sf(t, e, r) {
  if (E.isString(t))
    try {
      return (e || JSON.parse)(t), E.trim(t);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (0, JSON.stringify)(t);
}
const cn = {
  transitional: Yo,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, r) {
    const n = r.getContentType() || "", s = n.indexOf("application/json") > -1, i = E.isObject(e);
    if (i && E.isHTMLForm(e) && (e = new FormData(e)), E.isFormData(e))
      return s ? JSON.stringify(Xo(e)) : e;
    if (E.isArrayBuffer(e) || E.isBuffer(e) || E.isStream(e) || E.isFile(e) || E.isBlob(e) || E.isReadableStream(e))
      return e;
    if (E.isArrayBufferView(e))
      return e.buffer;
    if (E.isURLSearchParams(e))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let o;
    if (i) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return vf(e, this.formSerializer).toString();
      if ((o = E.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Hn(
          o ? { "files[]": e } : e,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || s ? (r.setContentType("application/json", !1), Sf(e)) : e;
  }],
  transformResponse: [function(e) {
    const r = this.transitional || cn.transitional, n = r && r.forcedJSONParsing, s = this.responseType === "json";
    if (E.isResponse(e) || E.isReadableStream(e))
      return e;
    if (e && E.isString(e) && (n && !this.responseType || s)) {
      const a = !(r && r.silentJSONParsing) && s;
      try {
        return JSON.parse(e);
      } catch (o) {
        if (a)
          throw o.name === "SyntaxError" ? V.from(o, V.ERR_BAD_RESPONSE, this, null, this.response) : o;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Qe.classes.FormData,
    Blob: Qe.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
E.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  cn.headers[t] = {};
});
const Ef = E.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Cf = (t) => {
  const e = {};
  let r, n, s;
  return t && t.split(`
`).forEach(function(a) {
    s = a.indexOf(":"), r = a.substring(0, s).trim().toLowerCase(), n = a.substring(s + 1).trim(), !(!r || e[r] && Ef[r]) && (r === "set-cookie" ? e[r] ? e[r].push(n) : e[r] = [n] : e[r] = e[r] ? e[r] + ", " + n : n);
  }), e;
}, ya = Symbol("internals");
function Dr(t) {
  return t && String(t).trim().toLowerCase();
}
function Sn(t) {
  return t === !1 || t == null ? t : E.isArray(t) ? t.map(Sn) : String(t);
}
function Of(t) {
  const e = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(t); )
    e[n[1]] = n[2];
  return e;
}
const Rf = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function os(t, e, r, n, s) {
  if (E.isFunction(n))
    return n.call(this, e, r);
  if (s && (e = r), !!E.isString(e)) {
    if (E.isString(n))
      return e.indexOf(n) !== -1;
    if (E.isRegExp(n))
      return n.test(e);
  }
}
function _f(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, r, n) => r.toUpperCase() + n);
}
function Pf(t, e) {
  const r = E.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(t, n + r, {
      value: function(s, i, a) {
        return this[n].call(this, e, s, i, a);
      },
      configurable: !0
    });
  });
}
class ke {
  constructor(e) {
    e && this.set(e);
  }
  set(e, r, n) {
    const s = this;
    function i(o, l, u) {
      const c = Dr(l);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const h = E.findKey(s, c);
      (!h || s[h] === void 0 || u === !0 || u === void 0 && s[h] !== !1) && (s[h || l] = Sn(o));
    }
    const a = (o, l) => E.forEach(o, (u, c) => i(u, c, l));
    if (E.isPlainObject(e) || e instanceof this.constructor)
      a(e, r);
    else if (E.isString(e) && (e = e.trim()) && !Rf(e))
      a(Cf(e), r);
    else if (E.isHeaders(e))
      for (const [o, l] of e.entries())
        i(l, o, n);
    else
      e != null && i(r, e, n);
    return this;
  }
  get(e, r) {
    if (e = Dr(e), e) {
      const n = E.findKey(this, e);
      if (n) {
        const s = this[n];
        if (!r)
          return s;
        if (r === !0)
          return Of(s);
        if (E.isFunction(r))
          return r.call(this, s, n);
        if (E.isRegExp(r))
          return r.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, r) {
    if (e = Dr(e), e) {
      const n = E.findKey(this, e);
      return !!(n && this[n] !== void 0 && (!r || os(this, this[n], n, r)));
    }
    return !1;
  }
  delete(e, r) {
    const n = this;
    let s = !1;
    function i(a) {
      if (a = Dr(a), a) {
        const o = E.findKey(n, a);
        o && (!r || os(n, n[o], o, r)) && (delete n[o], s = !0);
      }
    }
    return E.isArray(e) ? e.forEach(i) : i(e), s;
  }
  clear(e) {
    const r = Object.keys(this);
    let n = r.length, s = !1;
    for (; n--; ) {
      const i = r[n];
      (!e || os(this, this[i], i, e, !0)) && (delete this[i], s = !0);
    }
    return s;
  }
  normalize(e) {
    const r = this, n = {};
    return E.forEach(this, (s, i) => {
      const a = E.findKey(n, i);
      if (a) {
        r[a] = Sn(s), delete r[i];
        return;
      }
      const o = e ? _f(i) : String(i).trim();
      o !== i && delete r[i], r[o] = Sn(s), n[o] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const r = /* @__PURE__ */ Object.create(null);
    return E.forEach(this, (n, s) => {
      n != null && n !== !1 && (r[s] = e && E.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, r]) => e + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...r) {
    const n = new this(e);
    return r.forEach((s) => n.set(s)), n;
  }
  static accessor(e) {
    const n = (this[ya] = this[ya] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(a) {
      const o = Dr(a);
      n[o] || (Pf(s, a), n[o] = !0);
    }
    return E.isArray(e) ? e.forEach(i) : i(e), this;
  }
}
ke.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
E.reduceDescriptors(ke.prototype, ({ value: t }, e) => {
  let r = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(n) {
      this[r] = n;
    }
  };
});
E.freezeMethods(ke);
function ls(t, e) {
  const r = this || cn, n = e || r, s = ke.from(n.headers);
  let i = n.data;
  return E.forEach(t, function(o) {
    i = o.call(r, i, s.normalize(), e ? e.status : void 0);
  }), s.normalize(), i;
}
function Go(t) {
  return !!(t && t.__CANCEL__);
}
function Sr(t, e, r) {
  V.call(this, t ?? "canceled", V.ERR_CANCELED, e, r), this.name = "CanceledError";
}
E.inherits(Sr, V, {
  __CANCEL__: !0
});
function Jo(t, e, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? t(r) : e(new V(
    "Request failed with status code " + r.status,
    [V.ERR_BAD_REQUEST, V.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function Tf(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function Nf(t, e) {
  t = t || 10;
  const r = new Array(t), n = new Array(t);
  let s = 0, i = 0, a;
  return e = e !== void 0 ? e : 1e3, function(l) {
    const u = Date.now(), c = n[i];
    a || (a = u), r[s] = l, n[s] = u;
    let h = i, d = 0;
    for (; h !== s; )
      d += r[h++], h = h % t;
    if (s = (s + 1) % t, s === i && (i = (i + 1) % t), u - a < e)
      return;
    const f = c && u - c;
    return f ? Math.round(d * 1e3 / f) : void 0;
  };
}
function jf(t, e) {
  let r = 0, n = 1e3 / e, s, i;
  const a = (u, c = Date.now()) => {
    r = c, s = null, i && (clearTimeout(i), i = null), t.apply(null, u);
  };
  return [(...u) => {
    const c = Date.now(), h = c - r;
    h >= n ? a(u, c) : (s = u, i || (i = setTimeout(() => {
      i = null, a(s);
    }, n - h)));
  }, () => s && a(s)];
}
const jn = (t, e, r = 3) => {
  let n = 0;
  const s = Nf(50, 250);
  return jf((i) => {
    const a = i.loaded, o = i.lengthComputable ? i.total : void 0, l = a - n, u = s(l), c = a <= o;
    n = a;
    const h = {
      loaded: a,
      total: o,
      progress: o ? a / o : void 0,
      bytes: l,
      rate: u || void 0,
      estimated: u && o && c ? (o - a) / u : void 0,
      event: i,
      lengthComputable: o != null,
      [e ? "download" : "upload"]: !0
    };
    t(h);
  }, r);
}, ba = (t, e) => {
  const r = t != null;
  return [(n) => e[0]({
    lengthComputable: r,
    total: t,
    loaded: n
  }), e[1]];
}, va = (t) => (...e) => E.asap(() => t(...e)), Ff = Qe.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a");
    let n;
    function s(i) {
      let a = i;
      return e && (r.setAttribute("href", a), a = r.href), r.setAttribute("href", a), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return n = s(window.location.href), function(a) {
      const o = E.isString(a) ? s(a) : a;
      return o.protocol === n.protocol && o.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), Df = Qe.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, r, n, s, i) {
      const a = [t + "=" + encodeURIComponent(e)];
      E.isNumber(r) && a.push("expires=" + new Date(r).toGMTString()), E.isString(n) && a.push("path=" + n), E.isString(s) && a.push("domain=" + s), i === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Af(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function kf(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function Zo(t, e) {
  return t && !Af(e) ? kf(t, e) : e;
}
const wa = (t) => t instanceof ke ? { ...t } : t;
function Ht(t, e) {
  e = e || {};
  const r = {};
  function n(u, c, h) {
    return E.isPlainObject(u) && E.isPlainObject(c) ? E.merge.call({ caseless: h }, u, c) : E.isPlainObject(c) ? E.merge({}, c) : E.isArray(c) ? c.slice() : c;
  }
  function s(u, c, h) {
    if (E.isUndefined(c)) {
      if (!E.isUndefined(u))
        return n(void 0, u, h);
    } else
      return n(u, c, h);
  }
  function i(u, c) {
    if (!E.isUndefined(c))
      return n(void 0, c);
  }
  function a(u, c) {
    if (E.isUndefined(c)) {
      if (!E.isUndefined(u))
        return n(void 0, u);
    } else
      return n(void 0, c);
  }
  function o(u, c, h) {
    if (h in e)
      return n(u, c);
    if (h in t)
      return n(void 0, u);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: o,
    headers: (u, c) => s(wa(u), wa(c), !0)
  };
  return E.forEach(Object.keys(Object.assign({}, t, e)), function(c) {
    const h = l[c] || s, d = h(t[c], e[c], c);
    E.isUndefined(d) && h !== o || (r[c] = d);
  }), r;
}
const el = (t) => {
  const e = Ht({}, t);
  let { data: r, withXSRFToken: n, xsrfHeaderName: s, xsrfCookieName: i, headers: a, auth: o } = e;
  e.headers = a = ke.from(a), e.url = Qo(Zo(e.baseURL, e.url), t.params, t.paramsSerializer), o && a.set(
    "Authorization",
    "Basic " + btoa((o.username || "") + ":" + (o.password ? unescape(encodeURIComponent(o.password)) : ""))
  );
  let l;
  if (E.isFormData(r)) {
    if (Qe.hasStandardBrowserEnv || Qe.hasStandardBrowserWebWorkerEnv)
      a.setContentType(void 0);
    else if ((l = a.getContentType()) !== !1) {
      const [u, ...c] = l ? l.split(";").map((h) => h.trim()).filter(Boolean) : [];
      a.setContentType([u || "multipart/form-data", ...c].join("; "));
    }
  }
  if (Qe.hasStandardBrowserEnv && (n && E.isFunction(n) && (n = n(e)), n || n !== !1 && Ff(e.url))) {
    const u = s && i && Df.read(i);
    u && a.set(s, u);
  }
  return e;
}, If = typeof XMLHttpRequest < "u", Mf = If && function(t) {
  return new Promise(function(r, n) {
    const s = el(t);
    let i = s.data;
    const a = ke.from(s.headers).normalize();
    let { responseType: o, onUploadProgress: l, onDownloadProgress: u } = s, c, h, d, f, p;
    function y() {
      f && f(), p && p(), s.cancelToken && s.cancelToken.unsubscribe(c), s.signal && s.signal.removeEventListener("abort", c);
    }
    let m = new XMLHttpRequest();
    m.open(s.method.toUpperCase(), s.url, !0), m.timeout = s.timeout;
    function S() {
      if (!m)
        return;
      const C = ke.from(
        "getAllResponseHeaders" in m && m.getAllResponseHeaders()
      ), j = {
        data: !o || o === "text" || o === "json" ? m.responseText : m.response,
        status: m.status,
        statusText: m.statusText,
        headers: C,
        config: t,
        request: m
      };
      Jo(function(_) {
        r(_), y();
      }, function(_) {
        n(_), y();
      }, j), m = null;
    }
    "onloadend" in m ? m.onloadend = S : m.onreadystatechange = function() {
      !m || m.readyState !== 4 || m.status === 0 && !(m.responseURL && m.responseURL.indexOf("file:") === 0) || setTimeout(S);
    }, m.onabort = function() {
      m && (n(new V("Request aborted", V.ECONNABORTED, t, m)), m = null);
    }, m.onerror = function() {
      n(new V("Network Error", V.ERR_NETWORK, t, m)), m = null;
    }, m.ontimeout = function() {
      let P = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const j = s.transitional || Yo;
      s.timeoutErrorMessage && (P = s.timeoutErrorMessage), n(new V(
        P,
        j.clarifyTimeoutError ? V.ETIMEDOUT : V.ECONNABORTED,
        t,
        m
      )), m = null;
    }, i === void 0 && a.setContentType(null), "setRequestHeader" in m && E.forEach(a.toJSON(), function(P, j) {
      m.setRequestHeader(j, P);
    }), E.isUndefined(s.withCredentials) || (m.withCredentials = !!s.withCredentials), o && o !== "json" && (m.responseType = s.responseType), u && ([d, p] = jn(u, !0), m.addEventListener("progress", d)), l && m.upload && ([h, f] = jn(l), m.upload.addEventListener("progress", h), m.upload.addEventListener("loadend", f)), (s.cancelToken || s.signal) && (c = (C) => {
      m && (n(!C || C.type ? new Sr(null, t, m) : C), m.abort(), m = null);
    }, s.cancelToken && s.cancelToken.subscribe(c), s.signal && (s.signal.aborted ? c() : s.signal.addEventListener("abort", c)));
    const x = Tf(s.url);
    if (x && Qe.protocols.indexOf(x) === -1) {
      n(new V("Unsupported protocol " + x + ":", V.ERR_BAD_REQUEST, t));
      return;
    }
    m.send(i || null);
  });
}, Lf = (t, e) => {
  let r = new AbortController(), n;
  const s = function(l) {
    if (!n) {
      n = !0, a();
      const u = l instanceof Error ? l : this.reason;
      r.abort(u instanceof V ? u : new Sr(u instanceof Error ? u.message : u));
    }
  };
  let i = e && setTimeout(() => {
    s(new V(`timeout ${e} of ms exceeded`, V.ETIMEDOUT));
  }, e);
  const a = () => {
    t && (i && clearTimeout(i), i = null, t.forEach((l) => {
      l && (l.removeEventListener ? l.removeEventListener("abort", s) : l.unsubscribe(s));
    }), t = null);
  };
  t.forEach((l) => l && l.addEventListener && l.addEventListener("abort", s));
  const { signal: o } = r;
  return o.unsubscribe = a, [o, () => {
    i && clearTimeout(i), i = null;
  }];
}, zf = function* (t, e) {
  let r = t.byteLength;
  if (r < e) {
    yield t;
    return;
  }
  let n = 0, s;
  for (; n < r; )
    s = n + e, yield t.slice(n, s), n = s;
}, Uf = async function* (t, e, r) {
  for await (const n of t)
    yield* zf(ArrayBuffer.isView(n) ? n : await r(String(n)), e);
}, xa = (t, e, r, n, s) => {
  const i = Uf(t, e, s);
  let a = 0, o, l = (u) => {
    o || (o = !0, n && n(u));
  };
  return new ReadableStream({
    async pull(u) {
      try {
        const { done: c, value: h } = await i.next();
        if (c) {
          l(), u.close();
          return;
        }
        let d = h.byteLength;
        if (r) {
          let f = a += d;
          r(f);
        }
        u.enqueue(new Uint8Array(h));
      } catch (c) {
        throw l(c), c;
      }
    },
    cancel(u) {
      return l(u), i.return();
    }
  }, {
    highWaterMark: 2
  });
}, Wn = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", tl = Wn && typeof ReadableStream == "function", zs = Wn && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((t) => (e) => t.encode(e))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), rl = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, Bf = tl && rl(() => {
  let t = !1;
  const e = new Request(Qe.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !e;
}), Sa = 64 * 1024, Us = tl && rl(() => E.isReadableStream(new Response("").body)), Fn = {
  stream: Us && ((t) => t.body)
};
Wn && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !Fn[e] && (Fn[e] = E.isFunction(t[e]) ? (r) => r[e]() : (r, n) => {
      throw new V(`Response type '${e}' is not supported`, V.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const $f = async (t) => {
  if (t == null)
    return 0;
  if (E.isBlob(t))
    return t.size;
  if (E.isSpecCompliantForm(t))
    return (await new Request(t).arrayBuffer()).byteLength;
  if (E.isArrayBufferView(t) || E.isArrayBuffer(t))
    return t.byteLength;
  if (E.isURLSearchParams(t) && (t = t + ""), E.isString(t))
    return (await zs(t)).byteLength;
}, Hf = async (t, e) => {
  const r = E.toFiniteNumber(t.getContentLength());
  return r ?? $f(e);
}, Wf = Wn && (async (t) => {
  let {
    url: e,
    method: r,
    data: n,
    signal: s,
    cancelToken: i,
    timeout: a,
    onDownloadProgress: o,
    onUploadProgress: l,
    responseType: u,
    headers: c,
    withCredentials: h = "same-origin",
    fetchOptions: d
  } = el(t);
  u = u ? (u + "").toLowerCase() : "text";
  let [f, p] = s || i || a ? Lf([s, i], a) : [], y, m;
  const S = () => {
    !y && setTimeout(() => {
      f && f.unsubscribe();
    }), y = !0;
  };
  let x;
  try {
    if (l && Bf && r !== "get" && r !== "head" && (x = await Hf(c, n)) !== 0) {
      let w = new Request(e, {
        method: "POST",
        body: n,
        duplex: "half"
      }), _;
      if (E.isFormData(n) && (_ = w.headers.get("content-type")) && c.setContentType(_), w.body) {
        const [O, R] = ba(
          x,
          jn(va(l))
        );
        n = xa(w.body, Sa, O, R, zs);
      }
    }
    E.isString(h) || (h = h ? "include" : "omit"), m = new Request(e, {
      ...d,
      signal: f,
      method: r.toUpperCase(),
      headers: c.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: h
    });
    let C = await fetch(m);
    const P = Us && (u === "stream" || u === "response");
    if (Us && (o || P)) {
      const w = {};
      ["status", "statusText", "headers"].forEach((N) => {
        w[N] = C[N];
      });
      const _ = E.toFiniteNumber(C.headers.get("content-length")), [O, R] = o && ba(
        _,
        jn(va(o), !0)
      ) || [];
      C = new Response(
        xa(C.body, Sa, O, () => {
          R && R(), P && S();
        }, zs),
        w
      );
    }
    u = u || "text";
    let j = await Fn[E.findKey(Fn, u) || "text"](C, t);
    return !P && S(), p && p(), await new Promise((w, _) => {
      Jo(w, _, {
        data: j,
        headers: ke.from(C.headers),
        status: C.status,
        statusText: C.statusText,
        config: t,
        request: m
      });
    });
  } catch (C) {
    throw S(), C && C.name === "TypeError" && /fetch/i.test(C.message) ? Object.assign(
      new V("Network Error", V.ERR_NETWORK, t, m),
      {
        cause: C.cause || C
      }
    ) : V.from(C, C && C.code, t, m);
  }
}), Bs = {
  http: of,
  xhr: Mf,
  fetch: Wf
};
E.forEach(Bs, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const Ea = (t) => `- ${t}`, Vf = (t) => E.isFunction(t) || t === null || t === !1, nl = {
  getAdapter: (t) => {
    t = E.isArray(t) ? t : [t];
    const { length: e } = t;
    let r, n;
    const s = {};
    for (let i = 0; i < e; i++) {
      r = t[i];
      let a;
      if (n = r, !Vf(r) && (n = Bs[(a = String(r)).toLowerCase()], n === void 0))
        throw new V(`Unknown adapter '${a}'`);
      if (n)
        break;
      s[a || "#" + i] = n;
    }
    if (!n) {
      const i = Object.entries(s).map(
        ([o, l]) => `adapter ${o} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = e ? i.length > 1 ? `since :
` + i.map(Ea).join(`
`) : " " + Ea(i[0]) : "as no adapter specified";
      throw new V(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: Bs
};
function cs(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Sr(null, t);
}
function Ca(t) {
  return cs(t), t.headers = ke.from(t.headers), t.data = ls.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), nl.getAdapter(t.adapter || cn.adapter)(t).then(function(n) {
    return cs(t), n.data = ls.call(
      t,
      t.transformResponse,
      n
    ), n.headers = ke.from(n.headers), n;
  }, function(n) {
    return Go(n) || (cs(t), n && n.response && (n.response.data = ls.call(
      t,
      t.transformResponse,
      n.response
    ), n.response.headers = ke.from(n.response.headers))), Promise.reject(n);
  });
}
const sl = "1.7.4", ui = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  ui[t] = function(n) {
    return typeof n === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Oa = {};
ui.transitional = function(e, r, n) {
  function s(i, a) {
    return "[Axios v" + sl + "] Transitional option '" + i + "'" + a + (n ? ". " + n : "");
  }
  return (i, a, o) => {
    if (e === !1)
      throw new V(
        s(a, " has been removed" + (r ? " in " + r : "")),
        V.ERR_DEPRECATED
      );
    return r && !Oa[a] && (Oa[a] = !0, console.warn(
      s(
        a,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(i, a, o) : !0;
  };
};
function qf(t, e, r) {
  if (typeof t != "object")
    throw new V("options must be an object", V.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(t);
  let s = n.length;
  for (; s-- > 0; ) {
    const i = n[s], a = e[i];
    if (a) {
      const o = t[i], l = o === void 0 || a(o, i, t);
      if (l !== !0)
        throw new V("option " + i + " must be " + l, V.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new V("Unknown option " + i, V.ERR_BAD_OPTION);
  }
}
const $s = {
  assertOptions: qf,
  validators: ui
}, ht = $s.validators;
class Bt {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new ga(),
      response: new ga()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, r) {
    try {
      return await this._request(e, r);
    } catch (n) {
      if (n instanceof Error) {
        let s;
        Error.captureStackTrace ? Error.captureStackTrace(s = {}) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? i && !String(n.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + i) : n.stack = i;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(e, r) {
    typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = Ht(this.defaults, r);
    const { transitional: n, paramsSerializer: s, headers: i } = r;
    n !== void 0 && $s.assertOptions(n, {
      silentJSONParsing: ht.transitional(ht.boolean),
      forcedJSONParsing: ht.transitional(ht.boolean),
      clarifyTimeoutError: ht.transitional(ht.boolean)
    }, !1), s != null && (E.isFunction(s) ? r.paramsSerializer = {
      serialize: s
    } : $s.assertOptions(s, {
      encode: ht.function,
      serialize: ht.function
    }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let a = i && E.merge(
      i.common,
      i[r.method]
    );
    i && E.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete i[p];
      }
    ), r.headers = ke.concat(a, i);
    const o = [];
    let l = !0;
    this.interceptors.request.forEach(function(y) {
      typeof y.runWhen == "function" && y.runWhen(r) === !1 || (l = l && y.synchronous, o.unshift(y.fulfilled, y.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(y) {
      u.push(y.fulfilled, y.rejected);
    });
    let c, h = 0, d;
    if (!l) {
      const p = [Ca.bind(this), void 0];
      for (p.unshift.apply(p, o), p.push.apply(p, u), d = p.length, c = Promise.resolve(r); h < d; )
        c = c.then(p[h++], p[h++]);
      return c;
    }
    d = o.length;
    let f = r;
    for (h = 0; h < d; ) {
      const p = o[h++], y = o[h++];
      try {
        f = p(f);
      } catch (m) {
        y.call(this, m);
        break;
      }
    }
    try {
      c = Ca.call(this, f);
    } catch (p) {
      return Promise.reject(p);
    }
    for (h = 0, d = u.length; h < d; )
      c = c.then(u[h++], u[h++]);
    return c;
  }
  getUri(e) {
    e = Ht(this.defaults, e);
    const r = Zo(e.baseURL, e.url);
    return Qo(r, e.params, e.paramsSerializer);
  }
}
E.forEach(["delete", "get", "head", "options"], function(e) {
  Bt.prototype[e] = function(r, n) {
    return this.request(Ht(n || {}, {
      method: e,
      url: r,
      data: (n || {}).data
    }));
  };
});
E.forEach(["post", "put", "patch"], function(e) {
  function r(n) {
    return function(i, a, o) {
      return this.request(Ht(o || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: a
      }));
    };
  }
  Bt.prototype[e] = r(), Bt.prototype[e + "Form"] = r(!0);
});
class hi {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(i) {
      r = i;
    });
    const n = this;
    this.promise.then((s) => {
      if (!n._listeners)
        return;
      let i = n._listeners.length;
      for (; i-- > 0; )
        n._listeners[i](s);
      n._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const a = new Promise((o) => {
        n.subscribe(o), i = o;
      }).then(s);
      return a.cancel = function() {
        n.unsubscribe(i);
      }, a;
    }, e(function(i, a, o) {
      n.reason || (n.reason = new Sr(i, a, o), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(e);
    r !== -1 && this._listeners.splice(r, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new hi(function(s) {
        e = s;
      }),
      cancel: e
    };
  }
}
function Kf(t) {
  return function(r) {
    return t.apply(null, r);
  };
}
function Qf(t) {
  return E.isObject(t) && t.isAxiosError === !0;
}
const Hs = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Hs).forEach(([t, e]) => {
  Hs[e] = t;
});
function il(t) {
  const e = new Bt(t), r = Io(Bt.prototype.request, e);
  return E.extend(r, Bt.prototype, e, { allOwnKeys: !0 }), E.extend(r, e, null, { allOwnKeys: !0 }), r.create = function(s) {
    return il(Ht(t, s));
  }, r;
}
const pe = il(cn);
pe.Axios = Bt;
pe.CanceledError = Sr;
pe.CancelToken = hi;
pe.isCancel = Go;
pe.VERSION = sl;
pe.toFormData = Hn;
pe.AxiosError = V;
pe.Cancel = pe.CanceledError;
pe.all = function(e) {
  return Promise.all(e);
};
pe.spread = Kf;
pe.isAxiosError = Qf;
pe.mergeConfig = Ht;
pe.AxiosHeaders = ke;
pe.formToJSON = (t) => Xo(E.isHTMLForm(t) ? new FormData(t) : t);
pe.getAdapter = nl.getAdapter;
pe.HttpStatusCode = Hs;
pe.default = pe;
const al = "/api/dashboard/customer", ol = "/api/dashboard/customer/data-files", Yf = `${ol}/validate-and-get-upload-options`, Xf = (t) => `${ol}/${t}/activate-file`, Gf = (t) => `${al}/draft-file/${t}`, Jf = (t) => `${al}/file/delete-with-digital-product-resource/${t}`, ll = "/api/data-files", Zf = `${ll}/validate-and-get-upload-options`, ep = (t) => `${ll}/${t}/activate-file`, tp = (t = !1) => {
  const { fetcher: e } = nr({
    method: tr.post
  }), { fetcher: r } = nr({
    method: tr.post
  }), { fetcher: n } = nr({
    method: tr.delete
  });
  return {
    validateAndGetUploadOptions: async ({
      file: u,
      isCommon: c,
      source: h,
      mimeType: d,
      cancelToken: f
    }) => await e(
      t ? Zf : Yf,
      {
        source: h,
        fileName: u.name,
        fileSize: u.size,
        mimeType: d,
        isCommon: c
      },
      {
        cancelToken: f
      }
    ),
    uploadToFileStore: async ({
      file: u,
      uploadOptions: c,
      progressHandler: h,
      cancelToken: d
    }) => {
      const f = new FormData();
      return f.append("key", c.key), f.append("acl", c.acl), f.append("X-Amz-Credential", c.credential), f.append("X-Amz-Algorithm", c.algorithm), f.append("X-Amz-Date", c.date), f.append("Policy", c.policy), f.append("X-Amz-Signature", c.signature), f.append("Content-Type", c.contentType), f.append("Cache-Control", c.cacheControl), f.append("file", u), await pe.post(c.url, f, {
        onUploadProgress: h,
        cancelToken: d
      });
    },
    activate: async ({
      fileId: u,
      cancelToken: c
    }) => await r(
      t ? ep(u) : Xf(u),
      {},
      {
        cancelToken: c,
        headers: {
          "Content-Type": "application/json"
        }
      }
    ),
    removeFile: async (u) => await n(Jf(u)),
    removeDraftFile: async (u) => await n(Gf(u))
  };
}, rp = () => {
  let t;
  return {
    createToken: () => (t = pe.CancelToken.source(), t.token),
    cancel: () => {
      t && (t.cancel(), t = void 0);
    },
    getToken: () => t == null ? void 0 : t.token
  };
}, np = ({
  onChange: t
}) => {
  let e = {
    isUploading: !1,
    progress: 0,
    total: 0,
    isUploaded: !1
  };
  const r = () => {
    t(e);
  }, n = () => {
    e = {
      ...e,
      progress: 0,
      total: 0,
      isUploading: !0,
      isUploaded: !1
    }, r();
  }, s = () => {
    e = {
      ...e,
      isUploading: !1,
      isUploaded: !0
    }, r();
  }, i = (l, u) => {
    u && (e = {
      ...e,
      progress: Math.round(l * 100 / u),
      total: u
    }, r());
  };
  return {
    getState: () => e,
    startProgress: n,
    finishProgress: s,
    updateProgress: i,
    resetProgress: () => {
      e = {
        progress: 0,
        total: 0,
        isUploading: !1,
        isUploaded: !1
      }, r();
    },
    progressHandler: (l) => {
      const u = l.loaded, c = l.total;
      i(u, c);
    }
  };
}, sp = (t) => {
  const e = t.name.match(/\.[a-zA-Z0-9_-]+$/i);
  switch (e && e[0]) {
    case ft.Docx:
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    case ft.Doc:
      return "application/msword";
    case ft.Ttf:
      return "font/ttf";
    case ft.AD_PRT:
      return "application/vnd.alibre.part";
    case ft.AD_SMP:
      return "application/vnd.alibre.sheet_metal_part";
    case ft.AD_ASM:
      return "application/vnd.alibre.assembly";
    case ft.AD_DRW:
      return "application/vnd.alibre.drawing";
    default:
      return t.type;
  }
}, cl = (t) => {
  const { t: e } = Pe(), { validateAndGetUploadOptions: r, uploadToFileStore: n, activate: s, removeDraftFile: i, removeFile: a } = tp(t);
  return {
    createFileUploader: (l) => {
      const u = np({ onChange: l }), c = rp();
      return {
        progress: u,
        upload: async ({
          file: f,
          source: p,
          isCommon: y = !1
        }) => {
          u.startProgress();
          const m = c.createToken();
          let S;
          try {
            const { uploadOptions: x, id: C } = await r({
              file: f,
              isCommon: y,
              source: p,
              mimeType: sp(f),
              cancelToken: m
            });
            S = C, await n({
              file: f,
              uploadOptions: x,
              progressHandler: u.progressHandler,
              cancelToken: m
            });
            const P = await s({
              fileId: C,
              cancelToken: m
            });
            return u.finishProgress(), P[C];
          } catch (x) {
            if (pe.isCancel(x)) {
              Me(e("file_manager.cancelled"));
              return;
            }
            throw typeof S == "number" ? await i(S) : Me.error(e("file_manager.error")), x;
          }
        },
        cancelUpload: () => {
          c.cancel(), u.resetProgress();
        }
      };
    },
    removeFile: a
  };
}, ip = ({
  preLoadedFiles: t,
  source: e,
  usePublicApi: r,
  onChange: n
}) => {
  const { t: s } = Pe(), { createFileUploader: i, removeFile: a } = cl(r), [o, l] = te([]), [u, c] = te([]), [h, d] = te({}), [f, p] = te([]), y = (O) => {
    const R = t == null ? void 0 : t.map((N) => N.id);
    return R == null ? void 0 : R.includes(O.id);
  }, m = () => u.map((R) => {
    const N = !y(R);
    return {
      file: { ...R, name: R.filename },
      disabled: f.includes(R.id),
      uploaded: N
    };
  }), S = () => Object.entries(h).map(([R, N]) => ({
    file: { ...N, id: R, name: N.file.name },
    progress: N.progress.isUploading ? N.progress.progress : void 0,
    uploaded: N.progress.isUploaded
  })), x = m(), C = S(), P = async (O) => {
    try {
      p((R) => [...R, O]), await a(O), c((R) => {
        const N = R.filter((k) => k.id !== O);
        return n == null || n(N), N;
      });
    } catch (R) {
      throw R;
    } finally {
      p((R) => R.filter((N) => N !== O));
    }
  }, j = (O) => {
    h[O].cancelUpload(), d((R) => {
      const { [O]: N, ...k } = R;
      return k;
    });
  };
  return {
    waitingUploadFiles: o,
    setWaitingUploadFiles: l,
    removingFiles: f,
    uploadedFiles: u,
    setUploadedFiles: c,
    mappedUploadedFiles: x,
    mappedUploadingFiles: C,
    startUploading: async (O) => {
      const R = await dh(O) + "_" + crypto.randomUUID(), k = i((F) => {
        d((U) => ({
          ...U,
          [R]: {
            ...U[R],
            progress: F
          }
        }));
      });
      l((F) => F.filter((U) => U.file !== O)), d((F) => ({
        ...F,
        [R]: {
          file: O,
          progress: k.progress.getState(),
          cancelUpload: k.cancelUpload
        }
      }));
      try {
        const F = await k.upload({ file: O, source: e });
        if (F)
          return c((U) => {
            const z = [{ ...F, file: O }, ...U];
            return n == null || n(z), z;
          }), F;
      } catch (F) {
        const U = F instanceof Error ? F : new Error(s("file_manager.error"));
        throw l((z) => [{ file: O, error: U }, ...z]), F;
      } finally {
        d((F) => {
          const { [R]: U, ...z } = F;
          return z;
        });
      }
    },
    deleteFile: async (O) => {
      h[O] && await j(String(O)), u.find((k) => k.id === +O) && await P(Number(O));
    },
    deleteUploadedFile: P,
    deleteUploadingFile: j
  };
}, ap = (t) => t instanceof File, op = (t) => "id" in t && "file" in t, lp = (t) => "id" in t && "path" in t && "size" in t && "type" in t && "filename" in t && "thumbnail" in t, cp = ({ progress: t }) => {
  const r = 2 * Math.PI * 14, n = r * (1 - t / 100);
  return /* @__PURE__ */ v.jsxs("div", { className: "relative w-8 h-8", children: [
    /* @__PURE__ */ v.jsx("svg", { className: "w-full h-full", children: /* @__PURE__ */ v.jsx(
      "circle",
      {
        cx: "50%",
        cy: "50%",
        r: 14,
        className: "stroke-text-secondary fill-none",
        strokeWidth: "3"
      }
    ) }),
    /* @__PURE__ */ v.jsx("svg", { className: "absolute top-0 left-0 w-full h-full", children: /* @__PURE__ */ v.jsx(
      "circle",
      {
        cx: "50%",
        cy: "50%",
        r: 14,
        className: "stroke-background-secondary fill-none transition-all duration-300",
        strokeWidth: "3",
        strokeDasharray: r,
        strokeDashoffset: n,
        transform: "rotate(-90 16 16)"
      }
    ) })
  ] });
};
function us({
  file: t,
  progress: e = 0,
  isError: r,
  isLoading: n,
  isLoaded: s,
  isDeleting: i,
  className: a,
  disabled: o,
  disabledDeleteButton: l,
  showDeleteButton: u,
  showEditButton: c,
  onDeleteFile: h,
  onEdit: d
}) {
  return /* @__PURE__ */ v.jsxs(
    "div",
    {
      className: ge("relative w-24 h-24", a),
      onClick: (f) => f.stopPropagation(),
      children: [
        u && /* @__PURE__ */ v.jsx(
          "button",
          {
            type: "button",
            className: ge(
              "absolute group -top-2 -right-2 z-1 rounded-full bg-background-primary",
              i && "animate-pulse"
            ),
            onClick: (f) => {
              f.preventDefault(), f.stopPropagation(), h();
            },
            disabled: l || o,
            children: /* @__PURE__ */ v.jsx(
              Pi,
              {
                className: ge(
                  "fill-text-secondary transition-colors",
                  !l && !o && "group-hover:fill-brand-primary"
                )
              }
            )
          }
        ),
        /* @__PURE__ */ v.jsxs("div", { className: "relative w-full h-full group/edit", children: [
          t instanceof File ? /* @__PURE__ */ v.jsx(vo, { file: t, className: "w-full h-full rounded-md" }) : /* @__PURE__ */ v.jsx(
            Ut,
            {
              src: t.thumbnail || t.path,
              fileType: t.type,
              isThumbnail: !0,
              className: "w-full h-full rounded-md",
              title: t.filename
            }
          ),
          /* @__PURE__ */ v.jsx(
            "div",
            {
              className: ge(
                "absolute top-0 left-0 w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md cursor-auto hidden",
                c && !o && "flex lg:hidden group-hover/edit:lg:flex"
              ),
              children: /* @__PURE__ */ v.jsx("div", { onClick: d, className: "cursor-pointer group p-2", children: /* @__PURE__ */ v.jsx(ac, { className: "fill-background-secondary group-hover:fill-brand-primary transition-colors" }) })
            }
          )
        ] }),
        r && /* @__PURE__ */ v.jsx("div", { className: "absolute top-0 left-0 flex w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md", children: /* @__PURE__ */ v.jsx(Pi, { className: "fill-danger rounded-full" }) }),
        n && /* @__PURE__ */ v.jsx("div", { className: "absolute top-0 left-0 flex w-full h-full justify-center items-center backdrop-blur-md bg-background-secondary/20 rounded-md", children: /* @__PURE__ */ v.jsx(cp, { progress: e }) })
      ]
    }
  );
}
var ul = /* @__PURE__ */ ((t) => (t[t.Small = 0] = "Small", t[t.Medium = 1] = "Medium", t[t.Big = 2] = "Big", t))(ul || {});
const up = {
  0: "p-2",
  1: "p-3",
  2: "p-10"
};
function hl({
  acceptTypes: t,
  children: e,
  dropZoneClassName: r,
  className: n,
  disabled: s,
  error: i,
  variant: a = ul.Medium,
  label: o,
  icon: l = /* @__PURE__ */ v.jsx(oc, {}),
  isPreFetching: u,
  toastText: c,
  labelClassName: h,
  openNativeWindow: d = !0,
  onSelectFile: f,
  onClick: p
}) {
  const { t: y } = Pe(), m = Le(null), [S, x] = te(!1), [C, P] = te(""), j = (N) => {
    var k;
    N.preventDefault(), !s && (p == null || p(), d && ((k = m.current) == null || k.click()));
  }, w = (N) => {
    if (N.target.files && N.target.files[0]) {
      const k = N.target.files[0];
      t && !ta(k.type, t) ? P(y("file_manager.file_upload.file_not_supported")) : (f(k), c && Me.success(c));
    }
    N.target.value = "";
  }, _ = (N) => {
    N.preventDefault(), x(!0);
  }, O = (N) => {
    N.preventDefault(), x(!1);
  }, R = (N) => {
    N.preventDefault(), N.stopPropagation();
    const { files: k } = N.dataTransfer;
    if (k && k.length) {
      const F = k[0];
      t && !ta(F.type, t) ? P(y("file_manager.file_upload.file_not_supported")) : (f(F), c && Me.success(c));
    }
    x(!1);
  };
  return /* @__PURE__ */ v.jsxs("div", { className: ge("font-medium", n), children: [
    /* @__PURE__ */ v.jsx(
      "input",
      {
        ref: m,
        type: "file",
        className: "invisible absolute h-1 w-0",
        onChange: w,
        disabled: u || s,
        accept: t && fh(t)
      }
    ),
    /* @__PURE__ */ v.jsxs(
      "button",
      {
        type: "button",
        className: ge(
          "bg-background-primary ring-brand-primary flex min-h-[60px] w-full flex-row flex-wrap gap-3 rounded-lg border border-dashed outline-hidden ring-offset-1 focus-visible:ring-2",
          S ? "border-brand-primary" : "border-text-secondary",
          up[a],
          u && "animate-pulse",
          s || u ? "pointer-events-none" : "hover:border-brand-primary cursor-pointer",
          r
        ),
        onDragStart: _,
        onDragLeave: O,
        onDrop: R,
        onDragOver: _,
        onClick: j,
        children: [
          !!Xl.count(e) && /* @__PURE__ */ v.jsx("div", { className: "flex w-full flex-wrap gap-3", children: e }),
          /* @__PURE__ */ v.jsxs(
            "div",
            {
              className: ge(
                "flex w-full flex-col items-center justify-center gap-1",
                h
              ),
              children: [
                l,
                o ?? y("file_manager.file_upload.drop_files_here")
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ v.jsx(En, { error: C, errorClassName: "text-center mt-2" }),
    /* @__PURE__ */ v.jsx(En, { error: i, errorClassName: "text-center mt-2" })
  ] });
}
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */
function Ra(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function dl(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ra(Object(r), !0).forEach(function(n) {
      pp(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Ra(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function hp(t, e) {
  if (typeof t != "object" || !t)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function fl(t) {
  var e = hp(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function Ws(t) {
  "@babel/helpers - typeof";
  return Ws = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ws(t);
}
function dp(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _a(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, fl(n.key), n);
  }
}
function fp(t, e, r) {
  return e && _a(t.prototype, e), r && _a(t, r), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function pp(t, e, r) {
  return e = fl(e), e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function pl(t) {
  return mp(t) || gp(t) || yp(t) || bp();
}
function mp(t) {
  if (Array.isArray(t))
    return Vs(t);
}
function gp(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function yp(t, e) {
  if (t) {
    if (typeof t == "string")
      return Vs(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Vs(t, e);
  }
}
function Vs(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function bp() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Vn = typeof window < "u" && typeof window.document < "u", rt = Vn ? window : {}, di = Vn && rt.document.documentElement ? "ontouchstart" in rt.document.documentElement : !1, fi = Vn ? "PointerEvent" in rt : !1, ue = "cropper", pi = "all", ml = "crop", gl = "move", yl = "zoom", Pt = "e", Tt = "w", Jt = "s", dt = "n", Ar = "ne", kr = "nw", Ir = "se", Mr = "sw", qs = "".concat(ue, "-crop"), Pa = "".concat(ue, "-disabled"), De = "".concat(ue, "-hidden"), Ta = "".concat(ue, "-hide"), vp = "".concat(ue, "-invisible"), Dn = "".concat(ue, "-modal"), Ks = "".concat(ue, "-move"), qr = "".concat(ue, "Action"), vn = "".concat(ue, "Preview"), mi = "crop", bl = "move", vl = "none", Qs = "crop", Ys = "cropend", Xs = "cropmove", Gs = "cropstart", Na = "dblclick", wp = di ? "touchstart" : "mousedown", xp = di ? "touchmove" : "mousemove", Sp = di ? "touchend touchcancel" : "mouseup", ja = fi ? "pointerdown" : wp, Fa = fi ? "pointermove" : xp, Da = fi ? "pointerup pointercancel" : Sp, Aa = "ready", ka = "resize", Ia = "wheel", Js = "zoom", Ma = "image/jpeg", Ep = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, Cp = /^data:/, Op = /^data:image\/jpeg;base64,/, Rp = /^img|canvas$/i, wl = 200, xl = 100, La = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: mi,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: !0,
  // Restore the cropped area after resize the window
  restore: !0,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: !0,
  // Check the current image's Exif Orientation information
  checkOrientation: !0,
  // Show the black modal
  modal: !0,
  // Show the dashed lines for guiding
  guides: !0,
  // Show the center indicator for guiding
  center: !0,
  // Show the white modal to highlight the crop box
  highlight: !0,
  // Show the grid background
  background: !0,
  // Enable to crop the image automatically when initialize
  autoCrop: !0,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: !0,
  // Enable to rotate the image
  rotatable: !0,
  // Enable to scale the image
  scalable: !0,
  // Enable to zoom the image
  zoomable: !0,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: !0,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: !0,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: !0,
  // Enable to resize the crop box
  cropBoxResizable: !0,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: !0,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: wl,
  minContainerHeight: xl,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
}, _p = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>', Pp = Number.isNaN || rt.isNaN;
function X(t) {
  return typeof t == "number" && !Pp(t);
}
var za = function(e) {
  return e > 0 && e < 1 / 0;
};
function hs(t) {
  return typeof t > "u";
}
function Wt(t) {
  return Ws(t) === "object" && t !== null;
}
var Tp = Object.prototype.hasOwnProperty;
function Zt(t) {
  if (!Wt(t))
    return !1;
  try {
    var e = t.constructor, r = e.prototype;
    return e && r && Tp.call(r, "isPrototypeOf");
  } catch {
    return !1;
  }
}
function Fe(t) {
  return typeof t == "function";
}
var Np = Array.prototype.slice;
function Sl(t) {
  return Array.from ? Array.from(t) : Np.call(t);
}
function ve(t, e) {
  return t && Fe(e) && (Array.isArray(t) || X(t.length) ? Sl(t).forEach(function(r, n) {
    e.call(t, r, n, t);
  }) : Wt(t) && Object.keys(t).forEach(function(r) {
    e.call(t, t[r], r, t);
  })), t;
}
var he = Object.assign || function(e) {
  for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)
    n[s - 1] = arguments[s];
  return Wt(e) && n.length > 0 && n.forEach(function(i) {
    Wt(i) && Object.keys(i).forEach(function(a) {
      e[a] = i[a];
    });
  }), e;
}, jp = /\.\d*(?:0|9){12}\d*$/;
function ir(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return jp.test(t) ? Math.round(t * e) / e : t;
}
var Fp = /^width|height|left|top|marginLeft|marginTop$/;
function St(t, e) {
  var r = t.style;
  ve(e, function(n, s) {
    Fp.test(s) && X(n) && (n = "".concat(n, "px")), r[s] = n;
  });
}
function Dp(t, e) {
  return t.classList ? t.classList.contains(e) : t.className.indexOf(e) > -1;
}
function we(t, e) {
  if (e) {
    if (X(t.length)) {
      ve(t, function(n) {
        we(n, e);
      });
      return;
    }
    if (t.classList) {
      t.classList.add(e);
      return;
    }
    var r = t.className.trim();
    r ? r.indexOf(e) < 0 && (t.className = "".concat(r, " ").concat(e)) : t.className = e;
  }
}
function tt(t, e) {
  if (e) {
    if (X(t.length)) {
      ve(t, function(r) {
        tt(r, e);
      });
      return;
    }
    if (t.classList) {
      t.classList.remove(e);
      return;
    }
    t.className.indexOf(e) >= 0 && (t.className = t.className.replace(e, ""));
  }
}
function er(t, e, r) {
  if (e) {
    if (X(t.length)) {
      ve(t, function(n) {
        er(n, e, r);
      });
      return;
    }
    r ? we(t, e) : tt(t, e);
  }
}
var Ap = /([a-z\d])([A-Z])/g;
function gi(t) {
  return t.replace(Ap, "$1-$2").toLowerCase();
}
function Zs(t, e) {
  return Wt(t[e]) ? t[e] : t.dataset ? t.dataset[e] : t.getAttribute("data-".concat(gi(e)));
}
function Kr(t, e, r) {
  Wt(r) ? t[e] = r : t.dataset ? t.dataset[e] = r : t.setAttribute("data-".concat(gi(e)), r);
}
function kp(t, e) {
  if (Wt(t[e]))
    try {
      delete t[e];
    } catch {
      t[e] = void 0;
    }
  else if (t.dataset)
    try {
      delete t.dataset[e];
    } catch {
      t.dataset[e] = void 0;
    }
  else
    t.removeAttribute("data-".concat(gi(e)));
}
var El = /\s\s*/, Cl = function() {
  var t = !1;
  if (Vn) {
    var e = !1, r = function() {
    }, n = Object.defineProperty({}, "once", {
      get: function() {
        return t = !0, e;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function(i) {
        e = i;
      }
    });
    rt.addEventListener("test", r, n), rt.removeEventListener("test", r, n);
  }
  return t;
}();
function Ve(t, e, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, s = r;
  e.trim().split(El).forEach(function(i) {
    if (!Cl) {
      var a = t.listeners;
      a && a[i] && a[i][r] && (s = a[i][r], delete a[i][r], Object.keys(a[i]).length === 0 && delete a[i], Object.keys(a).length === 0 && delete t.listeners);
    }
    t.removeEventListener(i, s, n);
  });
}
function Be(t, e, r) {
  var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, s = r;
  e.trim().split(El).forEach(function(i) {
    if (n.once && !Cl) {
      var a = t.listeners, o = a === void 0 ? {} : a;
      s = function() {
        delete o[i][r], t.removeEventListener(i, s, n);
        for (var u = arguments.length, c = new Array(u), h = 0; h < u; h++)
          c[h] = arguments[h];
        r.apply(t, c);
      }, o[i] || (o[i] = {}), o[i][r] && t.removeEventListener(i, o[i][r], n), o[i][r] = s, t.listeners = o;
    }
    t.addEventListener(i, s, n);
  });
}
function ar(t, e, r) {
  var n;
  return Fe(Event) && Fe(CustomEvent) ? n = new CustomEvent(e, {
    detail: r,
    bubbles: !0,
    cancelable: !0
  }) : (n = document.createEvent("CustomEvent"), n.initCustomEvent(e, !0, !0, r)), t.dispatchEvent(n);
}
function Ol(t) {
  var e = t.getBoundingClientRect();
  return {
    left: e.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: e.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var ds = rt.location, Ip = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function Ua(t) {
  var e = t.match(Ip);
  return e !== null && (e[1] !== ds.protocol || e[2] !== ds.hostname || e[3] !== ds.port);
}
function Ba(t) {
  var e = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return t + (t.indexOf("?") === -1 ? "?" : "&") + e;
}
function Ur(t) {
  var e = t.rotate, r = t.scaleX, n = t.scaleY, s = t.translateX, i = t.translateY, a = [];
  X(s) && s !== 0 && a.push("translateX(".concat(s, "px)")), X(i) && i !== 0 && a.push("translateY(".concat(i, "px)")), X(e) && e !== 0 && a.push("rotate(".concat(e, "deg)")), X(r) && r !== 1 && a.push("scaleX(".concat(r, ")")), X(n) && n !== 1 && a.push("scaleY(".concat(n, ")"));
  var o = a.length ? a.join(" ") : "none";
  return {
    WebkitTransform: o,
    msTransform: o,
    transform: o
  };
}
function Mp(t) {
  var e = dl({}, t), r = 0;
  return ve(t, function(n, s) {
    delete e[s], ve(e, function(i) {
      var a = Math.abs(n.startX - i.startX), o = Math.abs(n.startY - i.startY), l = Math.abs(n.endX - i.endX), u = Math.abs(n.endY - i.endY), c = Math.sqrt(a * a + o * o), h = Math.sqrt(l * l + u * u), d = (h - c) / c;
      Math.abs(d) > Math.abs(r) && (r = d);
    });
  }), r;
}
function wn(t, e) {
  var r = t.pageX, n = t.pageY, s = {
    endX: r,
    endY: n
  };
  return e ? s : dl({
    startX: r,
    startY: n
  }, s);
}
function Lp(t) {
  var e = 0, r = 0, n = 0;
  return ve(t, function(s) {
    var i = s.startX, a = s.startY;
    e += i, r += a, n += 1;
  }), e /= n, r /= n, {
    pageX: e,
    pageY: r
  };
}
function Et(t) {
  var e = t.aspectRatio, r = t.height, n = t.width, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain", i = za(n), a = za(r);
  if (i && a) {
    var o = r * e;
    s === "contain" && o > n || s === "cover" && o < n ? r = n / e : n = r * e;
  } else
    i ? r = n / e : a && (n = r * e);
  return {
    width: n,
    height: r
  };
}
function zp(t) {
  var e = t.width, r = t.height, n = t.degree;
  if (n = Math.abs(n) % 180, n === 90)
    return {
      width: r,
      height: e
    };
  var s = n % 90 * Math.PI / 180, i = Math.sin(s), a = Math.cos(s), o = e * a + r * i, l = e * i + r * a;
  return n > 90 ? {
    width: l,
    height: o
  } : {
    width: o,
    height: l
  };
}
function Up(t, e, r, n) {
  var s = e.aspectRatio, i = e.naturalWidth, a = e.naturalHeight, o = e.rotate, l = o === void 0 ? 0 : o, u = e.scaleX, c = u === void 0 ? 1 : u, h = e.scaleY, d = h === void 0 ? 1 : h, f = r.aspectRatio, p = r.naturalWidth, y = r.naturalHeight, m = n.fillColor, S = m === void 0 ? "transparent" : m, x = n.imageSmoothingEnabled, C = x === void 0 ? !0 : x, P = n.imageSmoothingQuality, j = P === void 0 ? "low" : P, w = n.maxWidth, _ = w === void 0 ? 1 / 0 : w, O = n.maxHeight, R = O === void 0 ? 1 / 0 : O, N = n.minWidth, k = N === void 0 ? 0 : N, F = n.minHeight, U = F === void 0 ? 0 : F, z = document.createElement("canvas"), M = z.getContext("2d"), re = Et({
    aspectRatio: f,
    width: _,
    height: R
  }), ce = Et({
    aspectRatio: f,
    width: k,
    height: U
  }, "cover"), $ = Math.min(re.width, Math.max(ce.width, p)), K = Math.min(re.height, Math.max(ce.height, y)), ne = Et({
    aspectRatio: s,
    width: _,
    height: R
  }), W = Et({
    aspectRatio: s,
    width: k,
    height: U
  }, "cover"), A = Math.min(ne.width, Math.max(W.width, i)), Q = Math.min(ne.height, Math.max(W.height, a)), Z = [-A / 2, -Q / 2, A, Q];
  return z.width = ir($), z.height = ir(K), M.fillStyle = S, M.fillRect(0, 0, $, K), M.save(), M.translate($ / 2, K / 2), M.rotate(l * Math.PI / 180), M.scale(c, d), M.imageSmoothingEnabled = C, M.imageSmoothingQuality = j, M.drawImage.apply(M, [t].concat(pl(Z.map(function(Te) {
    return Math.floor(ir(Te));
  })))), M.restore(), z;
}
var Rl = String.fromCharCode;
function Bp(t, e, r) {
  var n = "";
  r += e;
  for (var s = e; s < r; s += 1)
    n += Rl(t.getUint8(s));
  return n;
}
var $p = /^data:.*,/;
function Hp(t) {
  var e = t.replace($p, ""), r = atob(e), n = new ArrayBuffer(r.length), s = new Uint8Array(n);
  return ve(s, function(i, a) {
    s[a] = r.charCodeAt(a);
  }), n;
}
function Wp(t, e) {
  for (var r = [], n = 8192, s = new Uint8Array(t); s.length > 0; )
    r.push(Rl.apply(null, Sl(s.subarray(0, n)))), s = s.subarray(n);
  return "data:".concat(e, ";base64,").concat(btoa(r.join("")));
}
function Vp(t) {
  var e = new DataView(t), r;
  try {
    var n, s, i;
    if (e.getUint8(0) === 255 && e.getUint8(1) === 216)
      for (var a = e.byteLength, o = 2; o + 1 < a; ) {
        if (e.getUint8(o) === 255 && e.getUint8(o + 1) === 225) {
          s = o;
          break;
        }
        o += 1;
      }
    if (s) {
      var l = s + 4, u = s + 10;
      if (Bp(e, l, 4) === "Exif") {
        var c = e.getUint16(u);
        if (n = c === 18761, (n || c === 19789) && e.getUint16(u + 2, n) === 42) {
          var h = e.getUint32(u + 4, n);
          h >= 8 && (i = u + h);
        }
      }
    }
    if (i) {
      var d = e.getUint16(i, n), f, p;
      for (p = 0; p < d; p += 1)
        if (f = i + p * 12 + 2, e.getUint16(f, n) === 274) {
          f += 8, r = e.getUint16(f, n), e.setUint16(f, 1, n);
          break;
        }
    }
  } catch {
    r = 1;
  }
  return r;
}
function qp(t) {
  var e = 0, r = 1, n = 1;
  switch (t) {
    case 2:
      r = -1;
      break;
    case 3:
      e = -180;
      break;
    case 4:
      n = -1;
      break;
    case 5:
      e = 90, n = -1;
      break;
    case 6:
      e = 90;
      break;
    case 7:
      e = 90, r = -1;
      break;
    case 8:
      e = -90;
      break;
  }
  return {
    rotate: e,
    scaleX: r,
    scaleY: n
  };
}
var Kp = {
  render: function() {
    this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
  },
  initContainer: function() {
    var e = this.element, r = this.options, n = this.container, s = this.cropper, i = Number(r.minContainerWidth), a = Number(r.minContainerHeight);
    we(s, De), tt(e, De);
    var o = {
      width: Math.max(n.offsetWidth, i >= 0 ? i : wl),
      height: Math.max(n.offsetHeight, a >= 0 ? a : xl)
    };
    this.containerData = o, St(s, {
      width: o.width,
      height: o.height
    }), we(e, De), tt(s, De);
  },
  // Canvas (image wrapper)
  initCanvas: function() {
    var e = this.containerData, r = this.imageData, n = this.options.viewMode, s = Math.abs(r.rotate) % 180 === 90, i = s ? r.naturalHeight : r.naturalWidth, a = s ? r.naturalWidth : r.naturalHeight, o = i / a, l = e.width, u = e.height;
    e.height * o > e.width ? n === 3 ? l = e.height * o : u = e.width / o : n === 3 ? u = e.width / o : l = e.height * o;
    var c = {
      aspectRatio: o,
      naturalWidth: i,
      naturalHeight: a,
      width: l,
      height: u
    };
    this.canvasData = c, this.limited = n === 1 || n === 2, this.limitCanvas(!0, !0), c.width = Math.min(Math.max(c.width, c.minWidth), c.maxWidth), c.height = Math.min(Math.max(c.height, c.minHeight), c.maxHeight), c.left = (e.width - c.width) / 2, c.top = (e.height - c.height) / 2, c.oldLeft = c.left, c.oldTop = c.top, this.initialCanvasData = he({}, c);
  },
  limitCanvas: function(e, r) {
    var n = this.options, s = this.containerData, i = this.canvasData, a = this.cropBoxData, o = n.viewMode, l = i.aspectRatio, u = this.cropped && a;
    if (e) {
      var c = Number(n.minCanvasWidth) || 0, h = Number(n.minCanvasHeight) || 0;
      o > 1 ? (c = Math.max(c, s.width), h = Math.max(h, s.height), o === 3 && (h * l > c ? c = h * l : h = c / l)) : o > 0 && (c ? c = Math.max(c, u ? a.width : 0) : h ? h = Math.max(h, u ? a.height : 0) : u && (c = a.width, h = a.height, h * l > c ? c = h * l : h = c / l));
      var d = Et({
        aspectRatio: l,
        width: c,
        height: h
      });
      c = d.width, h = d.height, i.minWidth = c, i.minHeight = h, i.maxWidth = 1 / 0, i.maxHeight = 1 / 0;
    }
    if (r)
      if (o > (u ? 0 : 1)) {
        var f = s.width - i.width, p = s.height - i.height;
        i.minLeft = Math.min(0, f), i.minTop = Math.min(0, p), i.maxLeft = Math.max(0, f), i.maxTop = Math.max(0, p), u && this.limited && (i.minLeft = Math.min(a.left, a.left + (a.width - i.width)), i.minTop = Math.min(a.top, a.top + (a.height - i.height)), i.maxLeft = a.left, i.maxTop = a.top, o === 2 && (i.width >= s.width && (i.minLeft = Math.min(0, f), i.maxLeft = Math.max(0, f)), i.height >= s.height && (i.minTop = Math.min(0, p), i.maxTop = Math.max(0, p))));
      } else
        i.minLeft = -i.width, i.minTop = -i.height, i.maxLeft = s.width, i.maxTop = s.height;
  },
  renderCanvas: function(e, r) {
    var n = this.canvasData, s = this.imageData;
    if (r) {
      var i = zp({
        width: s.naturalWidth * Math.abs(s.scaleX || 1),
        height: s.naturalHeight * Math.abs(s.scaleY || 1),
        degree: s.rotate || 0
      }), a = i.width, o = i.height, l = n.width * (a / n.naturalWidth), u = n.height * (o / n.naturalHeight);
      n.left -= (l - n.width) / 2, n.top -= (u - n.height) / 2, n.width = l, n.height = u, n.aspectRatio = a / o, n.naturalWidth = a, n.naturalHeight = o, this.limitCanvas(!0, !1);
    }
    (n.width > n.maxWidth || n.width < n.minWidth) && (n.left = n.oldLeft), (n.height > n.maxHeight || n.height < n.minHeight) && (n.top = n.oldTop), n.width = Math.min(Math.max(n.width, n.minWidth), n.maxWidth), n.height = Math.min(Math.max(n.height, n.minHeight), n.maxHeight), this.limitCanvas(!1, !0), n.left = Math.min(Math.max(n.left, n.minLeft), n.maxLeft), n.top = Math.min(Math.max(n.top, n.minTop), n.maxTop), n.oldLeft = n.left, n.oldTop = n.top, St(this.canvas, he({
      width: n.width,
      height: n.height
    }, Ur({
      translateX: n.left,
      translateY: n.top
    }))), this.renderImage(e), this.cropped && this.limited && this.limitCropBox(!0, !0);
  },
  renderImage: function(e) {
    var r = this.canvasData, n = this.imageData, s = n.naturalWidth * (r.width / r.naturalWidth), i = n.naturalHeight * (r.height / r.naturalHeight);
    he(n, {
      width: s,
      height: i,
      left: (r.width - s) / 2,
      top: (r.height - i) / 2
    }), St(this.image, he({
      width: n.width,
      height: n.height
    }, Ur(he({
      translateX: n.left,
      translateY: n.top
    }, n)))), e && this.output();
  },
  initCropBox: function() {
    var e = this.options, r = this.canvasData, n = e.aspectRatio || e.initialAspectRatio, s = Number(e.autoCropArea) || 0.8, i = {
      width: r.width,
      height: r.height
    };
    n && (r.height * n > r.width ? i.height = i.width / n : i.width = i.height * n), this.cropBoxData = i, this.limitCropBox(!0, !0), i.width = Math.min(Math.max(i.width, i.minWidth), i.maxWidth), i.height = Math.min(Math.max(i.height, i.minHeight), i.maxHeight), i.width = Math.max(i.minWidth, i.width * s), i.height = Math.max(i.minHeight, i.height * s), i.left = r.left + (r.width - i.width) / 2, i.top = r.top + (r.height - i.height) / 2, i.oldLeft = i.left, i.oldTop = i.top, this.initialCropBoxData = he({}, i);
  },
  limitCropBox: function(e, r) {
    var n = this.options, s = this.containerData, i = this.canvasData, a = this.cropBoxData, o = this.limited, l = n.aspectRatio;
    if (e) {
      var u = Number(n.minCropBoxWidth) || 0, c = Number(n.minCropBoxHeight) || 0, h = o ? Math.min(s.width, i.width, i.width + i.left, s.width - i.left) : s.width, d = o ? Math.min(s.height, i.height, i.height + i.top, s.height - i.top) : s.height;
      u = Math.min(u, s.width), c = Math.min(c, s.height), l && (u && c ? c * l > u ? c = u / l : u = c * l : u ? c = u / l : c && (u = c * l), d * l > h ? d = h / l : h = d * l), a.minWidth = Math.min(u, h), a.minHeight = Math.min(c, d), a.maxWidth = h, a.maxHeight = d;
    }
    r && (o ? (a.minLeft = Math.max(0, i.left), a.minTop = Math.max(0, i.top), a.maxLeft = Math.min(s.width, i.left + i.width) - a.width, a.maxTop = Math.min(s.height, i.top + i.height) - a.height) : (a.minLeft = 0, a.minTop = 0, a.maxLeft = s.width - a.width, a.maxTop = s.height - a.height));
  },
  renderCropBox: function() {
    var e = this.options, r = this.containerData, n = this.cropBoxData;
    (n.width > n.maxWidth || n.width < n.minWidth) && (n.left = n.oldLeft), (n.height > n.maxHeight || n.height < n.minHeight) && (n.top = n.oldTop), n.width = Math.min(Math.max(n.width, n.minWidth), n.maxWidth), n.height = Math.min(Math.max(n.height, n.minHeight), n.maxHeight), this.limitCropBox(!1, !0), n.left = Math.min(Math.max(n.left, n.minLeft), n.maxLeft), n.top = Math.min(Math.max(n.top, n.minTop), n.maxTop), n.oldLeft = n.left, n.oldTop = n.top, e.movable && e.cropBoxMovable && Kr(this.face, qr, n.width >= r.width && n.height >= r.height ? gl : pi), St(this.cropBox, he({
      width: n.width,
      height: n.height
    }, Ur({
      translateX: n.left,
      translateY: n.top
    }))), this.cropped && this.limited && this.limitCanvas(!0, !0), this.disabled || this.output();
  },
  output: function() {
    this.preview(), ar(this.element, Qs, this.getData());
  }
}, Qp = {
  initPreview: function() {
    var e = this.element, r = this.crossOrigin, n = this.options.preview, s = r ? this.crossOriginUrl : this.url, i = e.alt || "The image to preview", a = document.createElement("img");
    if (r && (a.crossOrigin = r), a.src = s, a.alt = i, this.viewBox.appendChild(a), this.viewBoxImage = a, !!n) {
      var o = n;
      typeof n == "string" ? o = e.ownerDocument.querySelectorAll(n) : n.querySelector && (o = [n]), this.previews = o, ve(o, function(l) {
        var u = document.createElement("img");
        Kr(l, vn, {
          width: l.offsetWidth,
          height: l.offsetHeight,
          html: l.innerHTML
        }), r && (u.crossOrigin = r), u.src = s, u.alt = i, u.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', l.innerHTML = "", l.appendChild(u);
      });
    }
  },
  resetPreview: function() {
    ve(this.previews, function(e) {
      var r = Zs(e, vn);
      St(e, {
        width: r.width,
        height: r.height
      }), e.innerHTML = r.html, kp(e, vn);
    });
  },
  preview: function() {
    var e = this.imageData, r = this.canvasData, n = this.cropBoxData, s = n.width, i = n.height, a = e.width, o = e.height, l = n.left - r.left - e.left, u = n.top - r.top - e.top;
    !this.cropped || this.disabled || (St(this.viewBoxImage, he({
      width: a,
      height: o
    }, Ur(he({
      translateX: -l,
      translateY: -u
    }, e)))), ve(this.previews, function(c) {
      var h = Zs(c, vn), d = h.width, f = h.height, p = d, y = f, m = 1;
      s && (m = d / s, y = i * m), i && y > f && (m = f / i, p = s * m, y = f), St(c, {
        width: p,
        height: y
      }), St(c.getElementsByTagName("img")[0], he({
        width: a * m,
        height: o * m
      }, Ur(he({
        translateX: -l * m,
        translateY: -u * m
      }, e))));
    }));
  }
}, Yp = {
  bind: function() {
    var e = this.element, r = this.options, n = this.cropper;
    Fe(r.cropstart) && Be(e, Gs, r.cropstart), Fe(r.cropmove) && Be(e, Xs, r.cropmove), Fe(r.cropend) && Be(e, Ys, r.cropend), Fe(r.crop) && Be(e, Qs, r.crop), Fe(r.zoom) && Be(e, Js, r.zoom), Be(n, ja, this.onCropStart = this.cropStart.bind(this)), r.zoomable && r.zoomOnWheel && Be(n, Ia, this.onWheel = this.wheel.bind(this), {
      passive: !1,
      capture: !0
    }), r.toggleDragModeOnDblclick && Be(n, Na, this.onDblclick = this.dblclick.bind(this)), Be(e.ownerDocument, Fa, this.onCropMove = this.cropMove.bind(this)), Be(e.ownerDocument, Da, this.onCropEnd = this.cropEnd.bind(this)), r.responsive && Be(window, ka, this.onResize = this.resize.bind(this));
  },
  unbind: function() {
    var e = this.element, r = this.options, n = this.cropper;
    Fe(r.cropstart) && Ve(e, Gs, r.cropstart), Fe(r.cropmove) && Ve(e, Xs, r.cropmove), Fe(r.cropend) && Ve(e, Ys, r.cropend), Fe(r.crop) && Ve(e, Qs, r.crop), Fe(r.zoom) && Ve(e, Js, r.zoom), Ve(n, ja, this.onCropStart), r.zoomable && r.zoomOnWheel && Ve(n, Ia, this.onWheel, {
      passive: !1,
      capture: !0
    }), r.toggleDragModeOnDblclick && Ve(n, Na, this.onDblclick), Ve(e.ownerDocument, Fa, this.onCropMove), Ve(e.ownerDocument, Da, this.onCropEnd), r.responsive && Ve(window, ka, this.onResize);
  }
}, Xp = {
  resize: function() {
    if (!this.disabled) {
      var e = this.options, r = this.container, n = this.containerData, s = r.offsetWidth / n.width, i = r.offsetHeight / n.height, a = Math.abs(s - 1) > Math.abs(i - 1) ? s : i;
      if (a !== 1) {
        var o, l;
        e.restore && (o = this.getCanvasData(), l = this.getCropBoxData()), this.render(), e.restore && (this.setCanvasData(ve(o, function(u, c) {
          o[c] = u * a;
        })), this.setCropBoxData(ve(l, function(u, c) {
          l[c] = u * a;
        })));
      }
    }
  },
  dblclick: function() {
    this.disabled || this.options.dragMode === vl || this.setDragMode(Dp(this.dragBox, qs) ? bl : mi);
  },
  wheel: function(e) {
    var r = this, n = Number(this.options.wheelZoomRatio) || 0.1, s = 1;
    this.disabled || (e.preventDefault(), !this.wheeling && (this.wheeling = !0, setTimeout(function() {
      r.wheeling = !1;
    }, 50), e.deltaY ? s = e.deltaY > 0 ? 1 : -1 : e.wheelDelta ? s = -e.wheelDelta / 120 : e.detail && (s = e.detail > 0 ? 1 : -1), this.zoom(-s * n, e)));
  },
  cropStart: function(e) {
    var r = e.buttons, n = e.button;
    if (!(this.disabled || (e.type === "mousedown" || e.type === "pointerdown" && e.pointerType === "mouse") && // No primary button (Usually the left button)
    (X(r) && r !== 1 || X(n) && n !== 0 || e.ctrlKey))) {
      var s = this.options, i = this.pointers, a;
      e.changedTouches ? ve(e.changedTouches, function(o) {
        i[o.identifier] = wn(o);
      }) : i[e.pointerId || 0] = wn(e), Object.keys(i).length > 1 && s.zoomable && s.zoomOnTouch ? a = yl : a = Zs(e.target, qr), Ep.test(a) && ar(this.element, Gs, {
        originalEvent: e,
        action: a
      }) !== !1 && (e.preventDefault(), this.action = a, this.cropping = !1, a === ml && (this.cropping = !0, we(this.dragBox, Dn)));
    }
  },
  cropMove: function(e) {
    var r = this.action;
    if (!(this.disabled || !r)) {
      var n = this.pointers;
      e.preventDefault(), ar(this.element, Xs, {
        originalEvent: e,
        action: r
      }) !== !1 && (e.changedTouches ? ve(e.changedTouches, function(s) {
        he(n[s.identifier] || {}, wn(s, !0));
      }) : he(n[e.pointerId || 0] || {}, wn(e, !0)), this.change(e));
    }
  },
  cropEnd: function(e) {
    if (!this.disabled) {
      var r = this.action, n = this.pointers;
      e.changedTouches ? ve(e.changedTouches, function(s) {
        delete n[s.identifier];
      }) : delete n[e.pointerId || 0], r && (e.preventDefault(), Object.keys(n).length || (this.action = ""), this.cropping && (this.cropping = !1, er(this.dragBox, Dn, this.cropped && this.options.modal)), ar(this.element, Ys, {
        originalEvent: e,
        action: r
      }));
    }
  }
}, Gp = {
  change: function(e) {
    var r = this.options, n = this.canvasData, s = this.containerData, i = this.cropBoxData, a = this.pointers, o = this.action, l = r.aspectRatio, u = i.left, c = i.top, h = i.width, d = i.height, f = u + h, p = c + d, y = 0, m = 0, S = s.width, x = s.height, C = !0, P;
    !l && e.shiftKey && (l = h && d ? h / d : 1), this.limited && (y = i.minLeft, m = i.minTop, S = y + Math.min(s.width, n.width, n.left + n.width), x = m + Math.min(s.height, n.height, n.top + n.height));
    var j = a[Object.keys(a)[0]], w = {
      x: j.endX - j.startX,
      y: j.endY - j.startY
    }, _ = function(R) {
      switch (R) {
        case Pt:
          f + w.x > S && (w.x = S - f);
          break;
        case Tt:
          u + w.x < y && (w.x = y - u);
          break;
        case dt:
          c + w.y < m && (w.y = m - c);
          break;
        case Jt:
          p + w.y > x && (w.y = x - p);
          break;
      }
    };
    switch (o) {
      case pi:
        u += w.x, c += w.y;
        break;
      case Pt:
        if (w.x >= 0 && (f >= S || l && (c <= m || p >= x))) {
          C = !1;
          break;
        }
        _(Pt), h += w.x, h < 0 && (o = Tt, h = -h, u -= h), l && (d = h / l, c += (i.height - d) / 2);
        break;
      case dt:
        if (w.y <= 0 && (c <= m || l && (u <= y || f >= S))) {
          C = !1;
          break;
        }
        _(dt), d -= w.y, c += w.y, d < 0 && (o = Jt, d = -d, c -= d), l && (h = d * l, u += (i.width - h) / 2);
        break;
      case Tt:
        if (w.x <= 0 && (u <= y || l && (c <= m || p >= x))) {
          C = !1;
          break;
        }
        _(Tt), h -= w.x, u += w.x, h < 0 && (o = Pt, h = -h, u -= h), l && (d = h / l, c += (i.height - d) / 2);
        break;
      case Jt:
        if (w.y >= 0 && (p >= x || l && (u <= y || f >= S))) {
          C = !1;
          break;
        }
        _(Jt), d += w.y, d < 0 && (o = dt, d = -d, c -= d), l && (h = d * l, u += (i.width - h) / 2);
        break;
      case Ar:
        if (l) {
          if (w.y <= 0 && (c <= m || f >= S)) {
            C = !1;
            break;
          }
          _(dt), d -= w.y, c += w.y, h = d * l;
        } else
          _(dt), _(Pt), w.x >= 0 ? f < S ? h += w.x : w.y <= 0 && c <= m && (C = !1) : h += w.x, w.y <= 0 ? c > m && (d -= w.y, c += w.y) : (d -= w.y, c += w.y);
        h < 0 && d < 0 ? (o = Mr, d = -d, h = -h, c -= d, u -= h) : h < 0 ? (o = kr, h = -h, u -= h) : d < 0 && (o = Ir, d = -d, c -= d);
        break;
      case kr:
        if (l) {
          if (w.y <= 0 && (c <= m || u <= y)) {
            C = !1;
            break;
          }
          _(dt), d -= w.y, c += w.y, h = d * l, u += i.width - h;
        } else
          _(dt), _(Tt), w.x <= 0 ? u > y ? (h -= w.x, u += w.x) : w.y <= 0 && c <= m && (C = !1) : (h -= w.x, u += w.x), w.y <= 0 ? c > m && (d -= w.y, c += w.y) : (d -= w.y, c += w.y);
        h < 0 && d < 0 ? (o = Ir, d = -d, h = -h, c -= d, u -= h) : h < 0 ? (o = Ar, h = -h, u -= h) : d < 0 && (o = Mr, d = -d, c -= d);
        break;
      case Mr:
        if (l) {
          if (w.x <= 0 && (u <= y || p >= x)) {
            C = !1;
            break;
          }
          _(Tt), h -= w.x, u += w.x, d = h / l;
        } else
          _(Jt), _(Tt), w.x <= 0 ? u > y ? (h -= w.x, u += w.x) : w.y >= 0 && p >= x && (C = !1) : (h -= w.x, u += w.x), w.y >= 0 ? p < x && (d += w.y) : d += w.y;
        h < 0 && d < 0 ? (o = Ar, d = -d, h = -h, c -= d, u -= h) : h < 0 ? (o = Ir, h = -h, u -= h) : d < 0 && (o = kr, d = -d, c -= d);
        break;
      case Ir:
        if (l) {
          if (w.x >= 0 && (f >= S || p >= x)) {
            C = !1;
            break;
          }
          _(Pt), h += w.x, d = h / l;
        } else
          _(Jt), _(Pt), w.x >= 0 ? f < S ? h += w.x : w.y >= 0 && p >= x && (C = !1) : h += w.x, w.y >= 0 ? p < x && (d += w.y) : d += w.y;
        h < 0 && d < 0 ? (o = kr, d = -d, h = -h, c -= d, u -= h) : h < 0 ? (o = Mr, h = -h, u -= h) : d < 0 && (o = Ar, d = -d, c -= d);
        break;
      case gl:
        this.move(w.x, w.y), C = !1;
        break;
      case yl:
        this.zoom(Mp(a), e), C = !1;
        break;
      case ml:
        if (!w.x || !w.y) {
          C = !1;
          break;
        }
        P = Ol(this.cropper), u = j.startX - P.left, c = j.startY - P.top, h = i.minWidth, d = i.minHeight, w.x > 0 ? o = w.y > 0 ? Ir : Ar : w.x < 0 && (u -= h, o = w.y > 0 ? Mr : kr), w.y < 0 && (c -= d), this.cropped || (tt(this.cropBox, De), this.cropped = !0, this.limited && this.limitCropBox(!0, !0));
        break;
    }
    C && (i.width = h, i.height = d, i.left = u, i.top = c, this.action = o, this.renderCropBox()), ve(a, function(O) {
      O.startX = O.endX, O.startY = O.endY;
    });
  }
}, Jp = {
  // Show the crop box manually
  crop: function() {
    return this.ready && !this.cropped && !this.disabled && (this.cropped = !0, this.limitCropBox(!0, !0), this.options.modal && we(this.dragBox, Dn), tt(this.cropBox, De), this.setCropBoxData(this.initialCropBoxData)), this;
  },
  // Reset the image and crop box to their initial states
  reset: function() {
    return this.ready && !this.disabled && (this.imageData = he({}, this.initialImageData), this.canvasData = he({}, this.initialCanvasData), this.cropBoxData = he({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
  },
  // Clear the crop box
  clear: function() {
    return this.cropped && !this.disabled && (he(this.cropBoxData, {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), this.cropped = !1, this.renderCropBox(), this.limitCanvas(!0, !0), this.renderCanvas(), tt(this.dragBox, Dn), we(this.cropBox, De)), this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return !this.disabled && e && (this.isImg && (this.element.src = e), r ? (this.url = e, this.image.src = e, this.ready && (this.viewBoxImage.src = e, ve(this.previews, function(n) {
      n.getElementsByTagName("img")[0].src = e;
    }))) : (this.isImg && (this.replaced = !0), this.options.data = null, this.uncreate(), this.load(e))), this;
  },
  // Enable (unfreeze) the cropper
  enable: function() {
    return this.ready && this.disabled && (this.disabled = !1, tt(this.cropper, Pa)), this;
  },
  // Disable (freeze) the cropper
  disable: function() {
    return this.ready && !this.disabled && (this.disabled = !0, we(this.cropper, Pa)), this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function() {
    var e = this.element;
    return e[ue] ? (e[ue] = void 0, this.isImg && this.replaced && (e.src = this.originalUrl), this.uncreate(), this) : this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = this.canvasData, s = n.left, i = n.top;
    return this.moveTo(hs(e) ? e : s + Number(e), hs(r) ? r : i + Number(r));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = this.canvasData, s = !1;
    return e = Number(e), r = Number(r), this.ready && !this.disabled && this.options.movable && (X(e) && (n.left = e, s = !0), X(r) && (n.top = r, s = !0), s && this.renderCanvas(!0)), this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function(e, r) {
    var n = this.canvasData;
    return e = Number(e), e < 0 ? e = 1 / (1 - e) : e = 1 + e, this.zoomTo(n.width * e / n.naturalWidth, null, r);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function(e, r, n) {
    var s = this.options, i = this.canvasData, a = i.width, o = i.height, l = i.naturalWidth, u = i.naturalHeight;
    if (e = Number(e), e >= 0 && this.ready && !this.disabled && s.zoomable) {
      var c = l * e, h = u * e;
      if (ar(this.element, Js, {
        ratio: e,
        oldRatio: a / l,
        originalEvent: n
      }) === !1)
        return this;
      if (n) {
        var d = this.pointers, f = Ol(this.cropper), p = d && Object.keys(d).length ? Lp(d) : {
          pageX: n.pageX,
          pageY: n.pageY
        };
        i.left -= (c - a) * ((p.pageX - f.left - i.left) / a), i.top -= (h - o) * ((p.pageY - f.top - i.top) / o);
      } else
        Zt(r) && X(r.x) && X(r.y) ? (i.left -= (c - a) * ((r.x - i.left) / a), i.top -= (h - o) * ((r.y - i.top) / o)) : (i.left -= (c - a) / 2, i.top -= (h - o) / 2);
      i.width = c, i.height = h, this.renderCanvas(!0);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function(e) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(e));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function(e) {
    return e = Number(e), X(e) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = e % 360, this.renderCanvas(!0, !0)), this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function(e) {
    var r = this.imageData.scaleY;
    return this.scale(e, X(r) ? r : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function(e) {
    var r = this.imageData.scaleX;
    return this.scale(X(r) ? r : 1, e);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = this.imageData, s = !1;
    return e = Number(e), r = Number(r), this.ready && !this.disabled && this.options.scalable && (X(e) && (n.scaleX = e, s = !0), X(r) && (n.scaleY = r, s = !0), s && this.renderCanvas(!0, !0)), this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, r = this.options, n = this.imageData, s = this.canvasData, i = this.cropBoxData, a;
    if (this.ready && this.cropped) {
      a = {
        x: i.left - s.left,
        y: i.top - s.top,
        width: i.width,
        height: i.height
      };
      var o = n.width / n.naturalWidth;
      if (ve(a, function(c, h) {
        a[h] = c / o;
      }), e) {
        var l = Math.round(a.y + a.height), u = Math.round(a.x + a.width);
        a.x = Math.round(a.x), a.y = Math.round(a.y), a.width = u - a.x, a.height = l - a.y;
      }
    } else
      a = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    return r.rotatable && (a.rotate = n.rotate || 0), r.scalable && (a.scaleX = n.scaleX || 1, a.scaleY = n.scaleY || 1), a;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function(e) {
    var r = this.options, n = this.imageData, s = this.canvasData, i = {};
    if (this.ready && !this.disabled && Zt(e)) {
      var a = !1;
      r.rotatable && X(e.rotate) && e.rotate !== n.rotate && (n.rotate = e.rotate, a = !0), r.scalable && (X(e.scaleX) && e.scaleX !== n.scaleX && (n.scaleX = e.scaleX, a = !0), X(e.scaleY) && e.scaleY !== n.scaleY && (n.scaleY = e.scaleY, a = !0)), a && this.renderCanvas(!0, !0);
      var o = n.width / n.naturalWidth;
      X(e.x) && (i.left = e.x * o + s.left), X(e.y) && (i.top = e.y * o + s.top), X(e.width) && (i.width = e.width * o), X(e.height) && (i.height = e.height * o), this.setCropBoxData(i);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function() {
    return this.ready ? he({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function() {
    return this.sized ? he({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function() {
    var e = this.canvasData, r = {};
    return this.ready && ve(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(n) {
      r[n] = e[n];
    }), r;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function(e) {
    var r = this.canvasData, n = r.aspectRatio;
    return this.ready && !this.disabled && Zt(e) && (X(e.left) && (r.left = e.left), X(e.top) && (r.top = e.top), X(e.width) ? (r.width = e.width, r.height = e.width / n) : X(e.height) && (r.height = e.height, r.width = e.height * n), this.renderCanvas(!0)), this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function() {
    var e = this.cropBoxData, r;
    return this.ready && this.cropped && (r = {
      left: e.left,
      top: e.top,
      width: e.width,
      height: e.height
    }), r || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function(e) {
    var r = this.cropBoxData, n = this.options.aspectRatio, s, i;
    return this.ready && this.cropped && !this.disabled && Zt(e) && (X(e.left) && (r.left = e.left), X(e.top) && (r.top = e.top), X(e.width) && e.width !== r.width && (s = !0, r.width = e.width), X(e.height) && e.height !== r.height && (i = !0, r.height = e.height), n && (s ? r.height = r.width / n : i && (r.width = r.height * n)), this.renderCropBox()), this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement)
      return null;
    var r = this.canvasData, n = Up(this.image, this.imageData, r, e);
    if (!this.cropped)
      return n;
    var s = this.getData(e.rounded), i = s.x, a = s.y, o = s.width, l = s.height, u = n.width / Math.floor(r.naturalWidth);
    u !== 1 && (i *= u, a *= u, o *= u, l *= u);
    var c = o / l, h = Et({
      aspectRatio: c,
      width: e.maxWidth || 1 / 0,
      height: e.maxHeight || 1 / 0
    }), d = Et({
      aspectRatio: c,
      width: e.minWidth || 0,
      height: e.minHeight || 0
    }, "cover"), f = Et({
      aspectRatio: c,
      width: e.width || (u !== 1 ? n.width : o),
      height: e.height || (u !== 1 ? n.height : l)
    }), p = f.width, y = f.height;
    p = Math.min(h.width, Math.max(d.width, p)), y = Math.min(h.height, Math.max(d.height, y));
    var m = document.createElement("canvas"), S = m.getContext("2d");
    m.width = ir(p), m.height = ir(y), S.fillStyle = e.fillColor || "transparent", S.fillRect(0, 0, p, y);
    var x = e.imageSmoothingEnabled, C = x === void 0 ? !0 : x, P = e.imageSmoothingQuality;
    S.imageSmoothingEnabled = C, P && (S.imageSmoothingQuality = P);
    var j = n.width, w = n.height, _ = i, O = a, R, N, k, F, U, z;
    _ <= -o || _ > j ? (_ = 0, R = 0, k = 0, U = 0) : _ <= 0 ? (k = -_, _ = 0, R = Math.min(j, o + _), U = R) : _ <= j && (k = 0, R = Math.min(o, j - _), U = R), R <= 0 || O <= -l || O > w ? (O = 0, N = 0, F = 0, z = 0) : O <= 0 ? (F = -O, O = 0, N = Math.min(w, l + O), z = N) : O <= w && (F = 0, N = Math.min(l, w - O), z = N);
    var M = [_, O, R, N];
    if (U > 0 && z > 0) {
      var re = p / o;
      M.push(k * re, F * re, U * re, z * re);
    }
    return S.drawImage.apply(S, [n].concat(pl(M.map(function(ce) {
      return Math.floor(ir(ce));
    })))), m;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function(e) {
    var r = this.options;
    return !this.disabled && !hs(e) && (r.aspectRatio = Math.max(0, e) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function(e) {
    var r = this.options, n = this.dragBox, s = this.face;
    if (this.ready && !this.disabled) {
      var i = e === mi, a = r.movable && e === bl;
      e = i || a ? e : vl, r.dragMode = e, Kr(n, qr, e), er(n, qs, i), er(n, Ks, a), r.cropBoxMovable || (Kr(s, qr, e), er(s, qs, i), er(s, Ks, a));
    }
    return this;
  }
}, Zp = rt.Cropper, _l = /* @__PURE__ */ function() {
  function t(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (dp(this, t), !e || !Rp.test(e.tagName))
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    this.element = e, this.options = he({}, La, Zt(r) && r), this.cropped = !1, this.disabled = !1, this.pointers = {}, this.ready = !1, this.reloading = !1, this.replaced = !1, this.sized = !1, this.sizing = !1, this.init();
  }
  return fp(t, [{
    key: "init",
    value: function() {
      var r = this.element, n = r.tagName.toLowerCase(), s;
      if (!r[ue]) {
        if (r[ue] = this, n === "img") {
          if (this.isImg = !0, s = r.getAttribute("src") || "", this.originalUrl = s, !s)
            return;
          s = r.src;
        } else
          n === "canvas" && window.HTMLCanvasElement && (s = r.toDataURL());
        this.load(s);
      }
    }
  }, {
    key: "load",
    value: function(r) {
      var n = this;
      if (r) {
        this.url = r, this.imageData = {};
        var s = this.element, i = this.options;
        if (!i.rotatable && !i.scalable && (i.checkOrientation = !1), !i.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }
        if (Cp.test(r)) {
          Op.test(r) ? this.read(Hp(r)) : this.clone();
          return;
        }
        var a = new XMLHttpRequest(), o = this.clone.bind(this);
        this.reloading = !0, this.xhr = a, a.onabort = o, a.onerror = o, a.ontimeout = o, a.onprogress = function() {
          a.getResponseHeader("content-type") !== Ma && a.abort();
        }, a.onload = function() {
          n.read(a.response);
        }, a.onloadend = function() {
          n.reloading = !1, n.xhr = null;
        }, i.checkCrossOrigin && Ua(r) && s.crossOrigin && (r = Ba(r)), a.open("GET", r, !0), a.responseType = "arraybuffer", a.withCredentials = s.crossOrigin === "use-credentials", a.send();
      }
    }
  }, {
    key: "read",
    value: function(r) {
      var n = this.options, s = this.imageData, i = Vp(r), a = 0, o = 1, l = 1;
      if (i > 1) {
        this.url = Wp(r, Ma);
        var u = qp(i);
        a = u.rotate, o = u.scaleX, l = u.scaleY;
      }
      n.rotatable && (s.rotate = a), n.scalable && (s.scaleX = o, s.scaleY = l), this.clone();
    }
  }, {
    key: "clone",
    value: function() {
      var r = this.element, n = this.url, s = r.crossOrigin, i = n;
      this.options.checkCrossOrigin && Ua(n) && (s || (s = "anonymous"), i = Ba(n)), this.crossOrigin = s, this.crossOriginUrl = i;
      var a = document.createElement("img");
      s && (a.crossOrigin = s), a.src = i || n, a.alt = r.alt || "The image to crop", this.image = a, a.onload = this.start.bind(this), a.onerror = this.stop.bind(this), we(a, Ta), r.parentNode.insertBefore(a, r.nextSibling);
    }
  }, {
    key: "start",
    value: function() {
      var r = this, n = this.image;
      n.onload = null, n.onerror = null, this.sizing = !0;
      var s = rt.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(rt.navigator.userAgent), i = function(u, c) {
        he(r.imageData, {
          naturalWidth: u,
          naturalHeight: c,
          aspectRatio: u / c
        }), r.initialImageData = he({}, r.imageData), r.sizing = !1, r.sized = !0, r.build();
      };
      if (n.naturalWidth && !s) {
        i(n.naturalWidth, n.naturalHeight);
        return;
      }
      var a = document.createElement("img"), o = document.body || document.documentElement;
      this.sizingImage = a, a.onload = function() {
        i(a.width, a.height), s || o.removeChild(a);
      }, a.src = n.src, s || (a.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", o.appendChild(a));
    }
  }, {
    key: "stop",
    value: function() {
      var r = this.image;
      r.onload = null, r.onerror = null, r.parentNode.removeChild(r), this.image = null;
    }
  }, {
    key: "build",
    value: function() {
      if (!(!this.sized || this.ready)) {
        var r = this.element, n = this.options, s = this.image, i = r.parentNode, a = document.createElement("div");
        a.innerHTML = _p;
        var o = a.querySelector(".".concat(ue, "-container")), l = o.querySelector(".".concat(ue, "-canvas")), u = o.querySelector(".".concat(ue, "-drag-box")), c = o.querySelector(".".concat(ue, "-crop-box")), h = c.querySelector(".".concat(ue, "-face"));
        this.container = i, this.cropper = o, this.canvas = l, this.dragBox = u, this.cropBox = c, this.viewBox = o.querySelector(".".concat(ue, "-view-box")), this.face = h, l.appendChild(s), we(r, De), i.insertBefore(o, r.nextSibling), tt(s, Ta), this.initPreview(), this.bind(), n.initialAspectRatio = Math.max(0, n.initialAspectRatio) || NaN, n.aspectRatio = Math.max(0, n.aspectRatio) || NaN, n.viewMode = Math.max(0, Math.min(3, Math.round(n.viewMode))) || 0, we(c, De), n.guides || we(c.getElementsByClassName("".concat(ue, "-dashed")), De), n.center || we(c.getElementsByClassName("".concat(ue, "-center")), De), n.background && we(o, "".concat(ue, "-bg")), n.highlight || we(h, vp), n.cropBoxMovable && (we(h, Ks), Kr(h, qr, pi)), n.cropBoxResizable || (we(c.getElementsByClassName("".concat(ue, "-line")), De), we(c.getElementsByClassName("".concat(ue, "-point")), De)), this.render(), this.ready = !0, this.setDragMode(n.dragMode), n.autoCrop && this.crop(), this.setData(n.data), Fe(n.ready) && Be(r, Aa, n.ready, {
          once: !0
        }), ar(r, Aa);
      }
    }
  }, {
    key: "unbuild",
    value: function() {
      if (this.ready) {
        this.ready = !1, this.unbind(), this.resetPreview();
        var r = this.cropper.parentNode;
        r && r.removeChild(this.cropper), tt(this.element, De);
      }
    }
  }, {
    key: "uncreate",
    value: function() {
      this.ready ? (this.unbuild(), this.ready = !1, this.cropped = !1) : this.sizing ? (this.sizingImage.onload = null, this.sizing = !1, this.sized = !1) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
    }
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Cropper = Zp, t;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(r) {
      he(La, Zt(r) && r);
    }
  }]);
}();
he(_l.prototype, Kp, Qp, Yp, Xp, Gp, Jp);
var Nt = function() {
  return Nt = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++)
      for (var s in e = arguments[r])
        Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
    return t;
  }, Nt.apply(this, arguments);
};
function fs(t, e) {
  var r = {};
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function") {
    var s = 0;
    for (n = Object.getOwnPropertySymbols(t); s < n.length; s++)
      e.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[s]) && (r[n[s]] = t[n[s]]);
  }
  return r;
}
var em = ["aspectRatio", "autoCrop", "autoCropArea", "background", "center", "checkCrossOrigin", "checkOrientation", "cropBoxMovable", "cropBoxResizable", "data", "dragMode", "guides", "highlight", "initialAspectRatio", "minCanvasHeight", "minCanvasWidth", "minContainerHeight", "minContainerWidth", "minCropBoxHeight", "minCropBoxWidth", "modal", "movable", "preview", "responsive", "restore", "rotatable", "scalable", "toggleDragModeOnDblclick", "viewMode", "wheelZoomRatio", "zoomOnTouch", "zoomOnWheel", "zoomable", "cropstart", "cropmove", "cropend", "crop", "zoom", "ready"], tm = { opacity: 0, maxWidth: "100%" }, rm = Ae.forwardRef(function(t, e) {
  var r = fs(t, []), n = r.dragMode, s = n === void 0 ? "crop" : n, i = r.src, a = r.style, o = r.className, l = r.crossOrigin, u = r.scaleX, c = r.scaleY, h = r.enable, d = r.zoomTo, f = r.rotateTo, p = r.alt, y = p === void 0 ? "picture" : p, m = r.ready, S = r.onInitialized, x = fs(r, ["dragMode", "src", "style", "className", "crossOrigin", "scaleX", "scaleY", "enable", "zoomTo", "rotateTo", "alt", "ready", "onInitialized"]), C = { scaleY: c, scaleX: u, enable: h, zoomTo: d, rotateTo: f }, P = function() {
    for (var w = [], _ = 0; _ < arguments.length; _++)
      w[_] = arguments[_];
    var O = Le(null);
    return Ae.useEffect(function() {
      w.forEach(function(R) {
        R && (typeof R == "function" ? R(O.current) : R.current = O.current);
      });
    }, [w]), O;
  }(e, Le(null));
  We(function() {
    var w;
    !((w = P.current) === null || w === void 0) && w.cropper && typeof d == "number" && P.current.cropper.zoomTo(d);
  }, [r.zoomTo]), We(function() {
    var w;
    !((w = P.current) === null || w === void 0) && w.cropper && i !== void 0 && P.current.cropper.reset().clear().replace(i);
  }, [i]), We(function() {
    if (P.current !== null) {
      var w = new _l(P.current, Nt(Nt({ dragMode: s }, x), { ready: function(_) {
        _.currentTarget !== null && function(O, R) {
          R === void 0 && (R = {});
          var N = R.enable, k = N === void 0 || N, F = R.scaleX, U = F === void 0 ? 1 : F, z = R.scaleY, M = z === void 0 ? 1 : z, re = R.zoomTo, ce = re === void 0 ? 0 : re, $ = R.rotateTo;
          k ? O.enable() : O.disable(), O.scaleX(U), O.scaleY(M), $ !== void 0 && O.rotateTo($), ce > 0 && O.zoomTo(ce);
        }(_.currentTarget.cropper, C), m && m(_);
      } }));
      S && S(w);
    }
    return function() {
      var _, O;
      (O = (_ = P.current) === null || _ === void 0 ? void 0 : _.cropper) === null || O === void 0 || O.destroy();
    };
  }, [P]);
  var j = function(w) {
    return em.reduce(function(_, O) {
      var R = _, N = O;
      return R[N], fs(R, [typeof N == "symbol" ? N : N + ""]);
    }, w);
  }(Nt(Nt({}, x), { crossOrigin: l, src: i, alt: y }));
  return Ae.createElement("div", { style: a, className: o }, Ae.createElement("img", Nt({}, j, { style: tm, ref: P })));
});
const Pl = Gl(
  ({ imageCropperRef: t, isRounded: e, imageFile: r, imageCropperProps: n }) => {
    const {
      viewMode: s = 1,
      autoCropArea: i = 1,
      aspectRatio: a = 1,
      checkOrientation: o = !1,
      // NOTE: it fixes this issue https://github.com/fengyuanchen/cropperjs/issues/671
      background: l = !0,
      dragMode: u = "move",
      toggleDragModeOnDblclick: c = !1,
      style: h = { height: 400, width: "100%" },
      ...d
    } = n || {}, f = Le(null), p = Le(null), y = Le(null), m = Le(null), S = () => {
      p.current && (p.current.style.opacity = ""), y.current && (y.current.style.display = "block"), m.current && (m.current.style.zIndex = "", m.current.innerText = "");
    }, x = () => {
      y.current && m.current && (m.current.appendChild(y.current.cloneNode(!0)), m.current.style.zIndex = "1000", y.current.style.display = "none"), p.current && (p.current.style.opacity = "0");
    }, C = (P) => new Promise((j, w) => {
      var _;
      try {
        const O = (_ = f.current) == null ? void 0 : _.cropper;
        if (!O)
          throw new Error();
        if (e) {
          const R = O == null ? void 0 : O.getCroppedCanvas();
          if (!R)
            throw new Error();
          const N = Math.min(R.width, R.height), k = document.createElement("canvas");
          k.width = N, k.height = N;
          const F = k.getContext("2d");
          if (!F)
            throw new Error();
          F.beginPath(), F.arc(N / 2, N / 2, N / 2, 0, Math.PI * 2), F.closePath(), F.clip(), F.drawImage(R, 0, 0, N, N), k.toBlob((U) => {
            if (!r || !U)
              return w(new Error());
            const z = Gi(
              ea(r, U),
              a
            );
            j(z);
          });
        } else
          O.getCroppedCanvas(P).toBlob((R) => {
            if (!r || !R)
              return w(new Error());
            const N = Gi(
              ea(r, R),
              a
            );
            j(N);
          });
      } catch (O) {
        w(O);
      }
    });
    return t && (t.current = {
      hidePreview: S,
      showPreview: x,
      getCroppedFile: C
    }), /* @__PURE__ */ v.jsx("div", { children: /* @__PURE__ */ v.jsxs("div", { className: "relative w-full overflow-hidden", children: [
      /* @__PURE__ */ v.jsx(
        "div",
        {
          ref: m,
          className: "absolute inset-0 flex items-center justify-center"
        }
      ),
      /* @__PURE__ */ v.jsx(
        "div",
        {
          ref: y,
          style: {
            position: "absolute",
            overflow: "hidden",
            width: h.width,
            height: h.height,
            borderRadius: e ? "50%" : 0
          }
        }
      ),
      /* @__PURE__ */ v.jsx("div", { ref: p, children: /* @__PURE__ */ v.jsx(
        rm,
        {
          className: e ? "sio-cropper-rounded" : "",
          ref: f,
          src: r && URL.createObjectURL(r),
          preview: y || void 0,
          style: h,
          viewMode: s,
          background: l,
          autoCropArea: i,
          aspectRatio: a,
          checkOrientation: o,
          dragMode: u,
          toggleDragModeOnDblclick: c,
          ...d
        }
      ) })
    ] }) });
  }
);
Pl.displayName = "ImageCropper";
function Tl({
  imageFile: t,
  opened: e,
  actionButtonLabel: r,
  isFetching: n,
  onClose: s,
  onCrop: i,
  ...a
}) {
  const { t: o } = Pe(), l = Le(), [u, c] = te(!1), h = (f) => {
    var p, y;
    c(f), f ? (p = l.current) == null || p.showPreview() : (y = l.current) == null || y.hidePreview();
  }, d = async () => {
    var f;
    try {
      const p = await ((f = l.current) == null ? void 0 : f.getCroppedFile());
      if (!p)
        throw new Error();
      i(p);
    } catch {
      Me.error(o("file_manager.error"));
    }
  };
  return /* @__PURE__ */ v.jsxs(
    kn,
    {
      title: o("file_manager.file_upload.crop_file"),
      opened: e,
      onClose: s,
      afterLeave: () => c(!1),
      isFetching: n,
      isCentered: !0,
      children: [
        /* @__PURE__ */ v.jsx(Pl, { imageCropperRef: l, imageFile: t, ...a }),
        /* @__PURE__ */ v.jsxs("div", { className: "flex justify-between items-center mt-10", children: [
          /* @__PURE__ */ v.jsx(
            lc,
            {
              label: o("file_manager.preview"),
              selected: u,
              onChange: h
            }
          ),
          /* @__PURE__ */ v.jsx(an, { onClick: d, isFetching: n, children: r ?? o("file_manager.file_upload.crop_file") })
        ] })
      ]
    }
  );
}
const nm = ({
  uploaderRef: t,
  opened: e,
  source: r,
  imageCropperModalProps: n,
  showCroppingNote: s,
  acceptTypes: i,
  usePublicApi: a,
  actionLabel: o,
  singleFileMode: l,
  openCroppingModalOnAdding: u,
  requireCropping: c,
  onClose: h,
  onUploadFinish: d
}) => {
  const { t: f } = Pe(), [p, y] = te(!1), [m, S] = te(), {
    waitingUploadFiles: x,
    setWaitingUploadFiles: C,
    removingFiles: P,
    mappedUploadedFiles: j,
    mappedUploadingFiles: w,
    startUploading: _,
    setUploadedFiles: O,
    deleteFile: R
  } = ip({
    usePublicApi: a,
    source: r
  }), N = async (A) => {
    var ot;
    const Q = (ot = n == null ? void 0 : n.imageCropperProps) == null ? void 0 : ot.aspectRatio;
    if (!ws(A) || !Q || isNaN(Q))
      return !0;
    const Z = URL.createObjectURL(A), [Te, nt] = await go(Z);
    return !!yo(nt, Q);
  };
  Ji(x, async (A, Q) => {
    if (!u)
      return;
    const { added: Z } = A ? Zi(A, Q) : { added: Q };
    for (const { file: Te } of Z)
      if (!await N(Te)) {
        K(Te);
        break;
      }
  }), Ji(x, async (A, Q) => {
    if (!s)
      return;
    const { added: Z } = A ? Zi(A, Q) : { added: Q };
    for (const { file: Te } of Z)
      if (!await N(Te)) {
        Me(f("file_manager.image_cropper.aspect_ratio.need_to_crop_note"));
        break;
      }
  });
  const k = async (A) => {
    C(l ? [{ file: A }] : (Q) => [{ file: A }, ...Q]);
  }, F = async (A) => {
    try {
      ap(A) && C((Q) => Q == null ? void 0 : Q.filter((Z) => Z.file !== A)), op(A) && (await R(A.id), C((Q) => Q == null ? void 0 : Q.filter((Z) => Z.file !== A.file))), lp(A) && await R(A.id);
    } catch {
      Me.error(f("file_manager.error"));
    }
  }, U = async () => {
    try {
      if (S(void 0), y(!0), c) {
        for await (const { file: Z } of x)
          if (!await N(Z))
            throw new Error(f("file_manager.image_cropper.aspect_ratio.need_to_crop_note"));
      }
      const A = [], Q = await Promise.allSettled(
        x.map(
          ({ file: Z }) => _(Z).catch(() => {
            A.push(f("file_manager.error") + ": " + Z.name);
          })
        )
      );
      if (A.length)
        throw new Error(A.join(", "));
      await d(
        Q.map((Z) => {
          if (Z.status === "fulfilled")
            return Z.value;
        })
      ), Me.success(f("file_manager.file_upload.uploaded_successfully"));
    } catch (A) {
      const Q = A instanceof Error ? A : new Error(f("file_manager.error"));
      S(Q);
    } finally {
      y(!1);
    }
  }, z = !![...x, ...w, ...j].length, [M, re] = te(!1), [ce, $] = te(), K = (A) => {
    re(!0), $(A);
  }, ne = () => {
    re(!1), $(void 0);
  }, W = (A) => {
    C(
      (Q) => Q.map((Z) => Z.file === ce ? { file: A } : Z)
    ), ne();
  };
  return t && (t.current = {
    setWaitingUploadFiles: C
  }), /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      kn,
      {
        title: f("file_manager.file_upload.upload_files"),
        isCentered: !0,
        isFetching: p,
        opened: e,
        onClose: h,
        afterLeave: () => {
          O([]), C([]);
        },
        children: /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ v.jsxs(
            hl,
            {
              acceptTypes: i,
              onSelectFile: k,
              dropZoneClassName: ge("min-h-[400px]", !z && "items-center"),
              label: f("file_manager.file_upload.drop_files_here"),
              disabled: p,
              children: [
                x.map((A, Q) => /* @__PURE__ */ v.jsx("div", { title: A.file.name, children: /* @__PURE__ */ v.jsx(
                  us,
                  {
                    file: A.file,
                    isError: !!A.error,
                    onDeleteFile: () => F(A.file),
                    showDeleteButton: !0,
                    showEditButton: ws(A.file),
                    onEdit: () => K(A.file)
                  }
                ) }, Q + A.file.name)),
                w.map((A) => /* @__PURE__ */ v.jsx("div", { title: A.file.name, children: /* @__PURE__ */ v.jsx(
                  us,
                  {
                    file: A.file.file,
                    progress: A.progress,
                    isLoading: !0,
                    onDeleteFile: () => F(A.file)
                  }
                ) }, A.file.id)),
                j.map((A) => /* @__PURE__ */ v.jsx("div", { title: A.file.name, children: /* @__PURE__ */ v.jsx(
                  us,
                  {
                    file: A.file,
                    progress: A.progress,
                    isLoaded: !0,
                    isDeleting: P.includes(A.file.id),
                    onDeleteFile: () => F(A.file)
                  }
                ) }, A.file.id))
              ]
            }
          ),
          /* @__PURE__ */ v.jsx("div", { children: /* @__PURE__ */ v.jsx(
            En,
            {
              error: m == null ? void 0 : m.message,
              className: "text-center"
            }
          ) }),
          /* @__PURE__ */ v.jsxs("div", { className: "flex justify-end gap-3", children: [
            /* @__PURE__ */ v.jsx(Ja, { disabled: p, onClick: () => h(), children: f("file_manager.cancel") }),
            /* @__PURE__ */ v.jsx(
              an,
              {
                isFetching: p,
                onClick: U,
                disabled: !z,
                children: o ?? f("file_manager.upload")
              }
            )
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ v.jsx(
      Tl,
      {
        imageFile: ce,
        opened: M,
        onClose: ne,
        onCrop: W,
        ...n
      }
    )
  ] });
};
function sm({
  uploadingFromSource: t,
  requiredCropping: e = !0,
  fileUploaderModalProps: r,
  initialSearchFilters: n,
  disabledFileTypeSelect: s,
  disabledFileSourceSelect: i,
  fileSelectorRef: a,
  onSelect: o
}) {
  var Rt, fn;
  e = !!(e && ((fn = (Rt = r == null ? void 0 : r.imageCropperModalProps) == null ? void 0 : Rt.imageCropperProps) != null && fn.aspectRatio));
  const { t: l } = Pe(), { width: u } = cc(), [c, h] = te(
    n ?? {
      name: "",
      source: [],
      type: []
    }
  ), [d, f] = te(c), [p, y] = te(), [m, S] = te(), [x, C] = te(), [P, j] = te(""), [w, _] = te(), O = td({
    filter: d,
    sortColumn: "createdAt",
    sortDirection: Za.Desc
  }), { resetAndRefetch: R, deleteItemFromData: N, renameItemFromData: k } = O, { deleteFile: F, downloadFile: U, renameFile: z } = nd(), { data: M, isFetching: re } = rd({
    id: p == null ? void 0 : p.id
  }), ce = async () => {
    m && (await F(m), N(m.id), Me.success(l("file_manager.file_deleted_successfully")), S(void 0));
  }, $ = async (de) => {
    try {
      await U(de);
    } catch {
    }
  }, [K, ne] = te(), W = async () => {
    var de;
    if (x)
      try {
        ne(void 0), await z({ id: x.id, name: P }), k({ id: x.id, name: P }), Me.success(l("file_manager.file_renamed_successfully")), C(void 0);
      } catch (Ce) {
        if (Ce instanceof yc)
          ne((de = Ce.errors.fields.name) == null ? void 0 : de.join(" "));
        else
          throw Ce;
      }
  }, A = Le(), [Q, Z] = te(!1), Te = (de) => {
    var Ce;
    (Ce = A.current) == null || Ce.setWaitingUploadFiles((st) => [...st, { file: de }]), Z(!0);
  };
  We(() => {
    r != null && r.uploaderRef && (r.uploaderRef.current = A.current);
  }, [A.current]), a && (a.current = {
    setFileUploadModalOpen: Z
  });
  const { createFileUploader: nt } = cl(), [ot, Ct] = te(!1), [Er, Ot] = te(!1), [qn, Cr] = te(!1), [Kn, un] = te(), Vt = (de) => {
    Ct(!0), un(de);
  }, lt = () => {
    Ct(!1), un(void 0);
  }, hn = async (de) => {
    try {
      Ot(!0);
      const st = await nt(() => {
      }).upload({
        file: de,
        source: t
      });
      if (!st)
        throw new Error();
      const qt = uh(st, t);
      o(qt), R(), lt();
    } catch {
      Me.error(l("file_manager.error"));
    } finally {
      Ot(!1);
    }
  }, dn = async () => {
    var Ce, st;
    if (!w)
      return;
    const de = (st = (Ce = r == null ? void 0 : r.imageCropperModalProps) == null ? void 0 : Ce.imageCropperProps) == null ? void 0 : st.aspectRatio;
    if (!e || !ws(w) || !de || isNaN(de)) {
      o(w);
      return;
    }
    try {
      Cr(!0);
      const [qt, pn] = await go(w.path);
      if (yo(pn, de)) {
        o(w);
        return;
      }
      Me(ch(de));
      const mn = await hh(qt, w.name, w.type);
      Vt(mn);
    } catch {
      Me.error(l("file_manager.error"));
    } finally {
      Cr(!1);
    }
  };
  return /* @__PURE__ */ v.jsxs("div", { className: "flex gap-5", children: [
    /* @__PURE__ */ v.jsx(
      "div",
      {
        className: ge(
          p ? "w-1/2" : "w-full",
          u < 1024 && p ? "hidden" : "auto"
        ),
        children: /* @__PURE__ */ v.jsxs("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ v.jsx(
            sd,
            {
              isFetching: O.isFetching,
              values: c,
              disabledFileSourceSelect: i,
              disabledFileTypeSelect: s,
              onChange: h,
              onSubmit: () => {
                f(c);
              }
            }
          ),
          /* @__PURE__ */ v.jsx(
            wd,
            {
              dataFilesApi: O,
              onDetails: y,
              onSelect: _,
              onDelete: S,
              onDownload: $,
              onRename: (de) => {
                C(de), j(de.name);
              },
              specialElementInGrid: /* @__PURE__ */ v.jsx(
                hl,
                {
                  className: "h-full w-full",
                  dropZoneClassName: "w-full h-full items-center",
                  labelClassName: "text-text-primary",
                  onSelectFile: Te
                }
              )
            }
          ),
          /* @__PURE__ */ v.jsxs("div", { className: "sticky bottom-4 flex items-center justify-between sm:relative sm:bottom-0", children: [
            /* @__PURE__ */ v.jsxs("div", { className: "text-text-tertiary text-sm", children: [
              +!!w,
              " ",
              l("file_manager.file_selector.files_selected")
            ] }),
            /* @__PURE__ */ v.jsx(
              an,
              {
                className: "min-w-14",
                disabled: w === void 0,
                isFetching: qn,
                onClick: () => dn(),
                children: l("file_manager.select")
              }
            )
          ] })
        ] })
      }
    ),
    p && /* @__PURE__ */ v.jsx(
      ph,
      {
        className: ge(u < 1024 ? "w-full" : "max-w-[calc(50%-20px)]"),
        fileType: M == null ? void 0 : M.type,
        src: (M == null ? void 0 : M.path) ?? (M == null ? void 0 : M.thumbnail) ?? void 0,
        alt: M == null ? void 0 : M.name,
        name: M == null ? void 0 : M.name,
        size: M == null ? void 0 : M.size,
        onClose: () => y(void 0),
        isFetching: re
      }
    ),
    /* @__PURE__ */ v.jsx(
      ra,
      {
        opened: !!m,
        onClose: () => S(void 0),
        confirmationText: l("file_manager.file_selector.file_deletion_confirmation_text", {
          file: m == null ? void 0 : m.name
        }),
        onConfirm: () => ce()
      }
    ),
    /* @__PURE__ */ v.jsx(
      ra,
      {
        opened: !!x,
        onClose: () => {
          C(void 0), ne(void 0);
        },
        title: l("file_manager.file_selector.rename_file"),
        confirmButtonCaption: l("file_manager.rename"),
        confirmationContent: /* @__PURE__ */ v.jsx(
          uc,
          {
            label: l("file_manager.file_selector.file_name"),
            placeholder: l("file_manager.file_selector.enter_new_file_name"),
            value: P,
            onChange: (de) => j(de.target.value),
            error: K
          }
        ),
        onConfirm: () => W()
      }
    ),
    /* @__PURE__ */ v.jsx(
      nm,
      {
        ...r,
        uploaderRef: A,
        opened: Q,
        source: t,
        showCroppingNote: e,
        onClose: () => Z(!1),
        onUploadFinish: () => {
          R(), Z(!1);
        }
      }
    ),
    /* @__PURE__ */ v.jsx(
      Tl,
      {
        isFetching: Er,
        imageFile: Kn,
        opened: ot,
        onClose: lt,
        onCrop: hn,
        actionButtonLabel: l("file_manager.file_upload.crop_and_select_file"),
        ...r == null ? void 0 : r.imageCropperModalProps
      }
    )
  ] });
}
function mm({
  title: t,
  opened: e,
  onClose: r,
  onSelect: n,
  ...s
}) {
  const { t: i } = Pe();
  return /* @__PURE__ */ v.jsx(
    kn,
    {
      title: t ?? i("file_manager.file_selector.choose_file"),
      opened: e,
      isCentered: !0,
      size: hc.big,
      onClose: r,
      children: /* @__PURE__ */ v.jsx(sm, { onSelect: n, ...s })
    }
  );
}
export {
  Cc as AudioFileIcon,
  ra as ConfirmationModal,
  ji as DocumentFileIcon,
  gh as FileActionMenuDeleteItem,
  mh as FileActionMenuDetailsItem,
  bh as FileActionMenuDownloadItem,
  yh as FileActionMenuRenameItem,
  ph as FileDetails,
  ul as FileDropZoneVariantEnum,
  ft as FileExtensionEnum,
  wd as FileGrid,
  iu as FileItem,
  Ut as FilePreview,
  vo as FilePreviewFromOS,
  sd as FileSearch,
  sm as FileSelector,
  mm as FileSelectorModal,
  oe as FileSourceEnum,
  Sc as FileSourceEnumLocoKeys,
  ie as FileTypeEnum,
  Ec as FileTypeEnumLocoKeys,
  hl as FileUploaderDropZone,
  us as FileUploaderItem,
  nm as FileUploaderModal,
  Pl as ImageCropper,
  Tl as ImageCropperModal,
  Oc as ImageFileIcon,
  ed as LocaleContext,
  fm as LocaleProvider,
  ei as PaginationOrderEnum,
  dm as QueryClientProvider,
  Za as SortDirectionEnum,
  Rc as VideoFileIcon,
  Gi as appendAspectRatioToFileName,
  yo as areAspectRatiosEqual,
  uh as convertFileInfoToDataFile,
  rp as createCanceler,
  np as createProgress,
  um as fileInputAcceptTypes,
  fh as formatAcceptTypeForInput,
  oh as formatBytes,
  Zi as getArrayDifference,
  bo as getAspectRatioLabel,
  ch as getAspectRatioNote,
  hm as getFileTypeFromName,
  go as getImageAspectRatio,
  sp as getMimeType,
  _c as getThumbnailByType,
  dh as hashFile,
  ni as httpClient,
  ye as i18n,
  hh as imageToFile,
  ta as isAcceptTypeValid,
  xc as isDataFileInterface,
  lp as isFileInfoInterface,
  ws as isImageFile,
  ap as isOsFile,
  op as isOsFileWithId,
  ah as loadLangBundle,
  ri as namespace,
  ea as replaceImageFileBlob,
  mo as t,
  pm as useDataFiles,
  nr as useFetch,
  nd as useFileActions,
  rd as useFileDetails,
  cl as useFileUploader,
  tp as useFileUploaderActions,
  ip as useFileUploaderManager,
  td as useInfiniteDataFiles,
  Ji as useStateWatcher,
  Pe as useTranslation,
  up as variantClassName
};
